"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f107 = void 0;
exports.f107 = {
    "kotoko": [
        19,
        4992
    ],
    "kambon": [
        28,
        1238
    ],
    "kwem": [
        28
    ],
    "kamu": [
        8550,
        3522,
        3702,
        3703,
        3704,
        53
    ],
    "kapul": [
        57
    ],
    "kyode": [
        62
    ],
    "kwéyòl": [
        65
    ],
    "kwèyòl": [
        65
    ],
    "kora": [
        68,
        1404,
        1615,
        4406,
        4407,
        4408,
        8487
    ],
    "kormakiti": [
        83,
        84,
        85
    ],
    "kanjimata": [
        104
    ],
    "keydnjmarda": [
        104
    ],
    "kiakh": [
        108,
        109,
        110
    ],
    "kjax": [
        108,
        109,
        110
    ],
    "kurtjar": [
        115,
        2584
    ],
    "kri": [
        123
    ],
    "kw": [
        136,
        418
    ],
    "kuwait": [
        136,
        418
    ],
    "kapagmai": [
        142
    ],
    "keffi": [
        144
    ],
    "katubung": [
        161
    ],
    "kahua": [
        172
    ],
    "kaboloan": [
        174
    ],
    "kabulowan": [
        174
    ],
    "kabuluen": [
        174
    ],
    "kabuluwan": [
        174
    ],
    "kabuluwen": [
        174
    ],
    "kropko": [
        180
    ],
    "khao ikor": [
        181,
        182,
        183,
        184,
        185
    ],
    "khao": [
        8402,
        181,
        182,
        183,
        184,
        185,
        3710,
        3976,
        3977,
        4313,
        7825,
        7826
    ],
    "koro makama": [
        192,
        1071
    ],
    "koro": [
        1071,
        3384,
        3606,
        3932,
        4119,
        8095,
        8101,
        192,
        4748,
        6270,
        7930
    ],
    "koron ache": [
        192
    ],
    "koron": [
        192
    ],
    "koron ala": [
        192
    ],
    "kittitian creole english": [
        200
    ],
    "kittitian": [
        200
    ],
    "kokoy creole english": [
        200
    ],
    "kokoy": [
        200
    ],
    "kitts": [
        200,
        2171
    ],
    "kurdit": [
        204,
        4491
    ],
    "kapon": [
        236,
        205,
        6044
    ],
    "kware": [
        206,
        3963,
        4089
    ],
    "karbi": [
        4840,
        229,
        2561
    ],
    "kebar": [
        234,
        4061,
        4062
    ],
    "kapóng": [
        236
    ],
    "katinja": [
        239
    ],
    "kamba": [
        3470,
        249,
        1780,
        2333,
        8510
    ],
    "kasele": [
        249
    ],
    "kede": [
        254
    ],
    "kol": [
        855,
        2083,
        3862,
        255,
        3019,
        3020,
        3021,
        3022,
        3023
    ],
    "kaweskar": [
        258
    ],
    "kawesqar": [
        258
    ],
    "kallana": [
        263
    ],
    "kallaua": [
        263
    ],
    "khasi": [
        3643,
        3644,
        296,
        4562
    ],
    "kareneri": [
        302
    ],
    "kochimberi": [
        302
    ],
    "küpondirideri": [
        302
    ],
    "karang": [
        4177,
        317
    ],
    "kerang": [
        317
    ],
    "kanala": [
        319
    ],
    "kunda": [
        3545,
        320,
        3537
    ],
    "kingdom": [
        321,
        750,
        751,
        1558,
        1708,
        1709,
        2134,
        2153,
        2210,
        2234,
        2573,
        2628,
        4072,
        5673,
        5674,
        5838,
        6006,
        6185,
        6544,
        6563,
        6731,
        7710,
        8262,
        8595,
        8877,
        9023
    ],
    "khivannal": [
        323
    ],
    "kemai": [
        325
    ],
    "kaungso": [
        326
    ],
    "kaungtso": [
        326
    ],
    "khaungtso": [
        326
    ],
    "khawngso": [
        326
    ],
    "khong": [
        326,
        1105,
        1417
    ],
    "khongso": [
        326,
        1413
    ],
    "kamarakotos": [
        346
    ],
    "kanda": [
        350,
        3497,
        7935
    ],
    "khartoum arabic": [
        369,
        370
    ],
    "khartoum": [
        369,
        370
    ],
    "kiowa": [
        3683,
        379
    ],
    "kiowa apache": [
        379
    ],
    "kangite": [
        389
    ],
    "kurmi": [
        398,
        4109
    ],
    "kaugat": [
        399
    ],
    "kovalhvok": [
        403
    ],
    "koyaqteves": [
        403
    ],
    "km": [
        417,
        2441,
        8255,
        8292,
        8293,
        9005,
        9006
    ],
    "koneá": [
        443
    ],
    "karo": [
        450,
        4107,
        1166,
        1167
    ],
    "karo (brazil)": [
        450
    ],
    "kipare": [
        460
    ],
    "kiathu": [
        460
    ],
    "kaweinag": [
        462
    ],
    "kambari": [
        3543,
        7749,
        466
    ],
    "kamberchi": [
        466,
        3543,
        7749
    ],
    "kamberri": [
        466,
        3543,
        7749
    ],
    "karufa": [
        468
    ],
    "koatinema": [
        472
    ],
    "kuben-kamrektí": [
        472
    ],
    "kgs": [
        475
    ],
    "kinja": [
        501
    ],
    "kinja iara": [
        501
    ],
    "kinã": [
        501
    ],
    "ki’nya": [
        501
    ],
    "koroernoes": [
        524
    ],
    "korur": [
        524
    ],
    "kashkadarya arabic": [
        531
    ],
    "kashkadarya": [
        531
    ],
    "khundzuri": [
        532
    ],
    "kwakwa": [
        535
    ],
    "kotava": [
        536
    ],
    "kojali": [
        546
    ],
    "kosali": [
        546,
        7066
    ],
    "koseli": [
        546
    ],
    "kvolyab": [
        551
    ],
    "kia river awyu": [
        561
    ],
    "kia": [
        561,
        3706
    ],
    "koaia": [
        567
    ],
    "koaiá": [
        567,
        8690
    ],
    "koayá": [
        567
    ],
    "kikahiabilo": [
        576
    ],
    "koka ai-ebadu": [
        576
    ],
    "koka": [
        576,
        7004,
        6797
    ],
    "koka-aiebadu": [
        576
    ],
    "koko aiebadu": [
        576
    ],
    "koko": [
        5876,
        576,
        891,
        2577,
        3752,
        3761,
        5894,
        7869,
        7943,
        7959,
        8338
    ],
    "koko-badja": [
        576
    ],
    "koko-baldya": [
        576
    ],
    "koko-baltjayiahjaba": [
        576
    ],
    "koroino": [
        584
    ],
    "ki": [
        615,
        5190,
        6177,
        2170,
        2646
    ],
    "kirat khambu": [
        624
    ],
    "kirat": [
        624
    ],
    "khambu": [
        624
    ],
    "kirat khambu rai": [
        624
    ],
    "kirawa yüng": [
        624
    ],
    "kirawa": [
        624
    ],
    "kogi": [
        3856,
        627
    ],
    "kanna": [
        627
    ],
    "kedjom": [
        644
    ],
    "kejeng": [
        644
    ],
    "kejom": [
        644
    ],
    "kidzem": [
        644
    ],
    "kidzom": [
        644
    ],
    "konabéré": [
        648
    ],
    "konakuma": [
        648
    ],
    "kʋnabɩrɩ": [
        648
    ],
    "kariya": [
        3681,
        653
    ],
    "kulung": [
        654,
        3768
    ],
    "kukulung": [
        654
    ],
    "kulu": [
        654,
        3181,
        3616,
        3617,
        3768
    ],
    "kulung (nigeria)": [
        654
    ],
    "kuluno": [
        654
    ],
    "karnai": [
        655
    ],
    "kiwai": [
        3690,
        3699,
        665,
        4652
    ],
    "kaloum": [
        1054,
        1055,
        666
    ],
    "kalum": [
        666
    ],
    "kunamba": [
        670
    ],
    "kaluli": [
        673
    ],
    "kibaali": [
        674
    ],
    "kibala": [
        936,
        674
    ],
    "kibali": [
        674
    ],
    "kohumono": [
        678
    ],
    "kwəmà ká bàná": [
        682
    ],
    "kwəmà": [
        682
    ],
    "ká": [
        682
    ],
    "ka-bana": [
        682
    ],
    "koma": [
        3816,
        682,
        2695,
        2871,
        3792,
        3808,
        8580
    ],
    "kwaa–ɓwaare": [
        683
    ],
    "kugere-kuxinge": [
        685
    ],
    "kelelegeia": [
        688
    ],
    "kurmuk": [
        693
    ],
    "kibende": [
        700
    ],
    "kiburunge": [
        703
    ],
    "kitah": [
        721
    ],
    "kapore": [
        726
    ],
    "kibeembe": [
        731
    ],
    "kibena": [
        740
    ],
    "kayan, busang": [
        748
    ],
    "kayan": [
        748,
        3525,
        4150,
        6087,
        6088,
        6494,
        8227,
        8411,
        8495,
        8503,
        2631,
        4065
    ],
    "kajan": [
        748,
        4150,
        6494,
        8227,
        8495,
        8503
    ],
    "kajang": [
        748,
        8503
    ],
    "khor": [
        753
    ],
    "kidd": [
        753
    ],
    "keylong boli": [
        769,
        770
    ],
    "keylong": [
        769,
        770
    ],
    "katha": [
        771,
        6460,
        6461
    ],
    "kawathi": [
        773
    ],
    "kenat": [
        773
    ],
    "kevat boli": [
        773
    ],
    "kevat": [
        773
    ],
    "kevati": [
        773
    ],
    "kewani": [
        773
    ],
    "kewat": [
        4155,
        773
    ],
    "kewati": [
        773
    ],
    "kewot": [
        773
    ],
    "kumhari": [
        773
    ],
    "kho": [
        785,
        3702,
        3703,
        3704,
        3791
    ],
    "khoa": [
        785
    ],
    "khowa": [
        785
    ],
    "klata": [
        786
    ],
    "khmu": [
        3702,
        3703,
        3704,
        788
    ],
    "kha bet": [
        788
    ],
    "kha": [
        788,
        789,
        3702,
        3703,
        3704,
        4229,
        4230,
        6365,
        7477,
        1436,
        1696,
        4233,
        6124,
        6471,
        6476,
        7522,
        8751
    ],
    "khabit": [
        788
    ],
    "khbit": [
        788
    ],
    "kha bo": [
        789
    ],
    "koga": [
        792
    ],
    "koba": [
        3876,
        792
    ],
    "kakaba": [
        798
    ],
    "kamkam": [
        798
    ],
    "kobi-benggoi": [
        803
    ],
    "kachlakan": [
        803,
        7161
    ],
    "kiranti-bayung": [
        818
    ],
    "khotla": [
        822,
        823
    ],
    "kovedi": [
        832
    ],
    "kipere": [
        834
    ],
    "kipili": [
        834
    ],
    "kun-ɓíilé": [
        845
    ],
    "kibila": [
        849
    ],
    "kol (cameroon)": [
        855
    ],
    "kortabina": [
        860
    ],
    "kanauji": [
        868
    ],
    "kannauji": [
        868
    ],
    "kanalu": [
        869
    ],
    "kanapit": [
        869
    ],
    "kolube": [
        869
    ],
    "komalu": [
        869
    ],
    "kulubi": [
        869
    ],
    "kyak": [
        886
    ],
    "kyango": [
        894
    ],
    "kom": [
        896,
        3805
    ],
    "kom (cameroon)": [
        896
    ],
    "kong": [
        2963,
        896,
        3750,
        2040,
        2041,
        2042,
        4439,
        7386,
        7387,
        8923,
        8924,
        8925,
        8926,
        2161,
        9025,
        9027
    ],
    "kwa’": [
        898
    ],
    "kwa'": [
        898
    ],
    "kurâ": [
        900
    ],
    "kuwaa": [
        918
    ],
    "kowaao": [
        918
    ],
    "kwaa": [
        918
    ],
    "karen": [
        1225,
        1226,
        2631,
        3381,
        3383,
        3713,
        3714,
        3715,
        3716,
        3717,
        3718,
        3722,
        3976,
        3977,
        4061,
        4062,
        6380,
        6382,
        921,
        2089,
        4065,
        4066,
        4070,
        4104,
        4105,
        4106,
        4110,
        4152,
        4153,
        4154,
        6523,
        8804
    ],
    "kawa": [
        928,
        929,
        930,
        931,
        1182,
        1505,
        8186
    ],
    "khon doi": [
        928,
        929,
        930,
        931
    ],
    "khon": [
        928,
        929,
        930,
        931,
        5620,
        5621,
        7389
    ],
    "kontoi": [
        928,
        929,
        930,
        931
    ],
    "k’ala": [
        928,
        929,
        930,
        931
    ],
    "k’wa": [
        928,
        929,
        930,
        931
    ],
    "kibala-ngoya": [
        936
    ],
    "kimbundu de kwanza sul": [
        936
    ],
    "kimbundu": [
        3793,
        936
    ],
    "kwanza": [
        936
    ],
    "kosian": [
        940
    ],
    "kibembe": [
        945
    ],
    "kein": [
        951
    ],
    "kanuri, bilma": [
        962
    ],
    "kanuri": [
        962,
        3503,
        3504,
        3925,
        3926,
        3943
    ],
    "kanouri": [
        962,
        3503,
        3504,
        3925,
        3926
    ],
    "kanoury": [
        962,
        3503,
        3504,
        3925,
        3926
    ],
    "kali": [
        975,
        3490,
        7415
    ],
    "kibangobango": [
        994
    ],
    "kibangubangu": [
        994
    ],
    "ke": [
        2961,
        9087,
        2893,
        2894,
        2895,
        2629,
        5574,
        5575,
        6879,
        8400,
        1003,
        1567,
        1684,
        1732,
        1743,
        1850,
        1970,
        2000,
        2056,
        2099,
        2169,
        2228,
        2326,
        2825,
        3134,
        3470,
        3670,
        3777,
        4358,
        4368,
        4370,
        4479,
        4482,
        4514,
        4515,
        4529,
        4540,
        4550,
        4591,
        4698,
        4884,
        5144,
        5192,
        5482,
        5546,
        5790,
        5792,
        5878,
        5903,
        5915,
        5951,
        6168,
        6174,
        6459,
        6499,
        6672,
        6808,
        6818,
        7021,
        7142,
        7226,
        7253,
        7411,
        7422,
        7446,
        7475,
        7800,
        7802,
        7812,
        8499
    ],
    "kenya": [
        3470,
        4529,
        7778,
        8226,
        8502,
        8514,
        1003,
        1567,
        1684,
        1732,
        1743,
        1850,
        1970,
        2000,
        2056,
        2099,
        2169,
        2228,
        2326,
        2825,
        3134,
        3670,
        3777,
        4358,
        4368,
        4370,
        4479,
        4482,
        4514,
        4515,
        4540,
        4550,
        4591,
        4698,
        4884,
        5144,
        5192,
        5482,
        5546,
        5790,
        5792,
        5878,
        5903,
        5915,
        5951,
        6168,
        6174,
        6459,
        6499,
        6672,
        6808,
        6818,
        7021,
        7142,
        7226,
        7253,
        7411,
        7422,
        7446,
        7475,
        7800,
        7802,
        7812,
        8499
    ],
    "kasai": [
        1007
    ],
    "kiboma": [
        1007
    ],
    "kibbo": [
        1012
    ],
    "kibbun": [
        1012
    ],
    "kibo": [
        1012
    ],
    "kibyen": [
        1012
    ],
    "kibondei": [
        1019
    ],
    "koepang talk": [
        1035
    ],
    "koepang": [
        1035
    ],
    "kaure": [
        1039
    ],
    "kaureh": [
        1039
    ],
    "kaureki": [
        1039
    ],
    "kaurne": [
        1039
    ],
    "koronadal": [
        1041
    ],
    "koronadal b'laan": [
        1041
    ],
    "koronadal bilaan": [
        1041
    ],
    "koronadal blaan": [
        1041
    ],
    "koronadal b’laan": [
        1041
    ],
    "kapeso": [
        1051
    ],
    "koussountou": [
        1056
    ],
    "kusuńtú": [
        1056
    ],
    "khaveri": [
        1058
    ],
    "kinsong": [
        1070
    ],
    "kogoro": [
        1070
    ],
    "koguru": [
        1070
    ],
    "koro wachi": [
        1071
    ],
    "koro agwe": [
        1071
    ],
    "kata kolok": [
        1074
    ],
    "kata": [
        1074,
        1122
    ],
    "kolok": [
        1074
    ],
    "kh": [
        1078,
        1478,
        1479,
        1480,
        1535,
        1537,
        1653,
        2962,
        3420,
        3551,
        3791,
        3941,
        3945,
        5890,
        6061,
        6532,
        6733,
        6983,
        7166,
        7259,
        7276,
        7677,
        8501
    ],
    "kibira": [
        1083,
        6640
    ],
    "kur galli": [
        1085,
        1086
    ],
    "kur": [
        4036,
        1085,
        1086,
        4315,
        1361
    ],
    "kurd gali": [
        1085
    ],
    "kurd": [
        1085
    ],
    "kpe": [
        1087
    ],
    "kwedi": [
        1087
    ],
    "kweli": [
        1087
    ],
    "kwili": [
        1087
    ],
    "kwiri": [
        1087
    ],
    "kajjara": [
        1089
    ],
    "kieu": [
        1100,
        1101,
        1102,
        6017,
        6018,
        6019
    ],
    "kachari": [
        8391,
        1109,
        1110,
        1111,
        5288,
        1861,
        1862
    ],
    "kushi": [
        4021,
        1120
    ],
    "kati": [
        1122,
        3999,
        2038,
        2039,
        3990
    ],
    "kata viri": [
        1122
    ],
    "kativiri": [
        1122
    ],
    "kâtʹa-vari": [
        1122
    ],
    "kuta": [
        1127
    ],
    "koose": [
        1135
    ],
    "kosi": [
        1135
    ],
    "kosse": [
        1135
    ],
    "kossi": [
        1135
    ],
    "kakissa": [
        1139,
        1140
    ],
    "kuap": [
        1151
    ],
    "kleb": [
        1158
    ],
    "kohistani": [
        5173,
        6190,
        7723,
        1164,
        2843
    ],
    "karo batak": [
        1166,
        1167
    ],
    "kalak karo": [
        1166,
        1167
    ],
    "kalak": [
        1166,
        1167,
        3523
    ],
    "kibosy kiantalaotsy-majunga": [
        1172
    ],
    "kibosy": [
        1172
    ],
    "kiantalaotsy-majunga": [
        1172
    ],
    "kibuki": [
        1172
    ],
    "kibushi": [
        1172
    ],
    "kuba": [
        1176,
        3855,
        4126,
        4524
    ],
    "koromba": [
        1181,
        3619
    ],
    "kawac": [
        1182
    ],
    "kugara": [
        1185
    ],
    "kibudu": [
        1190
    ],
    "karen, bwe": [
        1225,
        1226
    ],
    "kohoroxitari": [
        1230
    ],
    "kàdenbà": [
        1231
    ],
    "kwojeffa": [
        1240
    ],
    "kanjaga": [
        1243
    ],
    "kibua": [
        1244
    ],
    "kibwa": [
        1244
    ],
    "kibuyu": [
        1279
    ],
    "kang bau": [
        1281
    ],
    "kang": [
        4147,
        1281,
        1503,
        3651,
        9016,
        3702,
        3703,
        3704,
        7632
    ],
    "kang beu": [
        1281
    ],
    "kang pau": [
        1281
    ],
    "kangpau": [
        1281
    ],
    "kofoyap": [
        1282
    ],
    "kawanuwan": [
        1288
    ],
    "ketangalan": [
        3463,
        1288
    ],
    "kakat": [
        1294
    ],
    "kriol": [
        6592,
        2664,
        1306,
        3558,
        3315
    ],
    "kemberano": [
        1312
    ],
    "kalitami": [
        1312
    ],
    "kelengaxo": [
        1320
    ],
    "kelenga": [
        1320
    ],
    "kélinga": [
        1320
    ],
    "kéllingua": [
        1320
    ],
    "kɛlɛngaxo bozo": [
        1320
    ],
    "kɛlɛngaxo": [
        1320
    ],
    "karif": [
        1329
    ],
    "koti’": [
        1330
    ],
    "kado": [
        1331,
        2874,
        2875,
        2876,
        3997,
        7952
    ],
    "kadohadacho": [
        1331
    ],
    "kaqchikel": [
        1338
    ],
    "kaqchiquel": [
        1338
    ],
    "karìna auran": [
        1345
    ],
    "karìna": [
        1345
    ],
    "kalihna": [
        1345
    ],
    "kalinya": [
        1345
    ],
    "kalin’a": [
        1345
    ],
    "kali’na": [
        1345
    ],
    "kara’ibs": [
        1345
    ],
    "kariña": [
        1345
    ],
    "kari’na": [
        1345
    ],
    "kari’na auran": [
        1345
    ],
    "kari’nja": [
        1345
    ],
    "kari’nya": [
        1345
    ],
    "kari’ña": [
        1345
    ],
    "kavinenya": [
        1347
    ],
    "kallawaya": [
        1348
    ],
    "kanichana": [
        1351
    ],
    "kabiyarí": [
        1352
    ],
    "kauyarí": [
        1352
    ],
    "kawiarí": [
        1352
    ],
    "kawillary": [
        1352
    ],
    "kawiri": [
        1352
    ],
    "kawiyarí": [
        1352
    ],
    "karapano": [
        1353
    ],
    "karapaná": [
        1353
    ],
    "karapanã": [
        1353
    ],
    "kaliohona": [
        1354
    ],
    "karihona": [
        1354
    ],
    "karijona": [
        1354
    ],
    "koto": [
        1354,
        5952
    ],
    "kayapa": [
        1356,
        3469
    ],
    "kakataibo-kashibo": [
        1364
    ],
    "kashibo": [
        1364
    ],
    "kashinawa": [
        1365
    ],
    "kuī": [
        1365
    ],
    "kuin": [
        1365
    ],
    "kui": [
        2023,
        4048,
        4122,
        7935,
        3550,
        3551,
        3552,
        4315,
        1365,
        5190
    ],
    "kashinahua": [
        1365
    ],
    "kaxinauá": [
        1365
    ],
    "kaxinawá": [
        1365
    ],
    "kaxynawa": [
        1365
    ],
    "kandozi-chapra": [
        1367
    ],
    "kandoshi": [
        1367
    ],
    "kandozi": [
        1367
    ],
    "kakua": [
        1368,
        3572
    ],
    "kákwa": [
        1368
    ],
    "kinabalian": [
        1369
    ],
    "kinabalianon": [
        1369
    ],
    "kasanga": [
        1377
    ],
    "kassanga": [
        1377
    ],
    "kodha": [
        1381,
        1382,
        1384
    ],
    "kamuku": [
        1401,
        6583
    ],
    "koda": [
        1404,
        8487
    ],
    "kaora": [
        1404
    ],
    "korali": [
        1404
    ],
    "korati": [
        1404
    ],
    "kore": [
        1404
    ],
    "khumi": [
        1412,
        1413,
        1414,
        1415,
        1416,
        1417,
        1418,
        1419,
        1420,
        1421,
        1547,
        1538
    ],
    "khami": [
        1412,
        1413,
        1414,
        1415,
        1416,
        1417,
        1418,
        1419,
        1420,
        1421,
        1547,
        1538
    ],
    "kanise": [
        1415
    ],
    "khawng": [
        1416
    ],
    "karimjo": [
        1427
    ],
    "karim": [
        1427
    ],
    "khiyu": [
        1427
    ],
    "kinzimba": [
        1427
    ],
    "kirim": [
        1427
    ],
    "kiyu": [
        1427
    ],
    "khualshim": [
        1430
    ],
    "kagayanen": [
        1434
    ],
    "kagay-anen": [
        1434
    ],
    "kinagayanen": [
        1434
    ],
    "kiga": [
        1435
    ],
    "kursmadkha": [
        1436
    ],
    "kia’": [
        1444,
        1584,
        1629,
        1644,
        1682
    ],
    "khamkura": [
        1459,
        3627,
        3676,
        3684,
        3709
    ],
    "kinnauri, chitkuli": [
        1470
    ],
    "kinnauri": [
        1470,
        3601,
        3602,
        3712,
        5405,
        7674,
        3400,
        6737,
        7139
    ],
    "kanauri": [
        1470,
        3601,
        3602
    ],
    "khmer islam": [
        1478
    ],
    "khmer": [
        3791,
        4111,
        4112,
        5890,
        1478,
        1566,
        1653,
        3550,
        3551,
        3552,
        6733
    ],
    "kru": [
        1481,
        2754,
        3785,
        7412
    ],
    "kwaiailk": [
        1482
    ],
    "kioko": [
        7914,
        1484
    ],
    "kuznets tatar": [
        1491,
        1492
    ],
    "kuznets": [
        1491,
        1492
    ],
    "kurdish, central": [
        1496,
        1497,
        1498
    ],
    "kurdish": [
        1496,
        1497,
        1498,
        4007,
        4008,
        4009,
        4010,
        4011,
        4012,
        4013,
        4014,
        6753
    ],
    "kordi": [
        1496,
        1497,
        1498,
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "korkora": [
        1496,
        1497,
        1498
    ],
    "kurdi": [
        1496,
        1497,
        1498,
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurdy": [
        1496,
        1497,
        1498
    ],
    "kibaku": [
        1500
    ],
    "kibbaku": [
        1500
    ],
    "kikuk": [
        1500
    ],
    "kyibaku": [
        1500
    ],
    "kaang": [
        1503
    ],
    "kaang chin": [
        1503
    ],
    "kyokosi": [
        1504
    ],
    "kajakse": [
        1505
    ],
    "kadjakse": [
        1505
    ],
    "kajeske": [
        1505
    ],
    "kawa tadimini": [
        1505
    ],
    "kujarke": [
        1505
    ],
    "kairak": [
        1506
    ],
    "koasati": [
        1509
    ],
    "kavalan": [
        1510
    ],
    "kabalan": [
        1510
    ],
    "kabaran": [
        1510
    ],
    "kamalan": [
        1510
    ],
    "kavanan": [
        1510
    ],
    "kavarauan": [
        1510
    ],
    "kbalan": [
        1510
    ],
    "kibalan": [
        1510
    ],
    "kiwaraw": [
        1510
    ],
    "kiwarawa": [
        1510
    ],
    "kuvalan": [
        1510
    ],
    "kuvarawan": [
        1510
    ],
    "kuwarawan": [
        1510
    ],
    "kvalan": [
        1510
    ],
    "kaqchikel-k’iche’ mixed language": [
        1513
    ],
    "kaqchikel-k’iche’": [
        1513
    ],
    "kheu": [
        1519
    ],
    "klallam": [
        1523
    ],
    "krung": [
        3941,
        1529
    ],
    "kirma": [
        1530
    ],
    "koneq-koneq": [
        1533
    ],
    "kone-konee": [
        1533
    ],
    "kone’-kone’e": [
        1533
    ],
    "khimi": [
        1538
    ],
    "khumi awa": [
        1538
    ],
    "khoong": [
        1543
    ],
    "kaladan khumi": [
        1547
    ],
    "kaladan": [
        1547
    ],
    "kami": [
        3526,
        3801,
        1547,
        3651
    ],
    "khumi chin": [
        1547
    ],
    "khuni": [
        1547
    ],
    "kumi": [
        1547,
        7651
    ],
    "kï": [
        1555,
        1702
    ],
    "kokos": [
        1560
    ],
    "kukus": [
        1560
    ],
    "kikima": [
        1562
    ],
    "kikimá": [
        1562
    ],
    "kuapá": [
        1562
    ],
    "kwikapa": [
        1562
    ],
    "kwikapá": [
        1562
    ],
    "kukama-kukamiria": [
        1563
    ],
    "kocama": [
        1563
    ],
    "kokama": [
        1563
    ],
    "kokama-kokamilya": [
        1563
    ],
    "kukama": [
        1563
    ],
    "koreguaje": [
        1564
    ],
    "koʼrevajʉ chʉʼo": [
        1564
    ],
    "koʼrevajʉ": [
        1564
    ],
    "korebaju": [
        1564
    ],
    "korewahe": [
        1564
    ],
    "ko’reuaju": [
        1564
    ],
    "khmer chong": [
        1566
    ],
    "kichonyi": [
        1567
    ],
    "kwéimarusa’na": [
        1569
    ],
    "kofan": [
        1572
    ],
    "kofane": [
        1572
    ],
    "kofán": [
        1572
    ],
    "ko’kwel": [
        1577
    ],
    "kakinte": [
        1578
    ],
    "koniagi": [
        1579
    ],
    "koniagui": [
        1579
    ],
    "konyagi": [
        1579
    ],
    "kampa": [
        1585
    ],
    "kyerepong": [
        1589
    ],
    "kpeego": [
        1590
    ],
    "kreol": [
        4712,
        1619
    ],
    "kreol seselwa": [
        1619
    ],
    "kyoli": [
        1625
    ],
    "kashubian": [
        1630
    ],
    "kaszubski": [
        1630
    ],
    "kaszëbsczi jãzëk": [
        1630
    ],
    "kaszëbsczi": [
        1630
    ],
    "khamaw": [
        1636,
        1637
    ],
    "khamoe": [
        1636,
        1637
    ],
    "khyang": [
        1636,
        1637
    ],
    "khyeng": [
        1636,
        1637
    ],
    "kyang": [
        1636,
        1637
    ],
    "kaasa": [
        1640
    ],
    "kújoolowaay-kaasa": [
        1640
    ],
    "ksl": [
        1653,
        4055,
        8499
    ],
    "khmer sign language": [
        1653
    ],
    "katio": [
        1668
    ],
    "katío": [
        7385,
        1668
    ],
    "kobeua": [
        1681
    ],
    "kobewa": [
        1681
    ],
    "kobéwa": [
        1681
    ],
    "kubeo": [
        1681
    ],
    "kubewa": [
        1681
    ],
    "kubwa": [
        1681
    ],
    "kuiva": [
        1685
    ],
    "kuna, san blas": [
        1687
    ],
    "kuna": [
        1687,
        4058
    ],
    "kaya": [
        3591,
        3592,
        3593,
        3594,
        1687
    ],
    "kulina": [
        1688,
        8597
    ],
    "kollina": [
        1688
    ],
    "kulino": [
        1688
    ],
    "kulyna": [
        1688
    ],
    "kulína": [
        1688
    ],
    "kurina": [
        1688
    ],
    "kumanagoto": [
        1689
    ],
    "kumaná": [
        1689
    ],
    "kabwa": [
        1703
    ],
    "kikabwa": [
        1703
    ],
    "kwere": [
        1705
    ],
    "kakwere": [
        1705
    ],
    "kikwere": [
        1705,
        3561
    ],
    "kinghwele": [
        1705
    ],
    "kwele": [
        1705
    ],
    "kuwaataay": [
        1707
    ],
    "kwatay": [
        1707
    ],
    "kayuvava": [
        1711
    ],
    "kuyonon": [
        1712
    ],
    "kuyunon": [
        1712
    ],
    "knaanic": [
        1715
    ],
    "khyo": [
        1734,
        1735,
        1736,
        1737,
        1738
    ],
    "kkhyou": [
        1734,
        1735,
        1736,
        1737,
        1738
    ],
    "kheng": [
        1735
    ],
    "koya": [
        3591,
        3592,
        3593,
        3594,
        3621,
        1739
    ],
    "khiurkilinskii": [
        1740
    ],
    "kitaita": [
        1743
    ],
    "kidabida": [
        1743
    ],
    "kidawida": [
        1743
    ],
    "kadara doka": [
        1753
    ],
    "kadara": [
        1753,
        3462
    ],
    "kreool": [
        1770
    ],
    "kidoondo": [
        1773
    ],
    "kamba so": [
        1780
    ],
    "kamma so": [
        1780
    ],
    "kamma": [
        1780
    ],
    "kotedia": [
        1810
    ],
    "kusibi": [
        1810
    ],
    "korandabo": [
        1814
    ],
    "kakachhu-ki boli": [
        1837
    ],
    "kakachhu-ki": [
        1837
    ],
    "kidhaiso": [
        1840
    ],
    "kisegeju": [
        1840,
        6780
    ],
    "kacarya danuwar": [
        1843
    ],
    "kacarya": [
        1843
    ],
    "kidigo": [
        1850
    ],
    "kumiai": [
        1851
    ],
    "kamia": [
        1851
    ],
    "kamiai": [
        1851
    ],
    "kamiyahi": [
        1851
    ],
    "kamiyai": [
        1851
    ],
    "ki-miai": [
        1851
    ],
    "ko’al": [
        1851
    ],
    "kumeyaai": [
        1851
    ],
    "kumeyaay": [
        1851
    ],
    "kumia": [
        1851
    ],
    "ku’ahl": [
        1851
    ],
    "kw’aal": [
        1851
    ],
    "kaalong": [
        1852
    ],
    "kalong": [
        1852,
        4146,
        8741
    ],
    "kedeŋ-lesye": [
        1867
    ],
    "kindinga": [
        1867
    ],
    "koko-mudju": [
        1875
    ],
    "koko-tyankun": [
        1875
    ],
    "kumertuo": [
        1881
    ],
    "kapriman": [
        1884
    ],
    "kadung": [
        1887
    ],
    "kadun": [
        1887
    ],
    "kwang": [
        4053,
        1887
    ],
    "kwanga": [
        4082,
        1887
    ],
    "kwangka": [
        1887
    ],
    "kwanka": [
        1887
    ],
    "kwanka-boi-bijim": [
        1887
    ],
    "kwàŋ": [
        1887
    ],
    "kuijau": [
        1889
    ],
    "kijau": [
        1889
    ],
    "koijoe": [
        1889
    ],
    "kuiyow": [
        1889
    ],
    "kujau": [
        1889
    ],
    "kuliow": [
        1889
    ],
    "kuriyo": [
        1889
    ],
    "kwijau": [
        1889
    ],
    "kolu-so": [
        1897
    ],
    "kolum-so": [
        1897
    ],
    "kinabatangan, upper": [
        1902
    ],
    "kinabatangan": [
        1902,
        1981
    ],
    "kemedzung": [
        1906
    ],
    "kemezung": [
        1906
    ],
    "kumaju": [
        1906
    ],
    "kémézuñ": [
        1906
    ],
    "kɨmədzuŋ": [
        1906
    ],
    "karanga": [
        3989,
        1911
    ],
    "karangpurru": [
        1911
    ],
    "karranga": [
        1911
    ],
    "karrangpurru": [
        1911
    ],
    "kindendeule": [
        1916
    ],
    "kindendeuli": [
        1916
    ],
    "kwuizwu": [
        1917
    ],
    "kg": [
        1917,
        4129,
        6613
    ],
    "kyrgyzstan": [
        1917,
        4129,
        6613
    ],
    "kpankagooma": [
        1922
    ],
    "kam": [
        3555,
        2518,
        1932,
        3651,
        3663,
        3794,
        3795,
        3852,
        5620,
        5621
    ],
    "kidoe": [
        1933
    ],
    "ko": [
        2490,
        6363,
        3908,
        8680,
        1942,
        3674,
        8731
    ],
    "kwarekwareo": [
        1945
    ],
    "kadazan": [
        1981,
        1989,
        3917,
        1958,
        7858,
        4178
    ],
    "kalla-kalla": [
        1959
    ],
    "kolela": [
        1959
    ],
    "kula": [
        7665,
        1960
    ],
    "kadas": [
        1966,
        3920,
        6379,
        6388,
        6389
    ],
    "koraput oriya": [
        1974
    ],
    "koraput": [
        1974
    ],
    "kadazan, labuk-kinabatangan": [
        1981
    ],
    "kadajan": [
        1981
    ],
    "kan": [
        1985,
        1986,
        2523,
        2524,
        2525,
        2704,
        2719,
        4260,
        3739,
        3740,
        5265
    ],
    "kadazan dusun": [
        1989
    ],
    "kadasan": [
        1989
    ],
    "kadayan": [
        1989,
        4178
    ],
    "kadazandusun": [
        1989
    ],
    "kedayan": [
        1989
    ],
    "koki": [
        2004,
        3900,
        5776
    ],
    "kuala": [
        3626,
        2009
    ],
    "kiao": [
        2013
    ],
    "kiu": [
        2013
    ],
    "kiupa": [
        2013
    ],
    "kiutze": [
        2013,
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "kui, dawik": [
        2023
    ],
    "kujamataak": [
        2038,
        2039
    ],
    "kújoolaak kati fooñi": [
        2038,
        2039
    ],
    "kújoolaak": [
        2038,
        2039
    ],
    "kújoolaak kati kúfooñaak": [
        2038,
        2039
    ],
    "kúfooñaak": [
        2038,
        2039
    ],
    "kújoolaay": [
        2038,
        2039
    ],
    "kong jula": [
        2040,
        2041,
        2042
    ],
    "kikonjunkulu": [
        2043
    ],
    "kodgotto": [
        2043
    ],
    "koko-tjumbundji": [
        2043
    ],
    "kokonyungalo": [
        2043
    ],
    "karenggapa": [
        2050
    ],
    "karrengappa": [
        2050
    ],
    "kurengappa": [
        2050
    ],
    "kyama": [
        2055
    ],
    "kiembu": [
        2056
    ],
    "kĩembu": [
        2056
    ],
    "krepe": [
        2060,
        2061
    ],
    "krepi": [
        2060,
        2061
    ],
    "kjang e": [
        2063
    ],
    "kjang": [
        2063
    ],
    "karnic": [
        2079
    ],
    "kapauku": [
        2081
    ],
    "kol (bangladesh)": [
        2083
    ],
    "koti": [
        2085,
        2086
    ],
    "kayah, eastern": [
        2089
    ],
    "kayah": [
        2089,
        4152,
        4153,
        4154
    ],
    "karenni": [
        2089,
        4152,
        4153,
        4154
    ],
    "karennyi": [
        2089,
        4152,
        4153,
        4154
    ],
    "kayah li": [
        2089,
        4152,
        4153,
        4154
    ],
    "kayay": [
        2089
    ],
    "kayeh": [
        2089
    ],
    "kordofan": [
        2095
    ],
    "kunibum": [
        2102
    ],
    "koniag-chugach": [
        2111,
        2112
    ],
    "kiingereza": [
        2118,
        2134,
        2146,
        2210
    ],
    "keeling": [
        2136,
        5071
    ],
    "kiribati": [
        2646,
        2170
    ],
    "kn": [
        2171
    ],
    "ky": [
        2172
    ],
    "kiamerop": [
        2238
    ],
    "koyam": [
        2287,
        2288,
        2289
    ],
    "kuskokwim eskimo": [
        2299
    ],
    "kuskokwim": [
        4035,
        2299
    ],
    "keel": [
        2302,
        3299
    ],
    "kirjakeel": [
        2302
    ],
    "keaka": [
        2313
    ],
    "kwa": [
        4074,
        2313
    ],
    "khamnigan": [
        2320,
        2321,
        2322
    ],
    "khamnigan ewenki": [
        2320,
        2321,
        2322
    ],
    "khamnigan mongol": [
        2320,
        2321,
        2322
    ],
    "keiyo": [
        2326
    ],
    "keyo": [
        2326
    ],
    "kursav": [
        2338
    ],
    "konga": [
        2341
    ],
    "kɔŋa": [
        2341
    ],
    "kalige": [
        2351
    ],
    "kaligi": [
        2351
    ],
    "kalike": [
        2351
    ],
    "kaliki": [
        2351
    ],
    "kole": [
        2380,
        3797,
        3862,
        3925,
        3926
    ],
    "kifipa": [
        2389
    ],
    "kwakwi": [
        2390
    ],
    "kirya-konzel": [
        2394
    ],
    "karya": [
        2394
    ],
    "kirya": [
        2394
    ],
    "kirya-konzəl": [
        2394
    ],
    "konzal": [
        2394
    ],
    "kákíryà": [
        2394
    ],
    "kónzə̀l": [
        2394
    ],
    "kven": [
        2395
    ],
    "kainu": [
        2395
    ],
    "kainun kieli": [
        2395
    ],
    "kainun": [
        2395
    ],
    "kieli": [
        2395,
        5896
    ],
    "kveenin": [
        2395
    ],
    "kveenin kieli": [
        2395
    ],
    "kven finnish": [
        2395
    ],
    "kvensk": [
        2395
    ],
    "kvääna": [
        2395
    ],
    "kvääni": [
        2395
    ],
    "kväänin kieli": [
        2395
    ],
    "kväänin": [
        2395
    ],
    "kalispel-pend d’oreille": [
        2396
    ],
    "kalispel-pend": [
        2396
    ],
    "kalispel-pend d'oreille": [
        2396
    ],
    "kifuliiru": [
        2401
    ],
    "kifulero": [
        2401
    ],
    "koitor boli": [
        2404
    ],
    "koitor": [
        2404
    ],
    "koitori": [
        2404
    ],
    "kobe": [
        2407
    ],
    "krio": [
        3934,
        2416
    ],
    "kiai": [
        2475
    ],
    "kau": [
        2490,
        3476,
        6517,
        8016,
        8017,
        9044,
        9045,
        9047,
        9048
    ],
    "kadirgi": [
        2500
    ],
    "kondjara": [
        2500
    ],
    "konjara": [
        2500
    ],
    "korra": [
        3589,
        2500
    ],
    "kungara": [
        2500
    ],
    "kurka": [
        2500,
        3944
    ],
    "kandawo": [
        2522
    ],
    "kenathi": [
        2531
    ],
    "kenati": [
        2531
    ],
    "kondekar": [
        2532
    ],
    "kondko": [
        2532
    ],
    "konekor gadaba": [
        2532,
        2575,
        2576
    ],
    "konekor": [
        2532,
        2575,
        2576
    ],
    "kaytetye": [
        2541
    ],
    "kaiditj": [
        2541
    ],
    "kaititj": [
        2541
    ],
    "kaytej": [
        2541
    ],
    "karajarri": [
        2542
    ],
    "karadjeri": [
        2542
    ],
    "karrajarri": [
        2542
    ],
    "kakadu": [
        2559
    ],
    "kakakta": [
        2559
    ],
    "kakdju": [
        2559
    ],
    "kakdjuan": [
        2559
    ],
    "kabbi": [
        2561
    ],
    "kabi": [
        2561
    ],
    "kabi kabi": [
        2561
    ],
    "kabikabi": [
        2561
    ],
    "kahby": [
        2561
    ],
    "karabi": [
        2561
    ],
    "kpla": [
        2562
    ],
    "kanggaleida": [
        2566
    ],
    "kangkalita": [
        2566
    ],
    "kreyol": [
        2568,
        3064
    ],
    "kanwar khati": [
        2574
    ],
    "kanwar": [
        2574
    ],
    "khati": [
        2574
    ],
    "koko padun": [
        2577
    ],
    "koko patun": [
        2577
    ],
    "koko-patun": [
        2577
    ],
    "kokopatun": [
        2577
    ],
    "kadjerawang": [
        2582
    ],
    "kadjeroen": [
        2582
    ],
    "kadjerong": [
        2582
    ],
    "kadpjeroen": [
        2582
    ],
    "kajirrawong": [
        2582
    ],
    "kajirrawung": [
        2582
    ],
    "kunggara": [
        2584
    ],
    "kunggera": [
        2584
    ],
    "kungardutyi": [
        2594
    ],
    "kunatatchee": [
        2594
    ],
    "kungaditji": [
        2594
    ],
    "kungadutji": [
        2594
    ],
    "kungarditchi": [
        2594
    ],
    "kungatutji": [
        2594
    ],
    "kungatutyi": [
        2594
    ],
    "kungkatutyi": [
        2594
    ],
    "kire": [
        2598
    ],
    "kire-puire": [
        2598
    ],
    "karre": [
        2612
    ],
    "kukatj": [
        2619
    ],
    "kungarakany": [
        2622
    ],
    "kangarraga": [
        2622
    ],
    "kungarakan": [
        2622
    ],
    "kelana": [
        2624,
        3517
    ],
    "kago": [
        2625
    ],
    "karen, geko": [
        2631
    ],
    "kakhau": [
        2631
    ],
    "kayan kakhau": [
        2631
    ],
    "kekaungdu": [
        2631
    ],
    "kekhong": [
        2631
    ],
    "keku": [
        2631
    ],
    "kubokota": [
        2633
    ],
    "kumbokota": [
        2633
    ],
    "kuke": [
        2637
    ],
    "kutang": [
        2637,
        3986
    ],
    "kutang ghale": [
        2637
    ],
    "kija": [
        2638
    ],
    "kidja": [
        2638
    ],
    "kitja": [
        2638
    ],
    "kada": [
        2641,
        3567
    ],
    "kaɗa": [
        2641
    ],
    "kidabal": [
        2644
    ],
    "kidjabal": [
        2644
    ],
    "kita-bool": [
        2644
    ],
    "kitabool": [
        2644
    ],
    "kitapul": [
        2644
    ],
    "kitta-bool": [
        2644
    ],
    "kittabool": [
        2644
    ],
    "kuttibul": [
        2644
    ],
    "kiribatese": [
        2646
    ],
    "klau": [
        2650,
        3785
    ],
    "koli, kachi": [
        2659,
        2660
    ],
    "koli": [
        2659,
        2660,
        4069,
        4115,
        4116,
        4117,
        8076
    ],
    "kachi": [
        2659,
        2660,
        3609,
        3610
    ],
    "kachi gujarati": [
        2659,
        2660
    ],
    "kachi koli": [
        2659,
        2660
    ],
    "katchi": [
        2659,
        2660,
        3609,
        3610
    ],
    "kohli": [
        2659,
        2660
    ],
    "kolhi": [
        2659,
        2660
    ],
    "kori": [
        2659,
        2660
    ],
    "kuchi": [
        2659,
        2660
    ],
    "kuchikoli": [
        2659,
        2660
    ],
    "kirurndit": [
        2661
    ],
    "kuunditjmara": [
        2661
    ],
    "kuurn kopan noot": [
        2661
    ],
    "kuurn": [
        2661
    ],
    "kopan": [
        2661
    ],
    "kuurn-kopan-noot": [
        2661
    ],
    "kashmir gujuri": [
        2665,
        2666
    ],
    "kashmir": [
        2665,
        2666
    ],
    "kok-nar": [
        2671
    ],
    "kok nar": [
        2671
    ],
    "kok": [
        7714,
        7715,
        2671,
        3752,
        5876,
        7662,
        7663
    ],
    "kok narr": [
        2671
    ],
    "kok nhang": [
        2671
    ],
    "kok-narr": [
        2671
    ],
    "kokatabul": [
        2671
    ],
    "kokawan-gar": [
        2671
    ],
    "koknar": [
        2671
    ],
    "koko-nar": [
        2671
    ],
    "koko-nari": [
        2671
    ],
    "koko-nhang": [
        2671
    ],
    "koko-daua": [
        2671
    ],
    "kokodaue": [
        2671
    ],
    "kokowanggara": [
        2671
    ],
    "kuantari": [
        2671
    ],
    "kuk-narr": [
        2671
    ],
    "kundar": [
        2671
    ],
    "kundara": [
        2671
    ],
    "kuuk-nhang": [
        2671
    ],
    "kwanthar": [
        2671
    ],
    "kpelle, guinea": [
        2672
    ],
    "kpelle": [
        2672,
        3877,
        3878
    ],
    "kpɛlɛwoo": [
        2672,
        3877,
        3878
    ],
    "kpele": [
        2672,
        3877,
        3878
    ],
    "kpelese": [
        2672
    ],
    "kpelesetina": [
        2672
    ],
    "kperese": [
        2672
    ],
    "kpese": [
        2672,
        3877,
        3878
    ],
    "kpwessi": [
        2672,
        3877,
        3878
    ],
    "kulaal": [
        2679
    ],
    "kalali": [
        2682
    ],
    "kalil": [
        2682
    ],
    "kullali": [
        2682
    ],
    "kullalli": [
        2682
    ],
    "kullally": [
        2682
    ],
    "kullilla": [
        2682
    ],
    "kullilli": [
        2682
    ],
    "kambera": [
        8424,
        2688
    ],
    "kwai": [
        2689
    ],
    "kadam": [
        2695
    ],
    "koma kadam": [
        2695
    ],
    "komlama": [
        2695
    ],
    "kimagoma": [
        2700
    ],
    "kaansa": [
        2704
    ],
    "kã́asa": [
        2704
    ],
    "kaan": [
        4260,
        2704
    ],
    "kaanse": [
        2704
    ],
    "kãasa": [
        2704
    ],
    "konajan": [
        2711
    ],
    "konean": [
        2711
    ],
    "konejandi": [
        2711
    ],
    "koneyandi": [
        2711
    ],
    "kunan": [
        2711,
        2855
    ],
    "kunian": [
        2711
    ],
    "kuniandu": [
        2711
    ],
    "kuniyan": [
        2711
    ],
    "kanakhoe": [
        2713
    ],
    "ka-ngool-lo": [
        2714
    ],
    "kaangooloo": [
        2714
    ],
    "kangalo": [
        2714
    ],
    "kangulu": [
        2714
    ],
    "kanolu": [
        2714
    ],
    "khang": [
        7632,
        2714,
        4147
    ],
    "khangalu": [
        2714
    ],
    "kongal": [
        2714
    ],
    "kongul": [
        2714
    ],
    "konguli": [
        2714
    ],
    "keningau dusun": [
        2717
    ],
    "keningau": [
        4108,
        2717,
        6632
    ],
    "kooranga": [
        2718
    ],
    "koreng-koreng": [
        2718
    ],
    "korenggoreng": [
        2718
    ],
    "korrengkorreng": [
        2718
    ],
    "kurranga": [
        2718
    ],
    "ku": [
        2723,
        3372,
        4235,
        5039
    ],
    "kweni": [
        2723
    ],
    "kwéndré": [
        2723
    ],
    "kigogo": [
        2730
    ],
    "konkani, goan": [
        2736,
        2737,
        2738
    ],
    "konkani": [
        2736,
        2737,
        2738,
        3832,
        3833,
        3861,
        3582,
        3583
    ],
    "konknni": [
        2736,
        2737,
        2738
    ],
    "kanara": [
        3582,
        3583,
        2736,
        2737,
        2738
    ],
    "kortchi": [
        2748
    ],
    "kroo brofo": [
        2754
    ],
    "kroo": [
        2754,
        3785
    ],
    "kru english": [
        2754
    ],
    "kaandata": [
        2756
    ],
    "kaandecha": [
        2756
    ],
    "kinihinao": [
        2758
    ],
    "kinikinao": [
        2758
    ],
    "kinikinau": [
        2758
    ],
    "keh-lao": [
        2760
    ],
    "kehlao": [
        2760
    ],
    "kelao": [
        2760
    ],
    "keleo": [
        2760
    ],
    "khi": [
        2760,
        3910
    ],
    "klo": [
        2760
    ],
    "klépo": [
        2763
    ],
    "kota marudu talantang": [
        2772
    ],
    "kota": [
        2772,
        3590,
        3865,
        5015,
        3968
    ],
    "klesi": [
        2776
    ],
    "kistane": [
        2780,
        2781
    ],
    "kusiilaay": [
        2789
    ],
    "kusilay": [
        2789
    ],
    "kadallu": [
        2811,
        2812
    ],
    "ka’yngua": [
        2815
    ],
    "kuninjku": [
        2817
    ],
    "kunwinjku": [
        2817
    ],
    "kobali": [
        2822
    ],
    "kisii": [
        2825
    ],
    "kosova": [
        2825
    ],
    "kaskihá": [
        2827
    ],
    "kotiria": [
        2828
    ],
    "kootiria": [
        2828
    ],
    "kótedia": [
        2828
    ],
    "kótirya": [
        2828
    ],
    "ka": [
        2830,
        4208
    ],
    "kuku-yalanji": [
        2834
    ],
    "koko-yalanji": [
        2834
    ],
    "kuku-yalangi": [
        2834
    ],
    "kura": [
        5653,
        2837,
        2838,
        3394,
        3781
    ],
    "kyi": [
        3643,
        3644,
        2837,
        2838,
        4498
    ],
    "kijani": [
        2840
    ],
    "koonarie": [
        2840
    ],
    "kooteeuna": [
        2840
    ],
    "kooteeunna": [
        2840
    ],
    "kooyeeunna": [
        2840
    ],
    "kooyiannie": [
        2840
    ],
    "kujani": [
        2840
    ],
    "kuyani": [
        2840
    ],
    "kuyanni": [
        2840
    ],
    "kwiana": [
        2840
    ],
    "kwiani": [
        2840
    ],
    "kalam kohistani": [
        2843
    ],
    "kalam": [
        3800,
        2843,
        3026
    ],
    "kalami": [
        2843
    ],
    "kohistana": [
        2843
    ],
    "kighonu": [
        2845
    ],
    "kigweno": [
        2845
    ],
    "khel": [
        2846
    ],
    "kyuu": [
        2848
    ],
    "k’yuu": [
        2848
    ],
    "kutchin": [
        2848
    ],
    "kwandara": [
        2851
    ],
    "kaombal": [
        2854
    ],
    "koambal": [
        2854
    ],
    "koamu": [
        2854
    ],
    "kooma": [
        2854
    ],
    "kuam": [
        2854
    ],
    "kuamu": [
        2854
    ],
    "kwini": [
        2855
    ],
    "kurupi": [
        2858
    ],
    "kayardild": [
        2859
    ],
    "kaiadilt": [
        2859
    ],
    "khungabula": [
        2861
    ],
    "kongabula": [
        2861
    ],
    "kungabula": [
        2861
    ],
    "kpasiya": [
        2862
    ],
    "kriiyliiz": [
        2866
    ],
    "kriiyoliiz": [
        2866
    ],
    "kunja": [
        6102,
        2869
    ],
    "kurnja": [
        2869
    ],
    "koma-ganza": [
        2871
    ],
    "kil": [
        2890,
        2908
    ],
    "kíl": [
        2890
    ],
    "kechia": [
        2893,
        2894,
        2895
    ],
    "kehia": [
        2893,
        2894,
        2895
    ],
    "kejia": [
        2893,
        2894,
        2895
    ],
    "kejiahua": [
        2893,
        2894,
        2895
    ],
    "kek": [
        2893,
        2894,
        2895
    ],
    "khek": [
        2893,
        2894,
        2895
    ],
    "koyong": [
        2896
    ],
    "kihangaza": [
        2898
    ],
    "kiha": [
        2901
    ],
    "kitlope": [
        2905
    ],
    "kwakiutl": [
        4083,
        2905
    ],
    "kihavu": [
        2906
    ],
    "kihaya": [
        2909
    ],
    "kilba": [
        2912
    ],
    "ka’do herdé": [
        2923
    ],
    "ka’do": [
        2923,
        5605,
        9061
    ],
    "kupang": [
        4859,
        2924
    ],
    "kihehe": [
        2925
    ],
    "kiemba": [
        2927
    ],
    "kihemba": [
        2927
    ],
    "kiluba-hemba": [
        2927
    ],
    "kapulika": [
        2929
    ],
    "kerak": [
        2931
    ],
    "keerak": [
        2931
    ],
    "keeraku": [
        2931
    ],
    "kamwe": [
        2942
    ],
    "kamwǝ": [
        2942
    ],
    "kalahari khoe": [
        2950
    ],
    "kalahari": [
        2950
    ],
    "khoe": [
        8684,
        2950
    ],
    "khoisan": [
        2950
    ],
    "kwe": [
        2950,
        7876
    ],
    "kwe-etshori kwee": [
        2950
    ],
    "kwe-etshori": [
        2950
    ],
    "kwee": [
        2950
    ],
    "kwe-tshori": [
        2950
    ],
    "kumiyana": [
        2954
    ],
    "kahe": [
        2956
    ],
    "kikahe": [
        2956
    ],
    "kihunde": [
        2957
    ],
    "kobi": [
        2957
    ],
    "khah": [
        2958,
        2959,
        2960
    ],
    "khasha": [
        2958,
        2959,
        2960
    ],
    "khashali": [
        2958,
        2959,
        2960
    ],
    "kwei-chu": [
        2980
    ],
    "kwei-chu miao": [
        2980
    ],
    "keh deo": [
        2981
    ],
    "keh": [
        2981
    ],
    "kr": [
        2982,
        3378,
        3847,
        3848,
        3850,
        4055,
        5882,
        5884,
        6169,
        9148
    ],
    "korea": [
        9148,
        2982,
        3378,
        3847,
        3848,
        3849,
        3850,
        4055,
        5882,
        5884,
        6169
    ],
    "kuv tsis has lug moob tau": [
        2986
    ],
    "kuv": [
        2986
    ],
    "kamea": [
        2992
    ],
    "kapau": [
        2992
    ],
    "khaltahi": [
        3001
    ],
    "kihungu": [
        3002
    ],
    "kagani": [
        3012
    ],
    "kaghani": [
        3012
    ],
    "k’katiam-pong-houk": [
        3014
    ],
    "kaji": [
        3019,
        3020,
        3021,
        3022,
        3023,
        6726,
        6727
    ],
    "kalam rifi": [
        3026
    ],
    "kiholo": [
        3029
    ],
    "kiholu": [
        3029
    ],
    "kalanga": [
        3516,
        3031
    ],
    "kiholoholo": [
        3031
    ],
    "kikalanga": [
        3031
    ],
    "khua": [
        8481,
        3050,
        6171,
        6172
    ],
    "kha-nzi": [
        3050
    ],
    "katharinensisch": [
        3056
    ],
    "kasar": [
        3060
    ],
    "kreyòl": [
        3064
    ],
    "kreyòl ayisyen": [
        3064
    ],
    "kangeju": [
        3067
    ],
    "kindega": [
        3067
    ],
    "kindiga": [
        3067
    ],
    "kitindiga": [
        3067
    ],
    "kihungan": [
        3083
    ],
    "kihungana": [
        3083
    ],
    "kham": [
        3627,
        3676,
        3684,
        3709,
        3089,
        3663,
        4176,
        7472
    ],
    "komïne": [
        3090
    ],
    "khunzal": [
        3095
    ],
    "khunzaly": [
        3095
    ],
    "khvanal": [
        3095,
        3472
    ],
    "kwudi": [
        3112
    ],
    "kwundi": [
        3112
    ],
    "koriki": [
        3114
    ],
    "karadjee": [
        3117
    ],
    "kentu": [
        3128
    ],
    "kyanton": [
        3128
    ],
    "kyãtõ": [
        3128
    ],
    "kiangan ifugao": [
        3150
    ],
    "kiangan": [
        3150
    ],
    "kiteke": [
        3151,
        7418
    ],
    "kallahan, keley-i": [
        3153
    ],
    "kallahan": [
        3153,
        3469
    ],
    "keley-i": [
        3153
    ],
    "keley-i kallahan": [
        3153
    ],
    "keley-i kalanguya": [
        3153
    ],
    "kalanguya": [
        3469,
        3153
    ],
    "keleyqiq ifugao": [
        3153
    ],
    "keleyqiq": [
        3153
    ],
    "katawa": [
        3155
    ],
    "kotokori": [
        3155
    ],
    "kwotto": [
        3155
    ],
    "kanggape": [
        3159
    ],
    "kapaur": [
        3167
    ],
    "kalabari": [
        3175
    ],
    "kalaḇari bibi": [
        3175
    ],
    "kalaḇari": [
        3175
    ],
    "kiikizu": [
        3191
    ],
    "kizu": [
        3191
    ],
    "kisti": [
        3215,
        3216,
        3217
    ],
    "kistin": [
        3215,
        3216,
        3217
    ],
    "kaitero": [
        3236
    ],
    "kasira": [
        3236
    ],
    "kwal": [
        3237
    ],
    "kwan": [
        3237,
        7894
    ],
    "kwoll": [
        3237
    ],
    "kiiraqw": [
        3238
    ],
    "kángw iraqw": [
        3238
    ],
    "kángw": [
        3238
    ],
    "kad chensu": [
        3241,
        3242
    ],
    "kad": [
        3241,
        3242
    ],
    "korava": [
        3241,
        3242,
        8778
    ],
    "kamberau": [
        3243
    ],
    "kambrau": [
        3243
    ],
    "kamrau": [
        3243
    ],
    "kiisanzu": [
        3255
    ],
    "kinyihanzu": [
        3255
    ],
    "kinyisanzu": [
        3255
    ],
    "kamchadal": [
        3270
    ],
    "kamchatka": [
        3270
    ],
    "kim mien": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "kim": [
        3671,
        4824,
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "kimmien": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "keeli": [
        3299
    ],
    "kanamanti": [
        3305
    ],
    "kapaná": [
        3305
    ],
    "kilokaka": [
        3312
    ],
    "kruyol": [
        3315
    ],
    "koenpel": [
        3316
    ],
    "kayani": [
        3320
    ],
    "konchri sain": [
        3336
    ],
    "konchri": [
        3336
    ],
    "ks": [
        3336
    ],
    "krimchak": [
        3337,
        3338
    ],
    "krymchak": [
        3337,
        3338
    ],
    "kuo": [
        8680,
        3349,
        5887
    ],
    "karakir": [
        3354
    ],
    "kasa": [
        3358,
        3379
    ],
    "kaduna": [
        3365
    ],
    "kamau": [
        3372
    ],
    "ku vou": [
        3372
    ],
    "khroskyabs": [
        3373
    ],
    "kijita": [
        3374
    ],
    "kaera": [
        3380
    ],
    "karen, mobwa": [
        3381
    ],
    "kubo": [
        3382
    ],
    "karen, paku": [
        3383
    ],
    "koro (india)": [
        3384
    ],
    "koniya": [
        3385
    ],
    "kimachame": [
        3391
    ],
    "ki-mashami": [
        3391
    ],
    "kimashami": [
        3391
    ],
    "khas kura": [
        3394
    ],
    "khas": [
        3394
    ],
    "kamara": [
        3396
    ],
    "kijoba": [
        3410
    ],
    "kivira": [
        3410
    ],
    "kir": [
        3422,
        3754,
        5029
    ],
    "kagwahibm": [
        3426
    ],
    "kagwahiph": [
        3426
    ],
    "kagwahiv": [
        3426,
        6025
    ],
    "kagwahiva": [
        6025,
        3426,
        4032,
        8013
    ],
    "kavahiva": [
        3426
    ],
    "kawahip": [
        3426
    ],
    "kawaib": [
        3426,
        6022,
        6025,
        8240
    ],
    "kona": [
        3430,
        3436
    ],
    "keru": [
        3449
    ],
    "kartvelian": [
        3452,
        3453,
        3454
    ],
    "karakalpak": [
        3455,
        3456,
        3457
    ],
    "kara-kalpak": [
        3455,
        3456,
        3457
    ],
    "karaklobuk": [
        3455,
        3456,
        3457
    ],
    "klobouki": [
        3455,
        3456,
        3457
    ],
    "kabyl": [
        3458,
        3459,
        3460
    ],
    "kabyle": [
        3458,
        3459,
        3460
    ],
    "kabylia": [
        3458,
        3459,
        3460
    ],
    "kachin": [
        3461,
        6820
    ],
    "ketagalan": [
        3463
    ],
    "ketangalano": [
        3463
    ],
    "katso": [
        3464
    ],
    "kazhuo": [
        3464
    ],
    "kajaman": [
        3465
    ],
    "kajaman-sekapan": [
        3465
    ],
    "kayaman": [
        3465
    ],
    "kejaman": [
        3465
    ],
    "kara": [
        3466,
        4286,
        6495,
        9148,
        3518,
        4119,
        4129,
        4130,
        4131,
        5727
    ],
    "kara (central african republic)": [
        3466
    ],
    "karekare": [
        3467
    ],
    "karai karai": [
        3467
    ],
    "karai": [
        3467
    ],
    "karai-karai": [
        3467
    ],
    "karaikarai": [
        3467
    ],
    "kerekere": [
        3467
    ],
    "kerikeri": [
        3467
    ],
    "kәrekәre": [
        3467
    ],
    "kache": [
        3468
    ],
    "kaje": [
        3468
    ],
    "kajji": [
        3468
    ],
    "kәjju": [
        3468
    ],
    "kalangoya": [
        3469
    ],
    "kalangoya-ikalahan": [
        3469
    ],
    "kayapa kallahan": [
        3469
    ],
    "kikamba": [
        3470
    ],
    "kamba (kenya)": [
        3470
    ],
    "kiikamba": [
        3470
    ],
    "kĩkamba": [
        3470
    ],
    "kĩĩkamba": [
        3470
    ],
    "kasonke": [
        3471
    ],
    "kasso": [
        3471
    ],
    "kasson": [
        3471
    ],
    "kassonke": [
        3471
    ],
    "khasonke": [
        3471
    ],
    "khassonka": [
        3471
    ],
    "khassonké": [
        3471
    ],
    "kapuch": [
        3472
    ],
    "kapucha": [
        3472
    ],
    "kapuchin": [
        3472
    ],
    "kapuchin-gunzib": [
        3472
    ],
    "kapuchuri": [
        3472
    ],
    "kiburabi": [
        3472
    ],
    "kupuca": [
        3472
    ],
    "kapanawa": [
        3473
    ],
    "katukína": [
        3474,
        3840
    ],
    "katukina do jutaí": [
        3474
    ],
    "katukina": [
        3474,
        3840,
        7242
    ],
    "katukina do rio biá": [
        3474
    ],
    "kawi": [
        3475
    ],
    "kao": [
        3476,
        5197,
        5198,
        5200,
        7825,
        7826
    ],
    "ka’u": [
        3476
    ],
    "kamayurá": [
        3477
    ],
    "kamaiurá": [
        3477
    ],
    "kamayirá": [
        3477
    ],
    "kalarko": [
        3478
    ],
    "kalaako": [
        3478
    ],
    "kalaaku": [
        3478
    ],
    "kalako": [
        3478
    ],
    "kalakul": [
        3478
    ],
    "kalarku": [
        3478
    ],
    "kaxuiâna": [
        3479
    ],
    "kachuana": [
        3479
    ],
    "kashujana": [
        3479
    ],
    "kashuyana": [
        3479
    ],
    "katxuyana": [
        3479
    ],
    "katxuyana-xikuyana": [
        3479
    ],
    "kaxuyana-xikuyana": [
        3479
    ],
    "kaxúyana": [
        3479
    ],
    "kadiwéu": [
        3480
    ],
    "kadiweo": [
        3480
    ],
    "kabardian": [
        3481
    ],
    "kabard": [
        3481
    ],
    "kabardin": [
        3481
    ],
    "kabardino-cherkes": [
        3481
    ],
    "kabardo-cherkess": [
        3481
    ],
    "kabardo-cherkessian": [
        3481
    ],
    "kanju": [
        3482
    ],
    "kaanju": [
        3482
    ],
    "kaantyu": [
        3482
    ],
    "kamdhue": [
        3482
    ],
    "kandju": [
        3482
    ],
    "kandyu": [
        3482
    ],
    "kanyu": [
        3482
    ],
    "karnu": [
        3482
    ],
    "khamba": [
        3483,
        3651
    ],
    "khamba khaadi": [
        3483
    ],
    "khaadi": [
        3483
    ],
    "kamemtxa": [
        3484
    ],
    "kamsa": [
        3484
    ],
    "kamse": [
        3484
    ],
    "kamëntsa": [
        3484
    ],
    "kaptiau": [
        3485
    ],
    "kapitiauw": [
        3485
    ],
    "kaptiauw": [
        3485
    ],
    "kari": [
        3486,
        3490,
        6886,
        8010
    ],
    "kare": [
        3490,
        3798,
        3486,
        7651
    ],
    "koiari, grass": [
        3487
    ],
    "koiari": [
        3487,
        3895
    ],
    "kanembu": [
        3488,
        3943,
        7847
    ],
    "kaidi-kanembu": [
        3488
    ],
    "kanambu": [
        3488,
        3943
    ],
    "kanembou": [
        3488
    ],
    "kaiwa": [
        3489
    ],
    "kare (central african republic)": [
        3490
    ],
    "kareng": [
        3490,
        4177
    ],
    "karré": [
        3490
    ],
    "kãrɛ̃": [
        3490
    ],
    "kã́rĩ́": [
        3490
    ],
    "keliko": [
        3491
    ],
    "kẹ̃lị̃kọ́": [
        3491
    ],
    "kaliko": [
        3491
    ],
    "kaliko-ma’di": [
        3491
    ],
    "kabiyè": [
        3492,
        3493
    ],
    "kabɩyɛ": [
        3492,
        3493
    ],
    "kabire": [
        3492,
        3493,
        3508
    ],
    "kabre": [
        3492,
        3493
    ],
    "kabure": [
        3492,
        3493
    ],
    "kabye": [
        3492,
        3493
    ],
    "kabɩyɛ tɔm": [
        3492,
        3493
    ],
    "kamano": [
        3494
    ],
    "kamano-kafe": [
        3494
    ],
    "kafa": [
        3495,
        3496
    ],
    "kande": [
        3497,
        4025
    ],
    "kaande": [
        3497
    ],
    "kabadi": [
        3498
    ],
    "kabutra": [
        3499
    ],
    "kamberataro": [
        3500
    ],
    "kamberatoro": [
        3500
    ],
    "komberatoro": [
        3500
    ],
    "kaiep": [
        3501
    ],
    "kambot": [
        3502
    ],
    "karaube": [
        3502
    ],
    "kanuri, manga": [
        3503,
        3504
    ],
    "kànòrí": [
        3503,
        3504
    ],
    "karfa": [
        3505
    ],
    "kerifa": [
        3505
    ],
    "khanty": [
        3506
    ],
    "kazym-berezover-suryskarer khanty": [
        3506
    ],
    "kazym-berezover-suryskarer": [
        3506
    ],
    "khant": [
        3506
    ],
    "khanti": [
        3506
    ],
    "kawacha": [
        3507
    ],
    "kawatsa": [
        3507
    ],
    "kabila": [
        3508
    ],
    "kanum, ngkâlmpw": [
        3509
    ],
    "kanum": [
        3509,
        3648,
        3949,
        4118
    ],
    "kenume": [
        3509,
        3648,
        4118
    ],
    "knwne": [
        3509,
        3648,
        4118
    ],
    "kaivi": [
        3510
    ],
    "kaibi": [
        3510
    ],
    "katab": [
        3512
    ],
    "kataf": [
        3512
    ],
    "kiballo": [
        3513
    ],
    "kiwollo": [
        3513
    ],
    "kamantan": [
        3514
    ],
    "kamanton": [
        3514
    ],
    "kobiana": [
        3515
    ],
    "kalagan": [
        3775,
        3902,
        3516,
        3770
    ],
    "kalaka": [
        3516
    ],
    "kalana": [
        3516
    ],
    "kanana": [
        3516
    ],
    "kala": [
        3517,
        5188,
        4742,
        4743,
        6364
    ],
    "kela": [
        3569,
        3517
    ],
    "kela (papua new guinea)": [
        3517
    ],
    "kara de soudan": [
        3518
    ],
    "kara of sudan": [
        3518
    ],
    "ki-nubi": [
        3519
    ],
    "kinubi": [
        3519
    ],
    "kinalakna": [
        3520
    ],
    "kanga": [
        3521
    ],
    "kamo": [
        3522
    ],
    "katla": [
        3523
    ],
    "koenoem": [
        3524
    ],
    "kanam": [
        3524
    ],
    "kanem": [
        3524
    ],
    "korenoem": [
        3524
    ],
    "kaian": [
        3525
    ],
    "kayan na yon": [
        3525
    ],
    "kami (tanzania)": [
        3526
    ],
    "kikami": [
        3526
    ],
    "kete": [
        3527
    ],
    "kikete": [
        3527
    ],
    "kabwari": [
        3528
    ],
    "kachama-ganjule": [
        3529
    ],
    "korandje": [
        3530
    ],
    "kwarandzyey": [
        3530
    ],
    "konongo": [
        3531
    ],
    "kikonongo": [
        3531
    ],
    "kattang": [
        3532
    ],
    "kutu": [
        3533,
        8774
    ],
    "khutu": [
        3533
    ],
    "kikutu": [
        3533
    ],
    "kixutu": [
        3533
    ],
    "kulpantja": [
        3534
    ],
    "kimakonde": [
        3535
    ],
    "konde": [
        3535,
        5811
    ],
    "kakuna": [
        3536
    ],
    "kotokoli": [
        3538,
        3539
    ],
    "kumam": [
        3540
    ],
    "kuman": [
        4018,
        6433,
        3540
    ],
    "kumum": [
        3540
    ],
    "karamojong": [
        3541
    ],
    "karimojong": [
        3541
    ],
    "karimonjong": [
        3541
    ],
    "kapone": [
        3542
    ],
    "kunie": [
        3542
    ],
    "kwényi": [
        3542
    ],
    "kimba": [
        3543
    ],
    "kagoma": [
        3544
    ],
    "kwong": [
        3544,
        4053
    ],
    "kaningdom-nindem": [
        3546
    ],
    "kaningdon-nindem": [
        3546
    ],
    "kaningkom-nindem": [
        3546
    ],
    "kaningkon-nindem": [
        3546
    ],
    "kaninkom-nindem": [
        3546
    ],
    "kaninkon-nindem": [
        3546
    ],
    "koch": [
        3547,
        6531,
        6537
    ],
    "koc": [
        3547
    ],
    "kocch": [
        3547
    ],
    "koce": [
        3547
    ],
    "kocha": [
        3547
    ],
    "kochboli": [
        3547
    ],
    "konch": [
        3547
    ],
    "karaim": [
        3548,
        3549
    ],
    "karaite": [
        3548,
        3549
    ],
    "karaj tili": [
        3548,
        3549
    ],
    "karaj": [
        3548,
        3549
    ],
    "kedar": [
        3548,
        3549
    ],
    "kuay": [
        3550,
        3551,
        3552
    ],
    "khamen-boran": [
        3550,
        3551,
        3552
    ],
    "kouy": [
        3550,
        3551,
        3552
    ],
    "kui souei": [
        3550,
        3551,
        3552
    ],
    "kuoy": [
        3550,
        3551,
        3552
    ],
    "kuy": [
        3550,
        3551,
        3552,
        7935
    ],
    "kadaru": [
        3553
    ],
    "kadaro": [
        3553
    ],
    "kadero": [
        3553
    ],
    "kaderu": [
        3553
    ],
    "kodhin": [
        3553
    ],
    "kodhinniai": [
        3553
    ],
    "kodoro": [
        3553
    ],
    "koneraw": [
        3554
    ],
    "konorau": [
        3554
    ],
    "keijar": [
        3556
    ],
    "keder": [
        3556
    ],
    "kwaja": [
        3557
    ],
    "kabuverdianu": [
        3558
    ],
    "krioulu": [
        3558
    ],
    "kélé": [
        3559
    ],
    "kili": [
        3559,
        3668
    ],
    "kele": [
        3668,
        6693,
        3559
    ],
    "keiga": [
        3560,
        3564
    ],
    "kayigang": [
        3560
    ],
    "kayikang": [
        3560
    ],
    "keiga-al-kheil": [
        3560
    ],
    "keiga-timero": [
        3560
    ],
    "kerewe": [
        3561
    ],
    "kerebe": [
        3561
    ],
    "kikerebe": [
        3561
    ],
    "kikerewe": [
        3561
    ],
    "keres, eastern": [
        3562
    ],
    "keres": [
        3562,
        3719
    ],
    "keresan": [
        3562
    ],
    "kpessi": [
        3563
    ],
    "kpesi": [
        3563
    ],
    "kpetchi": [
        3563
    ],
    "kpési": [
        3563
    ],
    "kpétsi": [
        3563
    ],
    "keiga girru": [
        3564
    ],
    "keiga jirru": [
        3564
    ],
    "keak": [
        3565
    ],
    "kwaruwikwundi": [
        3565
    ],
    "kei": [
        3566
    ],
    "kai": [
        8616,
        3566,
        3799,
        4003,
        5190,
        5632,
        7370,
        3642
    ],
    "keiese": [
        3566
    ],
    "kadar": [
        3567
    ],
    "kadir": [
        3567
    ],
    "kekchi’": [
        3568
    ],
    "kekchí": [
        3568
    ],
    "ketchi": [
        3568
    ],
    "ketchi’": [
        3568
    ],
    "kʼekchiʼ": [
        3568
    ],
    "kela (democratic republic of congo)": [
        3569
    ],
    "kemak": [
        3570
    ],
    "kenyang": [
        3571
    ],
    "kɛnyaŋ": [
        3571
    ],
    "kakwa": [
        3572
    ],
    "kakuwâ": [
        3572
    ],
    "kakwak": [
        3572
    ],
    "kwakwak": [
        3572
    ],
    "kaikadi": [
        3573
    ],
    "kaikadia": [
        3573
    ],
    "kaikai": [
        3573
    ],
    "kokadi": [
        3573
    ],
    "kamar": [
        3574,
        3614
    ],
    "kera": [
        3575
    ],
    "keera": [
        3575
    ],
    "kere": [
        3575
    ],
    "kugbo": [
        3576
    ],
    "ket": [
        3577
    ],
    "kabu": [
        3578
    ],
    "kebu": [
        5372,
        3578
    ],
    "kegberike": [
        3578
    ],
    "kébou": [
        3578
    ],
    "kǝkpǝǝ-kǝ": [
        3578
    ],
    "kekpeerike": [
        3578
    ],
    "kanikkaran": [
        3579,
        3580
    ],
    "kanikkar": [
        3579,
        3580
    ],
    "kannikan": [
        3579,
        3580
    ],
    "kannikaran": [
        3579,
        3580
    ],
    "kannikharan": [
        3579,
        3580
    ],
    "kewa, west": [
        3581
    ],
    "kewa": [
        3581,
        3726,
        3721
    ],
    "kukna": [
        3582,
        3583
    ],
    "kanara konkani": [
        3582,
        3583
    ],
    "kokna": [
        3582,
        3583
    ],
    "kokni": [
        3582,
        3583
    ],
    "kupia": [
        3584
    ],
    "kukele": [
        3585
    ],
    "kodava": [
        3586
    ],
    "kadagi": [
        3586
    ],
    "khurgi": [
        3586
    ],
    "kodagu": [
        3586
    ],
    "kotagu": [
        3586
    ],
    "kurja": [
        3586
    ],
    "kurug": [
        3586
    ],
    "kolami, northwestern": [
        3587
    ],
    "kolami": [
        3587,
        5485
    ],
    "kolam": [
        3587
    ],
    "kolamboli": [
        3587
    ],
    "kolamy": [
        3587
    ],
    "kolmi": [
        3587
    ],
    "kulme": [
        3587
    ],
    "konda-dora": [
        3588
    ],
    "konda": [
        3823,
        3588
    ],
    "kubi": [
        3855,
        3588
    ],
    "koraga, korra": [
        3589
    ],
    "koraga": [
        3589,
        8107
    ],
    "koragar": [
        3589
    ],
    "koragara": [
        3589
    ],
    "korangi": [
        3589
    ],
    "korra koraga": [
        3589
    ],
    "knof": [
        3590
    ],
    "kohatur": [
        3590
    ],
    "kota (india)": [
        3590
    ],
    "kotar": [
        3590
    ],
    "kotha": [
        3590
    ],
    "kother-tamil": [
        3590
    ],
    "kotta": [
        3590
    ],
    "kov": [
        3590
    ],
    "kowe-adiwasi": [
        3590
    ],
    "kuof": [
        3590
    ],
    "kavor": [
        3591,
        3592,
        3593,
        3594
    ],
    "koa": [
        3591,
        3592,
        3593,
        3594
    ],
    "koi": [
        3591,
        3592,
        3593,
        3594,
        3756,
        3901
    ],
    "koi gondi": [
        3591,
        3592,
        3593,
        3594
    ],
    "koitar": [
        3591,
        3592,
        3593,
        3594
    ],
    "koyato": [
        3591,
        3592,
        3593,
        3594
    ],
    "koyi": [
        3591,
        3592,
        3593,
        3594,
        3756
    ],
    "kudiya": [
        3595,
        3596
    ],
    "kurku": [
        3595,
        3596,
        3608
    ],
    "kurichiya": [
        3597
    ],
    "kowohans": [
        3597
    ],
    "kurichchan": [
        3597
    ],
    "kurichchia": [
        3597
    ],
    "kurichia": [
        3597
    ],
    "kurichiyars": [
        3597
    ],
    "kuruchans": [
        3597
    ],
    "kurumba, kannada": [
        3598,
        3599
    ],
    "kurumba": [
        3598,
        3599,
        3874,
        6176,
        8669,
        8670,
        8671,
        8672,
        8675,
        3619
    ],
    "kannada": [
        3818,
        3819,
        3820,
        3598,
        3599,
        8669,
        8675
    ],
    "kannada kurumba": [
        3598,
        3599
    ],
    "korambar": [
        3598,
        3599
    ],
    "kuramwari": [
        3598,
        3599
    ],
    "kuremban": [
        3598,
        3599
    ],
    "kuruba": [
        3598,
        3599
    ],
    "kuruban": [
        3598,
        3599
    ],
    "kurubar": [
        3598,
        3599
    ],
    "kurubas kuruma": [
        3598,
        3599
    ],
    "kurubas": [
        3598,
        3599
    ],
    "kuruma": [
        3619,
        3598,
        3599
    ],
    "kuruman": [
        3598,
        3599
    ],
    "kurumans": [
        3598,
        3599
    ],
    "kurumar": [
        3598,
        3599
    ],
    "kurumban": [
        3598,
        3599
    ],
    "kurumbar": [
        3598,
        3599
    ],
    "kurumbas": [
        3598,
        3599
    ],
    "kurumvari": [
        3598,
        3599
    ],
    "kemiehua": [
        3600
    ],
    "kanaury anuskad": [
        3601,
        3602
    ],
    "kanaury": [
        3601,
        3602
    ],
    "kanawari": [
        3601,
        3602
    ],
    "kanawi": [
        3601,
        3602
    ],
    "kanoreunu skad": [
        3601,
        3602
    ],
    "kanoreunu": [
        3601,
        3602
    ],
    "kanorin skad": [
        3601,
        3602
    ],
    "kanorin": [
        3601,
        3602
    ],
    "kanorug skadd": [
        3601,
        3602
    ],
    "kanorug": [
        3601,
        3602
    ],
    "kinnaura yanuskad": [
        3601,
        3602
    ],
    "kinnaura": [
        3601,
        3602
    ],
    "kinner": [
        3601,
        3602
    ],
    "kinori": [
        3601,
        3602
    ],
    "koonawure": [
        3601,
        3602
    ],
    "kunawari": [
        3601,
        3602
    ],
    "kunawur": [
        3601,
        3602
    ],
    "kung": [
        3603,
        8052,
        3843,
        4006
    ],
    "khunsari": [
        3604
    ],
    "khunsaric": [
        3604
    ],
    "kuk": [
        3605,
        3604
    ],
    "koro (côte d'ivoire)": [
        3606
    ],
    "koro jula": [
        3606
    ],
    "korwa": [
        3607,
        3980
    ],
    "korku": [
        3608
    ],
    "korki": [
        3608
    ],
    "kuri": [
        5321,
        3608
    ],
    "kacchi": [
        3609,
        3610
    ],
    "kachchhi": [
        3609,
        3610
    ],
    "kachchi": [
        3609,
        3610
    ],
    "kachhi": [
        3609,
        3610
    ],
    "katch": [
        3609,
        3610
    ],
    "kautchy": [
        3609,
        3610
    ],
    "kutchchi": [
        3609,
        3610
    ],
    "kutchi": [
        3609,
        3610
    ],
    "kutchie": [
        3609,
        3610
    ],
    "kahluri": [
        3611
    ],
    "kehloori pahari": [
        3611
    ],
    "kehloori": [
        3611
    ],
    "kehluri": [
        3611
    ],
    "kanjari": [
        3612
    ],
    "kagari": [
        3612
    ],
    "kangar bhat": [
        3612
    ],
    "kangar": [
        3612
    ],
    "kangri": [
        8567,
        3612
    ],
    "kanjri": [
        3612
    ],
    "katkari": [
        3613
    ],
    "katakari": [
        3613
    ],
    "katari": [
        3613
    ],
    "kathodi": [
        3613,
        3832,
        3833,
        3861
    ],
    "katvadi": [
        3613,
        3832,
        3833,
        3861
    ],
    "kurmukar": [
        3614
    ],
    "karmakar": [
        3614
    ],
    "karmokar": [
        3614
    ],
    "kumbhakar": [
        3614
    ],
    "kumhar": [
        3614
    ],
    "kharam": [
        3615
    ],
    "kharam naga": [
        3615
    ],
    "kullu": [
        3616,
        3617
    ],
    "kauli": [
        3616,
        3617
    ],
    "kullu pahari": [
        3616,
        3617
    ],
    "kullui": [
        3616,
        3617
    ],
    "kulu boli": [
        3616,
        3617
    ],
    "kulu pahari": [
        3616,
        3617
    ],
    "kului": [
        3616,
        3617
    ],
    "kulvi": [
        3616,
        3617
    ],
    "kulwali": [
        3616,
        3617
    ],
    "kumaoni": [
        3618
    ],
    "kamaoni": [
        3618
    ],
    "kumau": [
        3618
    ],
    "kumauni": [
        3618
    ],
    "kumawani": [
        3618
    ],
    "kumgoni": [
        3618
    ],
    "kumman": [
        3618
    ],
    "kunayaoni": [
        3618
    ],
    "koromfé": [
        3619
    ],
    "kouroumba": [
        3619
    ],
    "kurum-korey": [
        3619
    ],
    "kurumfe": [
        3619
    ],
    "kongo": [
        3620,
        4096
    ],
    "kikongo": [
        3620,
        4001,
        4096
    ],
    "kikoongo": [
        3620,
        4096,
        4868
    ],
    "kongo-nseke": [
        3620
    ],
    "koongo": [
        3620
    ],
    "koyaga": [
        3621
    ],
    "koyaa": [
        3621
    ],
    "koyaga jula": [
        3621
    ],
    "koyagakan": [
        3621
    ],
    "koyaka": [
        3621
    ],
    "koyara": [
        3621
    ],
    "kawe": [
        3622
    ],
    "komering": [
        3623
    ],
    "kumoring": [
        3623
    ],
    "kube": [
        3624
    ],
    "kulungtfu-yuanggeng-tobo": [
        3624
    ],
    "kusunda": [
        3625
    ],
    "kusanda": [
        3625
    ],
    "klsl": [
        3626
    ],
    "kuala lumpur sign language": [
        3626
    ],
    "kham, gamale": [
        3627
    ],
    "kham-magar": [
        3627,
        3676,
        3684,
        3709
    ],
    "kaiwá": [
        3628
    ],
    "kaingwá": [
        3628
    ],
    "kaiova": [
        3628,
        6341
    ],
    "kaiowá": [
        3628
    ],
    "kayova": [
        3628
    ],
    "kunggari": [
        3629,
        4372
    ],
    "kungkari": [
        4372,
        3629
    ],
    "karipúna": [
        3630,
        3813
    ],
    "karipuna do amapá": [
        3630
    ],
    "karipuna": [
        3813,
        4032,
        3630
    ],
    "karipuna do uaçá": [
        3630
    ],
    "karingani": [
        3631
    ],
    "keringani": [
        3631
    ],
    "krongo": [
        3632
    ],
    "kadumodi": [
        3632
    ],
    "korongo": [
        3632
    ],
    "kurungu": [
        3632
    ],
    "kaingang": [
        3633,
        8579
    ],
    "kanhgág": [
        3633
    ],
    "kamoro": [
        3634
    ],
    "kamora": [
        3634
    ],
    "kaokonau": [
        3634
    ],
    "karon": [
        3640,
        3947,
        3635
    ],
    "kumbainggar": [
        3636
    ],
    "kumbaingeri": [
        3636
    ],
    "kumbainggiri": [
        3636
    ],
    "kila": [
        3637
    ],
    "kobol": [
        3638
    ],
    "koguman": [
        3638
    ],
    "karas": [
        3639
    ],
    "karon dori": [
        3640
    ],
    "kamaru": [
        3641
    ],
    "kyerung": [
        3642
    ],
    "kyerong": [
        3642
    ],
    "kyirong": [
        3642
    ],
    "kyirong kai": [
        3642
    ],
    "kyirong-nga": [
        3642
    ],
    "kyirung": [
        3642
    ],
    "kahasi": [
        3643,
        3644
    ],
    "kassi": [
        3643,
        3644
    ],
    "khasa": [
        3643,
        3644
    ],
    "khashi": [
        3643,
        3644
    ],
    "khasie": [
        3643,
        3644
    ],
    "khasiyas": [
        3643,
        3644
    ],
    "khassee": [
        3643,
        3644
    ],
    "khuchia": [
        3643,
        3644
    ],
    "kanum, bädi": [
        3648
    ],
    "korowai": [
        3649
    ],
    "kolufaup": [
        3649
    ],
    "khuen": [
        3650,
        3743
    ],
    "khouen": [
        3650
    ],
    "khween": [
        3650
    ],
    "kween": [
        3650
    ],
    "khams": [
        3651
    ],
    "khampa": [
        3651
    ],
    "khams bhotia": [
        3651
    ],
    "khams tibetan": [
        3651
    ],
    "khams-yal": [
        3651
    ],
    "kehu": [
        3652
    ],
    "keuw": [
        3652
    ],
    "kuturmi": [
        3653
    ],
    "kaliai": [
        3654
    ],
    "kaliai-kove": [
        3654
    ],
    "khandesi": [
        3655
    ],
    "khandeshi": [
        3655
    ],
    "khandeshi bhili": [
        3655
    ],
    "khandish": [
        3655
    ],
    "khotanese": [
        3656,
        3657
    ],
    "kapauri": [
        3658
    ],
    "kapori": [
        3658
    ],
    "koyra": [
        3659,
        6792
    ],
    "koyra ciini": [
        3659
    ],
    "koyra chiini songhay": [
        3659
    ],
    "kharia": [
        3660,
        3661,
        3979
    ],
    "khadia": [
        3660,
        3661
    ],
    "khadiya": [
        3660,
        3661
    ],
    "khariya": [
        3660,
        3661
    ],
    "kharvi": [
        3660,
        3661
    ],
    "khatria": [
        3660,
        3661
    ],
    "khaɽiyā": [
        3660,
        3661
    ],
    "kheria": [
        3660,
        3661,
        3979
    ],
    "kasua": [
        3662
    ],
    "khamti": [
        3663
    ],
    "kam ti": [
        3663
    ],
    "kham-tai": [
        3663
    ],
    "khampti": [
        3663
    ],
    "khampti sam": [
        3663
    ],
    "khampti shan": [
        3663
    ],
    "khamti shan": [
        3663
    ],
    "khandi shan": [
        3663
    ],
    "khandi": [
        3663
    ],
    "khantis": [
        3663
    ],
    "khumbi": [
        3664
    ],
    "khvarshi": [
        3665
    ],
    "khvarsh": [
        3665
    ],
    "khvarshin": [
        3665
    ],
    "khowar": [
        3666
    ],
    "kashkari": [
        3666
    ],
    "khawar": [
        3666
    ],
    "kanu": [
        3667
    ],
    "kaanu": [
        3667
    ],
    "kano": [
        3667
    ],
    "kele (democratic republic of congo)": [
        3668
    ],
    "keapara": [
        3669
    ],
    "keopara": [
        3669
    ],
    "kikuyu": [
        3670
    ],
    "koalib": [
        3672
    ],
    "kandiza kethi koalib": [
        3672
    ],
    "kandiza": [
        3672
    ],
    "kethi": [
        3672
    ],
    "kawaaliib": [
        3672
    ],
    "kawalib": [
        3672
    ],
    "kowalib": [
        3672
    ],
    "kwɐ̀ɐlîp": [
        3672
    ],
    "kickapoo": [
        3673
    ],
    "kicapoux": [
        3673
    ],
    "kicapus": [
        3673
    ],
    "kikabeeux": [
        3673
    ],
    "kikapaux": [
        3673
    ],
    "kikapoo": [
        3673
    ],
    "kikapú": [
        3673
    ],
    "koshin": [
        3674
    ],
    "kaw": [
        3674,
        3964,
        5009
    ],
    "kosin": [
        3674
    ],
    "kusheen benubcouh": [
        3674
    ],
    "kusheen": [
        3674
    ],
    "kibet": [
        3675
    ],
    "kaben": [
        3675
    ],
    "kabentang": [
        3675
    ],
    "kibeet": [
        3675
    ],
    "kibeit": [
        3675
    ],
    "kham, eastern parbate": [
        3676
    ],
    "kimaghima": [
        3677
    ],
    "kaladdarsch": [
        3677
    ],
    "kimaama": [
        3677
    ],
    "kimaghama": [
        3677
    ],
    "kimaghana": [
        3677
    ],
    "kilmeri": [
        3678
    ],
    "kilmera": [
        3678
    ],
    "kitsai": [
        3679
    ],
    "kichai": [
        3679
    ],
    "kilivila": [
        3680
    ],
    "kiriwina": [
        3680
    ],
    "kariyu": [
        3681
    ],
    "kauyawa": [
        3681
    ],
    "keriya": [
        3681
    ],
    "karagas": [
        3682
    ],
    "kamas": [
        8406,
        3682
    ],
    "karagass": [
        3682
    ],
    "kham, sheshi": [
        3684
    ],
    "kosare": [
        3685
    ],
    "kosadle": [
        3685
    ],
    "kis": [
        3686
    ],
    "kirmanjki": [
        3688,
        9186,
        9187
    ],
    "kirmanjki (individual language)": [
        3688
    ],
    "kırmancki": [
        3688
    ],
    "kimbu": [
        3689
    ],
    "kikimbu": [
        3689
    ],
    "kiwai, northeast": [
        3690
    ],
    "khiamniungan": [
        3691
    ],
    "kalyokengnyu": [
        3691
    ],
    "khiamngan": [
        3691
    ],
    "khiamniungan naga": [
        3691
    ],
    "khiemnungan": [
        3691
    ],
    "kirikiri": [
        3692
    ],
    "kirira": [
        3692
    ],
    "kisi": [
        3693,
        3972,
        3916
    ],
    "kese": [
        3693
    ],
    "kikisi": [
        3693
    ],
    "kwanyama": [
        3694,
        3695
    ],
    "kuanjama": [
        3694,
        3695
    ],
    "kuanyama": [
        3694,
        3695
    ],
    "kwancama": [
        3694,
        3695
    ],
    "kwanjama": [
        3694,
        3695
    ],
    "kuangsu-bonggrang": [
        3696
    ],
    "kwangsu-bonggrang": [
        3696
    ],
    "kwansu": [
        3696
    ],
    "kwansu-bonggrang": [
        3696
    ],
    "kanjobal": [
        3827,
        3697
    ],
    "kanhobal": [
        3697
    ],
    "k’anjobal": [
        3697
    ],
    "konjo, coastal": [
        3698
    ],
    "konjo": [
        3698,
        3708,
        3863
    ],
    "kondjo": [
        3698
    ],
    "kiwai, southern": [
        3699
    ],
    "kisar": [
        3700
    ],
    "khalaj [indo-iranian]": [
        3701
    ],
    "khalaj": [
        3701,
        3773
    ],
    "kamhmu": [
        3702,
        3703,
        3704
    ],
    "kammu": [
        3702,
        3703,
        3704
    ],
    "kemu": [
        3702,
        3703,
        3704
    ],
    "kha cau": [
        3702,
        3703,
        3704
    ],
    "kha khmu": [
        3702,
        3703,
        3704
    ],
    "khamu": [
        3702,
        3703,
        3704
    ],
    "khamuk": [
        3702,
        3703,
        3704
    ],
    "khmu’": [
        3702,
        3703,
        3704
    ],
    "kho mu": [
        3702,
        3703,
        3704
    ],
    "khomu": [
        3702,
        3703,
        3704
    ],
    "kmhmu": [
        3702,
        3703,
        3704
    ],
    "khakas": [
        3705
    ],
    "ka’erkezi": [
        3705
    ],
    "khakhas": [
        3705
    ],
    "khakhass": [
        3705
    ],
    "kirghiz": [
        4129,
        4130,
        4131,
        3705
    ],
    "khinalugh": [
        3707
    ],
    "khinalug": [
        3707
    ],
    "khinalugi": [
        3707
    ],
    "konjo, highland": [
        3708
    ],
    "konjo pegunungan": [
        3708
    ],
    "konyo": [
        3708
    ],
    "kham, western parbate": [
        3709
    ],
    "kháng": [
        3710
    ],
    "khaang": [
        3710
    ],
    "ksakautenh": [
        3710
    ],
    "kunjen": [
        3711,
        5894
    ],
    "kukumindjen": [
        3711
    ],
    "kinnauri, pahari": [
        3712
    ],
    "karen, pwo eastern": [
        3713,
        3714,
        3715,
        3716,
        3717,
        3718
    ],
    "karen, pwo west-central thailand": [
        3718,
        3713,
        3714,
        3715,
        3716,
        3717
    ],
    "keres, western": [
        3719
    ],
    "kurudu": [
        3720
    ],
    "kewapi": [
        3721
    ],
    "karen, phrae pwo": [
        3722
    ],
    "kashaya": [
        3723
    ],
    "kaikavian literary language": [
        3724
    ],
    "kaikavian": [
        3724
    ],
    "kereaka": [
        3725
    ],
    "keriaka": [
        3725
    ],
    "kewa south": [
        3726
    ],
    "kebumtamp": [
        3727
    ],
    "kazakh": [
        3728,
        3729,
        3730,
        3731,
        3732,
        3733,
        3734
    ],
    "kaisak": [
        3728,
        3730,
        3731,
        3733,
        3734
    ],
    "kazak": [
        3728,
        3730,
        3731,
        3732,
        3733
    ],
    "kazakhi": [
        3728,
        3730,
        3731,
        3732,
        3733,
        3734
    ],
    "kazax": [
        3728,
        3730,
        3731,
        3733,
        3734
    ],
    "kosach": [
        3728,
        3730,
        3731,
        3733,
        3734
    ],
    "kz": [
        3728,
        3730,
        6614,
        7917
    ],
    "kazakhstan": [
        3728,
        3730,
        6614,
        7917
    ],
    "kakanda": [
        3735
    ],
    "kwerisa": [
        3736
    ],
    "kalamo": [
        3737
    ],
    "kinuku": [
        3738
    ],
    "kinugu": [
        3738
    ],
    "kinuka": [
        3738
    ],
    "kakabe": [
        3739,
        3740
    ],
    "kule": [
        3739,
        3740
    ],
    "kalaktang": [
        3741
    ],
    "kalaktang monpa": [
        3741
    ],
    "kalinga, mabaka valley": [
        3742
    ],
    "kalinga": [
        3742,
        3796,
        3803,
        3804,
        3822,
        3956,
        4133
    ],
    "kal-uwan": [
        3742
    ],
    "khün": [
        3743
    ],
    "khun shan": [
        3743
    ],
    "khun": [
        3743,
        6508
    ],
    "khyn": [
        3743
    ],
    "kagulu": [
        3744
    ],
    "kaguru": [
        3744
    ],
    "kigaguru": [
        3744
    ],
    "kikagulu": [
        3744
    ],
    "kiningo": [
        3744
    ],
    "kako": [
        3745,
        3746
    ],
    "kakɔ": [
        3745,
        3746
    ],
    "kaka": [
        3745
    ],
    "kokota": [
        3747
    ],
    "kosarek": [
        3748
    ],
    "kosarek yale": [
        3748
    ],
    "kiong": [
        3749,
        6244
    ],
    "kon keu": [
        3750
    ],
    "kon": [
        3750,
        7577,
        9015
    ],
    "keu": [
        3750
    ],
    "kong ge": [
        3750
    ],
    "kongge": [
        3750
    ],
    "karko": [
        3751
    ],
    "kaak": [
        3751
    ],
    "kakenbi": [
        3751
    ],
    "karme": [
        3751
    ],
    "kithonirishe": [
        3751
    ],
    "koko-bera": [
        3752
    ],
    "kok kaber": [
        3752
    ],
    "kaber": [
        3752
    ],
    "kok-kaper": [
        3752
    ],
    "koko pera": [
        3752
    ],
    "kukubera": [
        3752
    ],
    "kaiku": [
        3753
    ],
    "kaeku": [
        3753
    ],
    "kaiko": [
        3753
    ],
    "kir-balar": [
        3754
    ],
    "kirr": [
        3754
    ],
    "kirfi": [
        3755
    ],
    "kirifawa": [
        3755
    ],
    "kirifi": [
        3755
    ],
    "koyee": [
        3756
    ],
    "kohi": [
        3756
    ],
    "koi ba’a": [
        3756
    ],
    "koyi rai": [
        3756
    ],
    "koyu": [
        3756
    ],
    "kitimi": [
        3757
    ],
    "kangean": [
        3758
    ],
    "kikuwa": [
        3759
    ],
    "kikuya": [
        3759
    ],
    "koukouya": [
        3759
    ],
    "kukua": [
        3759
    ],
    "kukuya": [
        3759,
        5162
    ],
    "kukwa": [
        3759
    ],
    "kohin": [
        3760
    ],
    "koko imudji": [
        3761
    ],
    "kukuyimidir": [
        3761
    ],
    "kaska": [
        3762
    ],
    "kaska dena": [
        3762
    ],
    "kalaallisut": [
        3763
    ],
    "klamath-modoc": [
        3764
    ],
    "klamath": [
        3764
    ],
    "kiliwa": [
        3765
    ],
    "kiliwi": [
        3765
    ],
    "ko’lew": [
        3765
    ],
    "kolbila": [
        3766
    ],
    "kolbilari": [
        3766
    ],
    "kolbili": [
        3766
    ],
    "kolbilla": [
        3766
    ],
    "kolena": [
        3766
    ],
    "kamilaroi": [
        3767
    ],
    "kholung": [
        3768
    ],
    "khulung": [
        3768
    ],
    "khulunge rai": [
        3768
    ],
    "khulunge": [
        3768
    ],
    "kulu ring": [
        3768
    ],
    "kulung (nepal)": [
        3768
    ],
    "kulunge": [
        3768
    ],
    "kendeje": [
        3769
    ],
    "karangi": [
        3771
    ],
    "kalumpang": [
        3772
    ],
    "kono": [
        3774,
        3834,
        3841,
        4061,
        4062
    ],
    "kono (nigeria)": [
        3774
    ],
    "konu": [
        3774
    ],
    "kwono": [
        3774
    ],
    "kalagan, kagan": [
        3775
    ],
    "kagan": [
        3775
    ],
    "kaagan": [
        3775,
        3902
    ],
    "kagan kalagan": [
        3775
    ],
    "kolom": [
        3776
    ],
    "kalenjin": [
        3777,
        5482,
        6808
    ],
    "kapya": [
        3778
    ],
    "kamasa": [
        3779
    ],
    "kai-iri": [
        3780
    ],
    "kairi": [
        3780,
        4681
    ],
    "kibiri": [
        6293,
        3780
    ],
    "khaling": [
        3781
    ],
    "khael baat": [
        3781
    ],
    "khael": [
        3781
    ],
    "khael bra": [
        3781
    ],
    "khael braa": [
        3781
    ],
    "khaling kura": [
        3781
    ],
    "khalinge rai": [
        3781
    ],
    "khalinge": [
        3781
    ],
    "kalasha": [
        3782,
        3783,
        8182
    ],
    "kalash": [
        3782,
        3783
    ],
    "kalashamon": [
        3782,
        3783
    ],
    "kalashamond": [
        3782,
        3783
    ],
    "kalashamondr": [
        3782,
        3783
    ],
    "kalashi": [
        3782,
        3783
    ],
    "kal’as’amon": [
        3782,
        3783
    ],
    "komutu": [
        3784
    ],
    "klao": [
        3785
    ],
    "klaoh": [
        3785
    ],
    "kuliviu": [
        3786
    ],
    "koluwawa": [
        3788
    ],
    "kalokalo": [
        3788
    ],
    "kalao": [
        3789
    ],
    "kalaotoa": [
        3789
    ],
    "kabola": [
        3790
    ],
    "khmer nam bo": [
        3791
    ],
    "kho me": [
        3791
    ],
    "khome": [
        3791
    ],
    "krom": [
        3791
    ],
    "konni": [
        3792
    ],
    "kɔmɩŋ": [
        3792
    ],
    "komung": [
        3792
    ],
    "koni": [
        3792
    ],
    "kɔnni": [
        3792
    ],
    "kimbundo": [
        3793
    ],
    "kalinga, majukayang": [
        3796
    ],
    "kare (papua new guinea)": [
        3798
    ],
    "kâte": [
        3799
    ],
    "kâte dong": [
        3799
    ],
    "kâte dâŋ": [
        3799
    ],
    "karam": [
        3800
    ],
    "kotp": [
        3800
    ],
    "kami (nigeria)": [
        3801
    ],
    "kumarbhag paharia": [
        3802
    ],
    "kumarbhag": [
        3802
    ],
    "kumar": [
        3802
    ],
    "kalinga, limos": [
        3803
    ],
    "kalinga, tanudan": [
        3804
    ],
    "kom (india)": [
        3805
    ],
    "kom rem": [
        3805
    ],
    "kom-tong": [
        3805
    ],
    "kamnum": [
        3806
    ],
    "kwoma": [
        3807
    ],
    "koma kompana": [
        3808
    ],
    "kompana": [
        3808
    ],
    "kompara": [
        3808
    ],
    "kamasau": [
        3810
    ],
    "kemtuik": [
        3811
    ],
    "kamtuk": [
        3811
    ],
    "kemtuk": [
        3811
    ],
    "kanite": [
        3812
    ],
    "karipuna french creole": [
        3813
    ],
    "karipúna creole french": [
        3813
    ],
    "komo": [
        3814,
        8580,
        8581
    ],
    "kikomo": [
        3814
    ],
    "kikumo": [
        3814
    ],
    "kikumu": [
        3814
    ],
    "kikuumu": [
        3814
    ],
    "komo (democratic republic of congo)": [
        3814
    ],
    "kumo": [
        3814
    ],
    "kumu": [
        3814
    ],
    "kuumu": [
        3814
    ],
    "kuma": [
        3816
    ],
    "khorasani turkish": [
        3817
    ],
    "khorasani": [
        3817,
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kanarese": [
        3818,
        3819,
        3820
    ],
    "kanakuru": [
        3821
    ],
    "kalinga, lubuagan": [
        3822
    ],
    "kankanaey": [
        3824
    ],
    "kankanai": [
        3824
    ],
    "kankanay": [
        8564,
        3824
    ],
    "kanufi": [
        3826
    ],
    "karshi": [
        3826
    ],
    "k'anjob'al": [
        3827
    ],
    "kanjobal de san miguel acatán": [
        3827
    ],
    "kanjobal, western": [
        3827
    ],
    "kuti’": [
        3827
    ],
    "k’anjob’al": [
        3827
    ],
    "kuranko": [
        3828,
        3829
    ],
    "koranko": [
        3828,
        3829
    ],
    "keninjal": [
        3830
    ],
    "kaninjal": [
        3830
    ],
    "kaninjal dayak": [
        3830
    ],
    "kanamarí": [
        3831,
        3840
    ],
    "kanamaré": [
        3831
    ],
    "konkan": [
        3832,
        3833,
        3861
    ],
    "konkan standard": [
        3832,
        3833,
        3861
    ],
    "konkanese": [
        3832,
        3833,
        3861
    ],
    "konkani (individual language)": [
        3832,
        3833
    ],
    "konkani mangalorean": [
        3832,
        3833,
        3861
    ],
    "kunabi": [
        3832,
        3833,
        3861
    ],
    "konnoh": [
        3834
    ],
    "kono (sierra leone)": [
        3834
    ],
    "kɔnɔ": [
        3834
    ],
    "kwanja": [
        3835
    ],
    "kwànjâ": [
        3835
    ],
    "kondja": [
        3835
    ],
    "konja": [
        3835
    ],
    "kintaq": [
        3836
    ],
    "kenta": [
        3836
    ],
    "kintak": [
        3836
    ],
    "kintaq bong": [
        3836
    ],
    "kintk": [
        3836
    ],
    "kaningra": [
        3837
    ],
    "kaningara": [
        3837
    ],
    "kensiu": [
        3838,
        3839
    ],
    "kansiw": [
        3838,
        3839
    ],
    "kense": [
        3838,
        3839
    ],
    "kenseu": [
        3838,
        3839
    ],
    "kensieu": [
        3838,
        3839
    ],
    "kensiw": [
        3838,
        3839
    ],
    "katukína, panoan": [
        3840
    ],
    "kamanawa": [
        3840
    ],
    "kamannaua": [
        3840
    ],
    "katukina pano": [
        3840
    ],
    "katukina do acre": [
        3840
    ],
    "katukina do juruá": [
        3840
    ],
    "katukina-kanamari": [
        3840
    ],
    "kono (guinea)": [
        3841
    ],
    "kung-ekoka": [
        3843
    ],
    "kendayan": [
        3844,
        4474
    ],
    "kanayatn": [
        3844
    ],
    "kenayatn": [
        3844
    ],
    "kendayan dayak": [
        3844
    ],
    "kanyok": [
        3845
    ],
    "kanioka": [
        3845
    ],
    "kanyoka": [
        3845
    ],
    "kalamsé": [
        3846
    ],
    "kalemsé": [
        3846
    ],
    "kalenga": [
        3846
    ],
    "korean": [
        3847,
        3848,
        3849,
        3850,
        4055,
        5882,
        5884
    ],
    "koryomal": [
        3847,
        3848,
        3850
    ],
    "kp": [
        3849
    ],
    "konomala": [
        3851
    ],
    "kpati": [
        3852
    ],
    "kodi": [
        3853
    ],
    "kudi": [
        3853
    ],
    "kacipo-bale": [
        3854
    ],
    "kachepo": [
        3854
    ],
    "kachipo": [
        3854
    ],
    "kacipo": [
        3854
    ],
    "kacipo-bale suri": [
        3854
    ],
    "kacipo-balesi": [
        3854
    ],
    "kubawa": [
        3855
    ],
    "kaugiañ": [
        3856
    ],
    "kagaba": [
        3856
    ],
    "kaggaba": [
        3856
    ],
    "kawgian": [
        3856
    ],
    "kogui": [
        3856
    ],
    "koyo": [
        3857,
        4373
    ],
    "kouyou": [
        3857
    ],
    "komi-permyak": [
        3858,
        3859,
        3860
    ],
    "kama permyak": [
        3858,
        3859,
        3860
    ],
    "kama": [
        3858,
        3859,
        3860
    ],
    "komi-perm": [
        3858,
        3859,
        3860
    ],
    "komi-permyaki": [
        3858,
        3859,
        3860
    ],
    "komi-permyat": [
        3858,
        3859,
        3860
    ],
    "konkani (macrolanguage)": [
        3861
    ],
    "kol (papua new guinea)": [
        3862
    ],
    "kola": [
        4067,
        3862,
        6891,
        7665,
        8487
    ],
    "konzo": [
        3863
    ],
    "kwato": [
        3864
    ],
    "kota (gabon)": [
        3865
    ],
    "kotu": [
        3865
    ],
    "kosraean": [
        3866
    ],
    "kosrae": [
        3866
    ],
    "kusaie": [
        3866
    ],
    "kusaiean": [
        3866
    ],
    "kotoko-logone": [
        3867
    ],
    "koke": [
        3868
    ],
    "khoke": [
        3868
    ],
    "kudu-camo": [
        3869
    ],
    "kuda-chamo": [
        3869
    ],
    "kudawa": [
        3869
    ],
    "kugama": [
        3870
    ],
    "kugamma": [
        3870
    ],
    "koyukon": [
        3871
    ],
    "korak": [
        3872
    ],
    "kutto": [
        3873
    ],
    "kupto": [
        3873
    ],
    "kúttò": [
        3873
    ],
    "kurumba, mullu": [
        3874
    ],
    "karrupaku": [
        3875
    ],
    "koripako": [
        3875
    ],
    "korispaso": [
        3875
    ],
    "kuripaco": [
        3875
    ],
    "kuripako": [
        3875
    ],
    "kurripaco": [
        3875
    ],
    "kurripako": [
        3875
    ],
    "kúrrim": [
        3875
    ],
    "kpelle, liberia": [
        3878,
        3877
    ],
    "komba": [
        3879
    ],
    "kapingamarangi": [
        3880
    ],
    "kirinit": [
        3880
    ],
    "kplang": [
        3881
    ],
    "kofei": [
        3882
    ],
    "karajá": [
        3883
    ],
    "kpan": [
        3884
    ],
    "kpanten": [
        3884
    ],
    "kpwate": [
        3884
    ],
    "kpala": [
        3885,
        3942
    ],
    "kpwaala": [
        3885
    ],
    "kwala": [
        3885,
        4075
    ],
    "koho": [
        3886
    ],
    "kohor": [
        3886
    ],
    "kơho": [
        3886
    ],
    "kepkiriwát": [
        3887
    ],
    "kepkiriwat": [
        3887
    ],
    "kepkiriwate": [
        3887
    ],
    "kposo": [
        3888
    ],
    "korupun-sela": [
        3889
    ],
    "kimyal of korupun": [
        3889
    ],
    "kimyal": [
        3889,
        5545
    ],
    "korupun": [
        3889
    ],
    "korapun": [
        3889
    ],
    "korafe-yegha": [
        3890
    ],
    "kailikaili": [
        3890
    ],
    "kaire": [
        3890
    ],
    "korafe": [
        3890
    ],
    "korafe-mokorua": [
        3890
    ],
    "korafi": [
        3890
    ],
    "korape": [
        3890
    ],
    "kwarafe": [
        3890
    ],
    "kaibus": [
        3891
    ],
    "karata": [
        3892
    ],
    "karatai": [
        3892
    ],
    "karatay": [
        3892
    ],
    "karatin": [
        3892
    ],
    "kirdi": [
        3892
    ],
    "kk’irtli micc’i": [
        3892
    ],
    "kk’irtli": [
        3892
    ],
    "kafoa": [
        3893
    ],
    "kobon": [
        3894
    ],
    "koiali, mountain": [
        3895
    ],
    "koiali": [
        3895
    ],
    "koryak": [
        3896
    ],
    "koryaki": [
        3896
    ],
    "kupsapiiny": [
        3897
    ],
    "kuksabin": [
        3897
    ],
    "kupsabiny": [
        3897
    ],
    "katiati": [
        3898
    ],
    "kovai": [
        3899
    ],
    "kobai": [
        3899
    ],
    "kowai": [
        3899
    ],
    "koy sanjaq surat": [
        3901
    ],
    "koy": [
        3901
    ],
    "koi sanjaq soorit": [
        3901
    ],
    "koi-sanjaq sooret": [
        3901
    ],
    "koi-sanjaq": [
        3901
    ],
    "koy sanjaq sooret": [
        3901
    ],
    "koy sanjaq soorit": [
        3901
    ],
    "kinalagan": [
        3902
    ],
    "kakabai": [
        3903
    ],
    "khe": [
        3904
    ],
    "kheso": [
        3904
    ],
    "kisankasa": [
        3905
    ],
    "koita": [
        3906
    ],
    "koitabu": [
        3906
    ],
    "koitapu": [
        3906
    ],
    "koromira": [
        3907
    ],
    "kotafon": [
        3908
    ],
    "kogbe": [
        3908
    ],
    "kotafon gbe": [
        3908
    ],
    "kyenele": [
        3909
    ],
    "kiañiŋ balaŋ": [
        3909
    ],
    "kiañiŋ": [
        3909
    ],
    "kenen birang": [
        3909
    ],
    "kenen": [
        3909
    ],
    "kenying": [
        3909
    ],
    "keyele": [
        3909
    ],
    "keñele": [
        3909
    ],
    "kyenying-barang": [
        3909
    ],
    "khisa": [
        3910
    ],
    "khi khipa": [
        3910
    ],
    "khipa": [
        3910
    ],
    "komono": [
        3910
    ],
    "kumwenu": [
        3910
    ],
    "kaonde": [
        3911
    ],
    "kahonde": [
        3911
    ],
    "kawonde": [
        3911
    ],
    "kiikaonde": [
        3911
    ],
    "krahn, eastern": [
        3912
    ],
    "krahn": [
        3912,
        3946,
        3939
    ],
    "kran": [
        3946,
        3912
    ],
    "kimré": [
        3913
    ],
    "krenak": [
        3914
    ],
    "krenac": [
        3914
    ],
    "krenak-nakrehé": [
        3914
    ],
    "kimaragang": [
        3915
    ],
    "kimaragan": [
        3915
    ],
    "kimaragangan": [
        3915
    ],
    "kissi, northern": [
        3916
    ],
    "kissi": [
        3916,
        3972
    ],
    "kisie": [
        3916
    ],
    "kissien": [
        3916,
        3972
    ],
    "kadazan, klias river": [
        3917
    ],
    "klias": [
        3917
    ],
    "klias river kadazan": [
        3917
    ],
    "kuijou": [
        3917
    ],
    "kuizou": [
        3917
    ],
    "kolod": [
        3919
    ],
    "kolor": [
        3919,
        7531
    ],
    "kolour": [
        3919
    ],
    "kolur": [
        3919
    ],
    "kandas": [
        3920
    ],
    "king": [
        3920
    ],
    "klesem": [
        3921
    ],
    "kotoko-kuseri": [
        3921
    ],
    "kouseri": [
        3921
    ],
    "kousseri": [
        3921
    ],
    "kuseri": [
        3921
    ],
    "koorete": [
        3922,
        3923
    ],
    "korana": [
        3924
    ],
    "koranna": [
        3924
    ],
    "koraqua": [
        3924
    ],
    "kanuri, yerwa": [
        3926,
        3925
    ],
    "kolere": [
        3925,
        3926
    ],
    "kumal": [
        3927
    ],
    "kumali": [
        3927
    ],
    "kumbale": [
        3927
    ],
    "kumhale": [
        3927
    ],
    "kumhali": [
        3927
    ],
    "kumkale": [
        3927
    ],
    "karkin": [
        3928
    ],
    "karachay-balkar": [
        3929
    ],
    "karacaylar": [
        3929
    ],
    "karachai": [
        3929
    ],
    "karachaitsy": [
        3929
    ],
    "karachay": [
        3929
    ],
    "karachayla": [
        3929
    ],
    "kairui-midiki": [
        3930
    ],
    "kreen akarore": [
        3931
    ],
    "kreen": [
        3931
    ],
    "kren akarore": [
        3931
    ],
    "kren": [
        3931
    ],
    "krenakarore": [
        3931
    ],
    "krenakore": [
        3931
    ],
    "krenhakarore": [
        3931
    ],
    "koro (vanuatu)": [
        3932
    ],
    "kurama": [
        3933,
        8100
    ],
    "kinaray-a": [
        3935
    ],
    "karay-a": [
        3935
    ],
    "kiniray-a": [
        3935
    ],
    "kerek": [
        3936
    ],
    "karelian": [
        3937,
        3938,
        5896
    ],
    "karel": [
        3937,
        3938,
        5896
    ],
    "karelian proper": [
        3937,
        3938
    ],
    "karely": [
        3937,
        3938
    ],
    "karel’skiy jazyk": [
        3937,
        3938
    ],
    "karel’skiy": [
        3937,
        3938
    ],
    "korop": [
        3940
    ],
    "kurop": [
        3940
    ],
    "kreung": [
        3941
    ],
    "kru’ng": [
        3941
    ],
    "kpara": [
        3942
    ],
    "kparla": [
        3942
    ],
    "kredj": [
        3942
    ],
    "kreich": [
        3942
    ],
    "kreish": [
        3942
    ],
    "kresh": [
        3942
    ],
    "kanuri, tumari": [
        3943
    ],
    "kurux": [
        3944
    ],
    "kadukali": [
        3944
    ],
    "kurukh": [
        3944
    ],
    "kurukha": [
        3944
    ],
    "kavet": [
        3945
    ],
    "kaaveat": [
        3945
    ],
    "khrak": [
        3945
    ],
    "khvek": [
        3945
    ],
    "kowet": [
        3945
    ],
    "kraeth": [
        3945
    ],
    "kravet": [
        3945
    ],
    "kraveth": [
        3945
    ],
    "krahn, western": [
        3946
    ],
    "kuloonaay": [
        3947
    ],
    "kaloon": [
        3947
    ],
    "karone": [
        3947
    ],
    "karoninka": [
        3947
    ],
    "kouloonaay": [
        3947
    ],
    "kulonay": [
        3947
    ],
    "kryts": [
        3948
    ],
    "katsy": [
        3948
    ],
    "kryc": [
        3948
    ],
    "kryz": [
        3948
    ],
    "kryzy": [
        3948
    ],
    "kanum, sota": [
        3949
    ],
    "kashmiri": [
        3950,
        3951,
        3952,
        3953
    ],
    "kacmiri": [
        3950,
        3951,
        3952,
        3953
    ],
    "kaschemiri": [
        3950,
        3951,
        3952,
        3953
    ],
    "keshur": [
        3950,
        3951,
        3952,
        3953
    ],
    "keshuri": [
        3950,
        3951,
        3952,
        3953
    ],
    "koshur": [
        3950,
        3951,
        3952,
        3953
    ],
    "kauru": [
        3954
    ],
    "kuzamani": [
        3954
    ],
    "kishambaa": [
        3955
    ],
    "kisambaa": [
        3955
    ],
    "kishambala": [
        3955
    ],
    "kalinga, southern": [
        3956
    ],
    "kinalingka": [
        3956
    ],
    "kinalingga": [
        3956
    ],
    "kuanua": [
        3957
    ],
    "kuni": [
        3958,
        4051,
        5507
    ],
    "kpa": [
        3959
    ],
    "kusaghe": [
        3960
    ],
    "kusage": [
        3960
    ],
    "kushage": [
        3960
    ],
    "kölsch": [
        3961
    ],
    "krisa": [
        3962
    ],
    "kwale": [
        3963
    ],
    "kansa": [
        3964
    ],
    "kanze": [
        3964
    ],
    "konze": [
        3964
    ],
    "kumalu": [
        3965
    ],
    "kumara": [
        3965
    ],
    "kumba": [
        3966
    ],
    "kasiguranin": [
        3967
    ],
    "kofa": [
        3968
    ],
    "kabba": [
        3969,
        4207
    ],
    "kaba": [
        4079,
        4093,
        6717,
        3969,
        4061,
        4062
    ],
    "kaba de baibokoum": [
        3969
    ],
    "kaba de goré": [
        3969
    ],
    "kaba de paoua": [
        3969
    ],
    "kwaami": [
        3970
    ],
    "komawa": [
        3970
    ],
    "kwam": [
        3970
    ],
    "kwamanchi": [
        3970
    ],
    "kwami": [
        3987,
        3970
    ],
    "kwom": [
        3970
    ],
    "kisi, southern": [
        3972
    ],
    "kols": [
        3973
    ],
    "kolsi": [
        3973
    ],
    "kõ": [
        3973
    ],
    "khamyang": [
        3974
    ],
    "khamiyang": [
        3974
    ],
    "khamjang": [
        3974
    ],
    "kusu": [
        3975
    ],
    "kikusu": [
        3975
    ],
    "kongola": [
        3975
    ],
    "kutsu": [
        3975
    ],
    "karen, s’gaw": [
        3976,
        3977
    ],
    "kanyaw": [
        3976,
        3977
    ],
    "kayinpyu": [
        3976,
        3977,
        4061,
        4062
    ],
    "kyetho": [
        3976,
        3977
    ],
    "kayin": [
        3976,
        3977,
        6380
    ],
    "kedang": [
        3978
    ],
    "kdang": [
        3978
    ],
    "kedangese": [
        3978
    ],
    "kédang": [
        3978
    ],
    "kharia thar": [
        3979
    ],
    "kodaku": [
        3980
    ],
    "koraku": [
        3980
    ],
    "katua": [
        3981
    ],
    "kambaata": [
        3982,
        3983
    ],
    "kholok": [
        3984
    ],
    "kode": [
        3984
    ],
    "koode": [
        3984
    ],
    "kwoode": [
        3984
    ],
    "kokata": [
        3985
    ],
    "kokatha": [
        3985
    ],
    "kokitta": [
        3985
    ],
    "koocatho": [
        3985
    ],
    "koogurda": [
        3985
    ],
    "kugurda": [
        3985
    ],
    "kukata": [
        3985
    ],
    "kukatha": [
        3985
    ],
    "kutang bhotia": [
        3986
    ],
    "kikwame": [
        3987
    ],
    "kikwami": [
        3987
    ],
    "kwame": [
        3987
    ],
    "kalkutung": [
        3988
    ],
    "kalkadoon": [
        3988
    ],
    "kalkatungu": [
        3988
    ],
    "kalkutungu": [
        3988
    ],
    "kurunga": [
        3989
    ],
    "kataut": [
        3990
    ],
    "kati-ninanti": [
        3990
    ],
    "krumen, plapo": [
        3991
    ],
    "krumen": [
        3991,
        6384,
        7412
    ],
    "kaniet": [
        3992
    ],
    "koroshi": [
        3993
    ],
    "kurti": [
        3994
    ],
    "kuruti": [
        3994
    ],
    "kuruti-pare": [
        3994
    ],
    "karitiâna": [
        3995
    ],
    "kuot": [
        3996
    ],
    "kuat": [
        3996
    ],
    "kaduo": [
        3997
    ],
    "kadu": [
        9061,
        3997,
        6943,
        8670,
        8671,
        8672
    ],
    "khatu": [
        3997
    ],
    "katabaga": [
        3998
    ],
    "kati metomka": [
        3999
    ],
    "ketum": [
        4000
    ],
    "kitum": [
        4000
    ],
    "kituba": [
        4001,
        4868
    ],
    "kibulamatadi": [
        4001
    ],
    "kikongo commercial": [
        4001
    ],
    "kikongo simplifié": [
        4001
    ],
    "kikongo ya leta": [
        4001
    ],
    "kikongo-kituba": [
        4001,
        4868
    ],
    "kikongo-kutuba": [
        4001
    ],
    "kileta": [
        4001
    ],
    "kituba (democratic republic of congo)": [
        4001
    ],
    "katu, eastern": [
        4002
    ],
    "katu": [
        4002,
        4019,
        7555
    ],
    "kato": [
        4003,
        9061
    ],
    "kai po-mo": [
        4003
    ],
    "kaxararí": [
        4004
    ],
    "kaxariri": [
        4004
    ],
    "kango": [
        4005,
        4183,
        4586,
        4587
    ],
    "kango (bas-uélé district)": [
        4005
    ],
    "kung-tsumkwe": [
        4006
    ],
    "kurdî": [
        4007,
        4008,
        4009,
        4010,
        4012,
        4014,
        6753
    ],
    "kurmanji": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kermancî": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "khorasani kurmanji": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kirmanciya jori": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kirmanciya": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kirmancî": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kordi kormanji": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kormanji": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurdish kurmanji": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurdish, northern": [
        4012,
        4014,
        4007,
        4009,
        4010
    ],
    "kurdiya jorîn": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurdiya": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurdmancî": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurdî-kurmancî": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurmancî": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurmanji kurdish": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kurmanjî": [
        4007,
        4009,
        4010,
        4012,
        4014
    ],
    "kutep": [
        4015
    ],
    "kuteb": [
        4015
    ],
    "kutev": [
        4015
    ],
    "kwinsu": [
        4016
    ],
    "kurada": [
        4017
    ],
    "kuman (papua new guinea)": [
        4018
    ],
    "katu, western": [
        4019
    ],
    "kupa": [
        4020
    ],
    "kushe": [
        4021
    ],
    "kuikúro-kalapálo": [
        4022
    ],
    "kalapalo": [
        4022
    ],
    "kuikuru": [
        4022
    ],
    "kurkuro": [
        4022
    ],
    "kuria": [
        4023
    ],
    "kikoria": [
        4023
    ],
    "kikuria": [
        4023
    ],
    "kikuria cha mashariki": [
        4023
    ],
    "kikuria cha juu": [
        4023
    ],
    "koria": [
        4023
    ],
    "kulia": [
        4023
    ],
    "kurya": [
        4023
    ],
    "kurye": [
        4023
    ],
    "kepo’": [
        4024
    ],
    "kepo'": [
        4024
    ],
    "kepoq": [
        4024
    ],
    "kulere": [
        4025
    ],
    "korom boye": [
        4025
    ],
    "korom": [
        4025
    ],
    "kumyk": [
        4026,
        4027,
        4028
    ],
    "kumuk": [
        4026,
        4027,
        4028
    ],
    "kumuklar": [
        4026,
        4027,
        4028
    ],
    "kumyki": [
        4026,
        4027,
        4028
    ],
    "kunama": [
        4029
    ],
    "kumukio": [
        4030
    ],
    "kumokio": [
        4030
    ],
    "kunimaipa": [
        4031
    ],
    "karipuna de rondônia": [
        4032
    ],
    "karipuna do guaporé": [
        4032
    ],
    "kusaal": [
        4033
    ],
    "kʋsaal": [
        4033
    ],
    "koussassé": [
        4033
    ],
    "kusaas": [
        4033
    ],
    "kusaasi": [
        4033
    ],
    "kusale": [
        4033
    ],
    "kusasi": [
        4033
    ],
    "kutenai": [
        4034
    ],
    "kootenai": [
        4034
    ],
    "kootenay": [
        4034
    ],
    "ktunaxa": [
        4034
    ],
    "kuskokwim, upper": [
        4035
    ],
    "kolchan": [
        4035
    ],
    "kpagua": [
        4037
    ],
    "kpagwa": [
        4037
    ],
    "kukatja": [
        4038
    ],
    "kukaja": [
        4038
    ],
    "kuuku-ya’u": [
        4039
    ],
    "koko-ja’o": [
        4039
    ],
    "kokoyao": [
        4039
    ],
    "kuuk-yak": [
        7943,
        4039
    ],
    "kuuku ya’u": [
        4039
    ],
    "kuuku": [
        4039
    ],
    "kuuku-ya'u": [
        4039
    ],
    "kunza": [
        4040
    ],
    "komi": [
        4041,
        4043,
        4044,
        4042,
        8332,
        8470
    ],
    "komi-zyrian": [
        4042,
        4041
    ],
    "komi-zyryan": [
        4041,
        4042
    ],
    "kvanada": [
        4045
    ],
    "kvanadin": [
        4045
    ],
    "kubu": [
        4046
    ],
    "kove": [
        4047
    ],
    "kui (indonesia)": [
        4048
    ],
    "kalabakan": [
        4049
    ],
    "kabalai": [
        4050
    ],
    "kaba-lai": [
        4050
    ],
    "kabalay": [
        4050
    ],
    "kabalaye": [
        4050
    ],
    "keb-kaye": [
        4050
    ],
    "kuni-boazi": [
        4051
    ],
    "kuini": [
        4051
    ],
    "komodo": [
        4052
    ],
    "kouang": [
        4053
    ],
    "kuang": [
        4053
    ],
    "kamsiki": [
        4054
    ],
    "kapsiki": [
        4054
    ],
    "korean sign language": [
        4055
    ],
    "kayaw": [
        4056
    ],
    "ka-yaw": [
        4056
    ],
    "kendem": [
        4057
    ],
    "kuna, border": [
        4058
    ],
    "kuna de la frontera": [
        4058
    ],
    "kobroor": [
        4059
    ],
    "kobro’or": [
        4059
    ],
    "kompane": [
        4060
    ],
    "komfana": [
        4060
    ],
    "kongampani": [
        4060
    ],
    "karen, geba": [
        4061,
        4062
    ],
    "karenbyu": [
        4061,
        4062
    ],
    "kayinbyu": [
        4061,
        4062
    ],
    "koo-ong": [
        4061,
        4062
    ],
    "kerinci": [
        4063,
        4064
    ],
    "kerinchi": [
        4063,
        4064
    ],
    "kinchai": [
        4063,
        4064
    ],
    "kayan lahta": [
        4065
    ],
    "khahta": [
        4065
    ],
    "kulaha": [
        4067
    ],
    "kolana": [
        4068
    ],
    "kolana-wersin": [
        4068
    ],
    "koli, parkari": [
        4069
    ],
    "kotogüt": [
        4071
    ],
    "kernewek": [
        4072
    ],
    "kernowek": [
        4072
    ],
    "kwah": [
        4074
    ],
    "kwaio": [
        4076
    ],
    "koio": [
        4076
    ],
    "kwerba": [
        4077,
        8699
    ],
    "koassa": [
        4077,
        8408
    ],
    "kwara’ae": [
        4078
    ],
    "kwara'ae": [
        4078
    ],
    "kwaraqae": [
        4078
    ],
    "kaba démé, sara": [
        4079
    ],
    "kaba demi": [
        4079
    ],
    "kaba démé": [
        4079
    ],
    "kaba ’dem": [
        4079
    ],
    "kowiai": [
        4080
    ],
    "kaiwai": [
        4080
    ],
    "kajumerah": [
        4080
    ],
    "kayumerah": [
        4080
    ],
    "koiwai": [
        4080
    ],
    "kuiwai": [
        4080
    ],
    "kwaiker": [
        4081
    ],
    "kawanga": [
        4082,
        4550
    ],
    "kwakwala": [
        4083
    ],
    "kwagiutl": [
        4083
    ],
    "kwakwaka’wakw": [
        4083
    ],
    "kofyar": [
        4084
    ],
    "koffiar": [
        4084
    ],
    "kwambi": [
        4085
    ],
    "kwangali": [
        4086
    ],
    "kwangare": [
        4086
    ],
    "kwangari": [
        4086
    ],
    "kwomtari": [
        4087
    ],
    "kefe": [
        4087
    ],
    "kisofe": [
        4087
    ],
    "klefe": [
        4087
    ],
    "kodia": [
        4088
    ],
    "kwadia": [
        4088
    ],
    "kwadya": [
        4088
    ],
    "kwer": [
        4089
    ],
    "kwese": [
        4090
    ],
    "kikwese": [
        4090
    ],
    "kwezo": [
        4090
    ],
    "kwesten": [
        4091
    ],
    "kwakum": [
        4092
    ],
    "kpakum": [
        4092
    ],
    "kaba naa, sara": [
        4093
    ],
    "kaba na": [
        4093
    ],
    "kaba naa": [
        4093
    ],
    "kaba nar": [
        4093
    ],
    "kwinti": [
        4094
    ],
    "khirwar": [
        4095
    ],
    "kalari": [
        4095
    ],
    "kherwari": [
        4095
    ],
    "khirwara": [
        4095
    ],
    "kongo, san salvador": [
        4096
    ],
    "kisikongo": [
        4096
    ],
    "kwadi": [
        4097
    ],
    "koroka": [
        4097
    ],
    "kairiru": [
        4098
    ],
    "krobu": [
        4099
    ],
    "krobou": [
        4099
    ],
    "konso": [
        4100,
        4101
    ],
    "kawyaw": [
        4104,
        4105,
        4106
    ],
    "kayah-munu": [
        4104,
        4105,
        4106
    ],
    "kayàw": [
        4104,
        4105,
        4106
    ],
    "karo (ethiopia)": [
        4107
    ],
    "keningau murut": [
        4108
    ],
    "kulfa": [
        4109
    ],
    "kulfe": [
        4109
    ],
    "kurumi": [
        4109
    ],
    "khaungtou": [
        4110
    ],
    "khmer, northern": [
        4111,
        4112
    ],
    "khmer lue": [
        4111,
        4112
    ],
    "kanowit-tanjong": [
        4113
    ],
    "kanowit-tanjong melanau": [
        4113
    ],
    "kanoé": [
        4114
    ],
    "kanoê": [
        4114
    ],
    "kapishanã": [
        4114
    ],
    "kapixana": [
        4114
    ],
    "kapixaná": [
        4114
    ],
    "koaratira": [
        4114
    ],
    "koli, wadiyari": [
        4115,
        4116,
        4117
    ],
    "koli, thradhri": [
        4117
    ],
    "kanum, smärky": [
        4118
    ],
    "koro (papua new guinea)": [
        4119
    ],
    "kangjia": [
        4120
    ],
    "kangyang hui": [
        4120
    ],
    "kangyang": [
        4120
    ],
    "koiwat": [
        4121
    ],
    "kui (india)": [
        4122,
        7935
    ],
    "kuvi": [
        4123,
        4124
    ],
    "khondh": [
        4123,
        4124
    ],
    "khondi": [
        4123,
        4124,
        7935
    ],
    "kond": [
        4123,
        4124
    ],
    "kuvi kond": [
        4123,
        4124
    ],
    "kuvinga": [
        4123,
        4124
    ],
    "kuwi": [
        4123,
        4124
    ],
    "konai": [
        4125
    ],
    "kala̱i̱": [
        4125
    ],
    "kayong": [
        4127
    ],
    "kagiuong": [
        4127
    ],
    "katang": [
        5349,
        5350,
        6736,
        4127,
        7762
    ],
    "kerewo": [
        4128
    ],
    "kerewa": [
        4128
    ],
    "kerewa-goari": [
        4128
    ],
    "kyrgyz": [
        4129,
        4130,
        4131
    ],
    "kara-kirgiz": [
        4129,
        4130,
        4131
    ],
    "ke’erkez": [
        4129,
        4130,
        4131
    ],
    "kirghizi": [
        4129,
        4130,
        4131
    ],
    "kirgiz": [
        4129,
        4130,
        4131
    ],
    "kyrgyz tili": [
        4129,
        4130,
        4131
    ],
    "kyrgyzcha": [
        4129,
        4130,
        4131
    ],
    "kwaya": [
        4132
    ],
    "kikwaya": [
        4132
    ],
    "kalinga, butbut": [
        4133
    ],
    "kalinga butbut": [
        4133
    ],
    "kyaka": [
        4134
    ],
    "kyaka enga": [
        4134
    ],
    "kyaka eŋa": [
        4134
    ],
    "karey": [
        4135
    ],
    "kerei": [
        4135
    ],
    "krei": [
        4135
    ],
    "krache": [
        4136
    ],
    "kaakye": [
        4136
    ],
    "kaache": [
        4136
    ],
    "kaakyi": [
        4136
    ],
    "kaakyɩ": [
        4136
    ],
    "krachi": [
        4136
    ],
    "krakye": [
        4136
    ],
    "kouya": [
        4137
    ],
    "kowya": [
        4137
    ],
    "kuya": [
        4137
    ],
    "keyagana": [
        4138
    ],
    "keiagana": [
        4138
    ],
    "keigana": [
        4138
    ],
    "ke’yagana": [
        4138
    ],
    "karok": [
        4139
    ],
    "karuk": [
        4139
    ],
    "kiput": [
        4140
    ],
    "karao": [
        4141
    ],
    "karaw": [
        4141
    ],
    "kamayo": [
        4142
    ],
    "kadi": [
        4142
    ],
    "kinadi": [
        4142
    ],
    "kinamayo": [
        4142
    ],
    "kalapuya": [
        4143,
        5677,
        7257
    ],
    "kalapuyan": [
        4143
    ],
    "kpatili": [
        4144
    ],
    "kpatere": [
        4144
    ],
    "kpatiri": [
        4144
    ],
    "karolanos": [
        4145
    ],
    "klon": [
        4146
    ],
    "kelon": [
        4146
    ],
    "kelong": [
        4146
    ],
    "kolon": [
        4146
    ],
    "kenga": [
        4148,
        7862
    ],
    "kenge": [
        4148
    ],
    "kuruáya": [
        4149
    ],
    "kuruaia": [
        4149
    ],
    "kayan, baram": [
        4150
    ],
    "kayagar": [
        4151
    ],
    "kajagar": [
        4151
    ],
    "kaygi": [
        4151
    ],
    "kaygir": [
        4151
    ],
    "kayah, western": [
        4152,
        4153,
        4154
    ],
    "karieng daeng": [
        4152,
        4153,
        4154
    ],
    "karieng": [
        4152,
        4153,
        4154
    ],
    "kayort": [
        4155
    ],
    "kudmali": [
        4156,
        4157,
        4158
    ],
    "khotta": [
        4156,
        4157,
        4158
    ],
    "kurmali": [
        4156,
        4157,
        4158
    ],
    "kurmali thar": [
        4156,
        4157,
        4158
    ],
    "kurumali": [
        4156,
        4157,
        4158
    ],
    "konua": [
        4159
    ],
    "kunua": [
        4159
    ],
    "kambaira": [
        4160
    ],
    "kayabí": [
        4161
    ],
    "kaiabí": [
        4161
    ],
    "kajabí": [
        4161
    ],
    "karaboro, western": [
        4162
    ],
    "karaboro": [
        4162,
        8616
    ],
    "kaibobo": [
        4163
    ],
    "kaibubu": [
        4163
    ],
    "kulango, bondoukou": [
        4164
    ],
    "kulango": [
        4164,
        5531
    ],
    "kolango": [
        4164
    ],
    "koulango": [
        4164,
        5531
    ],
    "kulange": [
        4164,
        5531
    ],
    "kadai": [
        4165
    ],
    "kosena": [
        4166
    ],
    "kóséna": [
        4166
    ],
    "kaili, da’a": [
        4167
    ],
    "kaili": [
        4167,
        4288,
        7984
    ],
    "kikai": [
        4168
    ],
    "kelabit": [
        4169
    ],
    "kalabit": [
        4169
    ],
    "kerabit": [
        4169
    ],
    "kazukuru": [
        4170
    ],
    "kayeli": [
        4171
    ],
    "kajeli": [
        4171
    ],
    "kais": [
        4172
    ],
    "kampung baru": [
        4172
    ],
    "kampung": [
        4172
    ],
    "kokola": [
        4173
    ],
    "kokhola": [
        4173
    ],
    "kaningi": [
        4174
    ],
    "kaidipang": [
        4175
    ],
    "kaidipang-bolangitang": [
        4175
    ],
    "kaike": [
        4176
    ],
    "karaŋ": [
        4177
    ],
    "kàráng": [
        4177
    ],
    "kayupulau": [
        4179
    ],
    "kajupulau": [
        4179
    ],
    "komyandaret": [
        4180
    ],
    "karirí-xocó": [
        4181
    ],
    "kariri xucó": [
        4181
    ],
    "kariri": [
        4181,
        8395
    ],
    "karirí": [
        4181
    ],
    "kipeá": [
        4181
    ],
    "kiriri": [
        4181
    ],
    "kamarian": [
        4182
    ],
    "kamariang": [
        4182
    ],
    "kango (tshopo district)": [
        4183
    ],
    "kango pygmy": [
        4183
    ],
    "kikango": [
        4183
    ],
    "kalabra": [
        4184
    ],
    "kidie lafofa": [
        4194
    ],
    "kidie": [
        4194
    ],
    "kɨlaangi": [
        4195
    ],
    "kelangi": [
        4195
    ],
    "kilaangi": [
        4195
    ],
    "kilangi": [
        4195
    ],
    "kirangi": [
        4195
    ],
    "kilambya": [
        4201
    ],
    "kabba laka": [
        4207
    ],
    "ka bao": [
        4208
    ],
    "ka beo": [
        4208
    ],
    "ka biao": [
        4208
    ],
    "kabeo": [
        4208
    ],
    "kedi": [
        4211
    ],
    "kazikumukhtsy": [
        4221
    ],
    "kha lamet": [
        4229,
        4230
    ],
    "khamed": [
        4229,
        4230
    ],
    "khamet": [
        4229,
        4230
    ],
    "khanawa": [
        4233
    ],
    "khap": [
        4233,
        8751
    ],
    "ku te": [
        4235
    ],
    "kunana": [
        4241
    ],
    "kla-dan": [
        4252
    ],
    "kla": [
        4252
    ],
    "kilari": [
        4257
    ],
    "kitta": [
        4264
    ],
    "kilega": [
        4266,
        4306
    ],
    "kirega": [
        4266,
        4306
    ],
    "kihema-nord": [
        4269
    ],
    "kilendu": [
        4269
    ],
    "kilengola": [
        4274
    ],
    "kara (papua new guinea)": [
        4286
    ],
    "kaili, ledo": [
        4288
    ],
    "kaili-ledo": [
        4288
    ],
    "kiurintsy": [
        4291,
        4292
    ],
    "kiurinty": [
        4291,
        4292
    ],
    "katova": [
        4299
    ],
    "kaoka": [
        4311
    ],
    "khlá": [
        4313
    ],
    "khlá don": [
        4313
    ],
    "khlá dung": [
        4313
    ],
    "khlá phlao": [
        4313
    ],
    "klá dong": [
        4313
    ],
    "klá": [
        4313
    ],
    "kui lung": [
        4315
    ],
    "kui sang": [
        4315
    ],
    "kwi": [
        4315
    ],
    "keccyok": [
        4317
    ],
    "kaixien": [
        4322
    ],
    "kucong": [
        4359,
        4322
    ],
    "kutsong": [
        4322
    ],
    "klai": [
        4326
    ],
    "kilika": [
        4334
    ],
    "kpongo": [
        4334
    ],
    "kolokwa": [
        4340
    ],
    "khae": [
        4341,
        4342
    ],
    "kel": [
        4344
    ],
    "kolpa": [
        4349
    ],
    "kunu": [
        4352
    ],
    "kabarasi": [
        4358
    ],
    "kabras": [
        4358
    ],
    "kenye": [
        4361
    ],
    "kenyi": [
        4361,
        9046
    ],
    "kalaamaya": [
        4366
    ],
    "kalamai": [
        4366
    ],
    "kalamaia": [
        4366
    ],
    "karlamay": [
        4366
    ],
    "karlamayi": [
        4366
    ],
    "kelamai": [
        4366
    ],
    "khayo": [
        4368
    ],
    "kisa": [
        4370
    ],
    "koongerri": [
        4372
    ],
    "koonkerri": [
        4372
    ],
    "kungeri": [
        4372
    ],
    "kor": [
        7336,
        4378
    ],
    "kalba": [
        4390,
        4506,
        4507
    ],
    "kuku-lumun": [
        4396
    ],
    "kambu": [
        4410
    ],
    "kawela": [
        4412
    ],
    "kirikjir": [
        4455
    ],
    "kouri-vini": [
        4461
    ],
    "kréyol": [
        4461
    ],
    "kréyol la lwizyàn": [
        4461
    ],
    "kololo": [
        4467
    ],
    "kolololo": [
        4467
    ],
    "kishpignag": [
        4494
    ],
    "kiluba": [
        4517,
        6995,
        6996
    ],
    "kidjaluo": [
        4529
    ],
    "ka-lin-kaw": [
        4533,
        4534,
        4535
    ],
    "khoja": [
        4538
    ],
    "khojki": [
        4538
    ],
    "kasabe": [
        4539
    ],
    "kahal maku’a": [
        4544
    ],
    "kahal": [
        4544
    ],
    "khongo": [
        4548
    ],
    "kyol": [
        4585
    ],
    "kankan maninka": [
        4587,
        4588,
        4589
    ],
    "kankan": [
        4587,
        4588,
        4589
    ],
    "kimaasai": [
        4591,
        4592
    ],
    "kabari": [
        4608
    ],
    "kabori": [
        4608
    ],
    "kumanuxú": [
        4610
    ],
    "ki-mbunda": [
        4635
    ],
    "kimbunda": [
        4635
    ],
    "kakawahe": [
        4636
    ],
    "kristang": [
        4637
    ],
    "kodut, south": [
        4649
    ],
    "kodut": [
        4649,
        4995,
        7968
    ],
    "koliku": [
        4653
    ],
    "kana mabang": [
        4655,
        4656
    ],
    "kana": [
        4655,
        4656,
        4893,
        5852,
        9065
    ],
    "kingbetu": [
        4661
    ],
    "kiyogo": [
        4664
    ],
    "kasere": [
        4681
    ],
    "kopo-monia": [
        4681
    ],
    "káꞌánꞌ": [
        4686
    ],
    "kájí": [
        4686
    ],
    "koalgurdi": [
        4691
    ],
    "kedah": [
        4694,
        4695
    ],
    "kedah malay": [
        4694,
        4695
    ],
    "kedahan malay": [
        4694,
        4695
    ],
    "kedahan": [
        4694,
        4695
    ],
    "kimîîru": [
        4698
    ],
    "kĩmĩrũ": [
        4698
    ],
    "kimeru": [
        4698,
        6638
    ],
    "klem el bithan": [
        4704,
        4705
    ],
    "klem": [
        4704,
        4705
    ],
    "kimanga": [
        4710
    ],
    "kimbanga": [
        4710
    ],
    "kreol morisien": [
        4712
    ],
    "kreol mauricean": [
        4712
    ],
    "kreol morisyin": [
        4712
    ],
    "kreole": [
        4712
    ],
    "ketuen": [
        4724
    ],
    "kanyop": [
        4731
    ],
    "kala moru": [
        4742,
        4743
    ],
    "kimakua": [
        4747
    ],
    "koro lafia": [
        4748
    ],
    "koro of lafia": [
        4748
    ],
    "kimalila": [
        4757
    ],
    "kimanda": [
        4759
    ],
    "kinyasa": [
        4759,
        4823,
        4984
    ],
    "kimatengo": [
        4762
    ],
    "kimatumbi": [
        4763
    ],
    "kimatuumbi": [
        4763
    ],
    "kimbunga": [
        4764
    ],
    "kemboowɛ": [
        4765
    ],
    "kimbugwe": [
        4765
    ],
    "kiumbugwe": [
        4765
    ],
    "kibwayo": [
        4770
    ],
    "kibwyo": [
        4770
    ],
    "kimaa": [
        4770
    ],
    "kimbugu": [
        4770
    ],
    "kamaxi": [
        4780
    ],
    "kuso": [
        4786
    ],
    "kusso": [
        4786
    ],
    "konkau": [
        4820
    ],
    "konkow": [
        4820
    ],
    "koyoomk’awi": [
        4820
    ],
    "koyoongk’awi": [
        4820
    ],
    "kimwera": [
        4823,
        5178
    ],
    "kim mun": [
        4824
    ],
    "kem mun": [
        4824
    ],
    "kem": [
        4824
    ],
    "kem di mun": [
        4824
    ],
    "kimmun": [
        4824
    ],
    "koravan": [
        4831
    ],
    "kuravan": [
        4831
    ],
    "karingal": [
        4833
    ],
    "karbi karbak": [
        4840
    ],
    "karbak": [
        4840
    ],
    "karbiarlong": [
        4840
    ],
    "kupang malay": [
        4859
    ],
    "konyanka": [
        4866
    ],
    "koniaka": [
        4866
    ],
    "konya": [
        4866
    ],
    "konyakakan": [
        4866
    ],
    "konyanka maninka": [
        4866
    ],
    "kituba (congo)": [
        4868
    ],
    "kinamiging": [
        4869
    ],
    "kamigin": [
        4869
    ],
    "kinamigin": [
        4869
    ],
    "kinamiging manobo": [
        4869
    ],
    "kinamiguin": [
        4869
    ],
    "khatin": [
        4879,
        4880
    ],
    "kiwilwana": [
        4884
    ],
    "kyam": [
        4886
    ],
    "kaana masala": [
        4893
    ],
    "kaana": [
        4893
    ],
    "kana masaraka": [
        4893
    ],
    "kantana": [
        4899
    ],
    "kwarra": [
        4899
    ],
    "kaidemui": [
        4915
    ],
    "kalkh": [
        4926,
        4927,
        4929,
        4931,
        4932
    ],
    "khalkha": [
        4926,
        4927,
        4929,
        4931,
        4932
    ],
    "khalkha mongolian": [
        4926,
        4927,
        4929,
        4931,
        4932
    ],
    "kathe": [
        4943,
        4944,
        4945
    ],
    "kathi": [
        4943,
        4944,
        4945
    ],
    "kanienkehaka": [
        4965
    ],
    "kanien’kehaka": [
        4965
    ],
    "kanien’kéha": [
        4965
    ],
    "kimpoto": [
        4984
    ],
    "kunmarung": [
        4991
    ],
    "kotoko-makari": [
        4992
    ],
    "kodut, middle": [
        4995
    ],
    "karimui": [
        5002
    ],
    "kurateg": [
        5004
    ],
    "kutai": [
        5015,
        8099
    ],
    "kota bangun kutai malay": [
        5015
    ],
    "kabunsuwan": [
        5019
    ],
    "kabungsuan": [
        5019
    ],
    "kubonitu": [
        5053
    ],
    "kemelom": [
        5087
    ],
    "kemelomsch": [
        5087
    ],
    "komolom": [
        5087
    ],
    "kotoko-maltam": [
        5093
    ],
    "kunant": [
        5094
    ],
    "kunante": [
        5094
    ],
    "kaele": [
        5126
    ],
    "kumbulmara": [
        5161
    ],
    "kohistani, indus": [
        5173
    ],
    "khili": [
        5173
    ],
    "kohistẽ": [
        5173
    ],
    "kaul": [
        5180
    ],
    "kita": [
        5183
    ],
    "kita maninka": [
        5183
    ],
    "kita maninkakan": [
        5183
    ],
    "kinamwanga": [
        5186
    ],
    "kinyamwanga": [
        5186
    ],
    "kala lagaw ya": [
        5188
    ],
    "kala lagau langgus": [
        5188
    ],
    "kala lagaw": [
        5188
    ],
    "kala yagaw ya": [
        5188
    ],
    "kalau lagau ya": [
        5188
    ],
    "kalau": [
        5188
    ],
    "k’cho": [
        5189
    ],
    "k’cho chin": [
        5189
    ],
    "kai kui ki boli": [
        5190
    ],
    "ko’": [
        5193,
        5194
    ],
    "kotoko-gulfei": [
        5210
    ],
    "kaman": [
        5214
    ],
    "keman": [
        5214
    ],
    "kman": [
        5214
    ],
    "kisam": [
        5237
    ],
    "kwe-nee-chee-aht": [
        5238
    ],
    "kweedishchaaht": [
        5238
    ],
    "kulawi": [
        5242
    ],
    "kaulae": [
        5251
    ],
    "kisu": [
        5252
    ],
    "kaniuá": [
        5273
    ],
    "kachari bengali": [
        5288
    ],
    "khoekhoe": [
        5300
    ],
    "khoekhoegowab": [
        5300
    ],
    "khoekhoegowap": [
        5300
    ],
    "khoi": [
        5300
    ],
    "kieta": [
        5302
    ],
    "kieta talk": [
        5302
    ],
    "konyak": [
        5314
    ],
    "kanyak": [
        5314
    ],
    "konyak naga": [
        5314
    ],
    "kabui": [
        5329,
        5516
    ],
    "kokori": [
        5344
    ],
    "kerake": [
        5346
    ],
    "keraki": [
        5346
    ],
    "karetaake": [
        5348
    ],
    "katang, northern": [
        5349,
        5350
    ],
    "kataang": [
        6736,
        5349,
        5350
    ],
    "kyo̱ŋbo̱ro̱ŋ-nɔ": [
        5355
    ],
    "kyongborong": [
        5355
    ],
    "kyo̱ŋbo̱ro̱ŋ": [
        5355
    ],
    "kenswei nsei": [
        5360
    ],
    "kenswei": [
        5360
    ],
    "kensense": [
        5360
    ],
    "kenswey nsey": [
        5360
    ],
    "kenswey": [
        5360
    ],
    "kindengereko": [
        5364
    ],
    "kingengereko": [
        5364
    ],
    "kindali": [
        5365
    ],
    "kindamba": [
        5367
    ],
    "kebutu": [
        5372
    ],
    "kebu’tu": [
        5372
    ],
    "ke’bu": [
        5372
    ],
    "khaskura": [
        5385,
        5386
    ],
    "klamu": [
        5391
    ],
    "koumac": [
        5393
    ],
    "kumak": [
        5393
    ],
    "kinnauri, bhoti": [
        5405
    ],
    "kahore": [
        5415
    ],
    "kingulu": [
        5434
    ],
    "kinguu": [
        5434
    ],
    "kengoreme": [
        5435
    ],
    "kingereme": [
        5435
    ],
    "kingoreme": [
        5435
    ],
    "kuvoko": [
        5437
    ],
    "kriang": [
        5438
    ],
    "khiang": [
        5438
    ],
    "kuriang": [
        5438
    ],
    "kinyiha": [
        5474,
        5530,
        5804
    ],
    "kinilamba": [
        5479
    ],
    "kiniramba": [
        5479
    ],
    "kĩnilyamba": [
        5479
    ],
    "kwasu": [
        5480
    ],
    "kalenjin nandi": [
        5482
    ],
    "kolami, southeastern": [
        5485
    ],
    "kihema": [
        5490
    ],
    "kingeti": [
        5491
    ],
    "kingiti": [
        5491
    ],
    "kobochi": [
        5493
    ],
    "kobotshi": [
        5493
    ],
    "kidonde": [
        5495
    ],
    "kimawanda": [
        5495
    ],
    "kindonde hamba": [
        5495
    ],
    "kindonde": [
        5495
    ],
    "kyong": [
        5496
    ],
    "kurdanji": [
        5497
    ],
    "kacha naga": [
        5501
    ],
    "kacha": [
        5501,
        5817,
        7992
    ],
    "kerema": [
        5504,
        7895
    ],
    "kunyi": [
        5507
    ],
    "kikuni": [
        5507
    ],
    "kikunyi": [
        5507
    ],
    "kugni": [
        5507
    ],
    "khoibu": [
        5512
    ],
    "khoibu maring": [
        5512
    ],
    "khoibu maring naga": [
        5512
    ],
    "khoibu naga": [
        5512
    ],
    "kinkwa": [
        5513
    ],
    "koireng": [
        5514
    ],
    "koirng": [
        5514
    ],
    "kolren": [
        5514
    ],
    "koren": [
        5514
    ],
    "kolombangara": [
        5515
    ],
    "kabui naga": [
        5516
    ],
    "kapwi": [
        5516
    ],
    "koboi": [
        5516
    ],
    "kubai": [
        5516
    ],
    "khezha": [
        5518
    ],
    "kezami": [
        5518
    ],
    "khezha naga": [
        5518
    ],
    "khezhama": [
        5518
    ],
    "kozale": [
        5518
    ],
    "kuzale": [
        5518
    ],
    "kuzhale": [
        5518
    ],
    "közhale": [
        5518
    ],
    "khoirao": [
        5519,
        5520
    ],
    "khoirao naga": [
        5519,
        5520
    ],
    "koirao": [
        5519,
        5520
    ],
    "kolya": [
        5519,
        5520
    ],
    "keenok": [
        5529
    ],
    "kinyika": [
        5530,
        5532,
        5792
    ],
    "kulango, bouna": [
        5531
    ],
    "kimjal": [
        5545
    ],
    "karan": [
        5557
    ],
    "kalto": [
        5558
    ],
    "kwasio": [
        5567,
        5568
    ],
    "kwassio": [
        5567
    ],
    "karangura": [
        5585
    ],
    "kinande": [
        5592
    ],
    "kinandi": [
        5592
    ],
    "ka’do ngueté": [
        5605
    ],
    "kingindo": [
        5609
    ],
    "kam mueang": [
        5620,
        5621
    ],
    "kam mu’ang": [
        5620,
        5621
    ],
    "kammyang": [
        5620,
        5621
    ],
    "kammüang": [
        5620,
        5621
    ],
    "khon mueang": [
        5620,
        5621
    ],
    "khon myang": [
        5620,
        5621
    ],
    "khonmuang": [
        5620,
        5621
    ],
    "kiari": [
        5623
    ],
    "karanogai": [
        5624
    ],
    "kubanogai": [
        5624
    ],
    "karagwe": [
        5638
    ],
    "kinyambo": [
        5638
    ],
    "kura ede nago": [
        5653
    ],
    "kwendelengo": [
        5654
    ],
    "kyan-karyaw naga": [
        5658
    ],
    "kyan-karyaw": [
        5658
    ],
    "kudjunguru": [
        5670
    ],
    "koarnbut": [
        5679
    ],
    "kingasa": [
        5687
    ],
    "kingassa": [
        5687
    ],
    "kuwa": [
        5701,
        5702,
        5703
    ],
    "koo’ra": [
        5713
    ],
    "kombe": [
        5732
    ],
    "khanung": [
        5737
    ],
    "khingpang": [
        5737
    ],
    "khupang": [
        5737
    ],
    "kwingsang": [
        5737
    ],
    "kwinp’ang": [
        5737
    ],
    "kinindi": [
        5775
    ],
    "kokak": [
        5776
    ],
    "koki naga": [
        5776
    ],
    "konke": [
        5776
    ],
    "kasiwa": [
        5784
    ],
    "kativa": [
        5784
    ],
    "kigiryama": [
        5792
    ],
    "kigiriama": [
        5792
    ],
    "kinyindu": [
        5793
    ],
    "kinyanga": [
        5796
    ],
    "kinyamweezi": [
        5799
    ],
    "kinyamuesi": [
        5799
    ],
    "kinyamwesi": [
        5799
    ],
    "kinyamwezi": [
        5799
    ],
    "kyopi": [
        5801
    ],
    "kɨnyakyʉsa": [
        5811
    ],
    "kinyakyusa": [
        5811
    ],
    "kinyakyusa-ngonde": [
        5811
    ],
    "kukwe": [
        5811
    ],
    "kinyakyʉsa": [
        5811
    ],
    "kachcha": [
        5817
    ],
    "kachcha naga": [
        5817
    ],
    "kutcha": [
        5817
    ],
    "kidapawan manobo": [
        5830
    ],
    "kidapawan": [
        5830
    ],
    "khana": [
        5852,
        6259
    ],
    "kobo": [
        5873,
        8075
    ],
    "koko babangk": [
        5876
    ],
    "kok peponk": [
        5876
    ],
    "kok-babonk": [
        5876
    ],
    "kok-papangk": [
        5876
    ],
    "kok-paponk": [
        5876
    ],
    "koko kunaniy": [
        5876
    ],
    "kunaniy": [
        5876
    ],
    "koresh-e rostam": [
        5877
    ],
    "koresh-e": [
        5877
    ],
    "kinare": [
        5878
    ],
    "kwamtim": [
        5880
    ],
    "kuamtim": [
        5880
    ],
    "kwamtim one": [
        5880
    ],
    "kentish": [
        5881
    ],
    "kirike": [
        5885
    ],
    "kịrịkẹ": [
        5885
    ],
    "keccya": [
        5891
    ],
    "kimochi": [
        5892
    ],
    "kimoshi": [
        5892
    ],
    "koka-ollugul": [
        5894
    ],
    "koko olkol": [
        5894
    ],
    "koko olkolo": [
        5894
    ],
    "koko-olkol": [
        5894
    ],
    "kuvale": [
        5899
    ],
    "kambeba": [
        5907
    ],
    "kambewa": [
        5907
    ],
    "kambéba": [
        5907
    ],
    "kaliko-omi": [
        5908
    ],
    "kabore": [
        5926
    ],
    "kabore one": [
        5926
    ],
    "kopkaka": [
        5943
    ],
    "kopka": [
        5943
    ],
    "koring": [
        5953
    ],
    "kanaq": [
        5955
    ],
    "kaipi": [
        5956
    ],
    "kairu-kaura": [
        5956
    ],
    "kotia": [
        5959
    ],
    "kotia oriya": [
        5959
    ],
    "kotiya": [
        5959
    ],
    "kawama": [
        5990
    ],
    "kawarma": [
        5990
    ],
    "kuiaro": [
        6010
    ],
    "koonzime": [
        6011
    ],
    "kɔɔnzime": [
        6011
    ],
    "konzime": [
        6011
    ],
    "kooncimo": [
        6011
    ],
    "koozhime": [
        6011
    ],
    "koozime": [
        6011
    ],
    "kɔɔzime": [
        6011
    ],
    "kawahib": [
        6022,
        8240
    ],
    "kagwahiwa": [
        6025
    ],
    "kapampangan": [
        6030,
        6031
    ],
    "koso": [
        6035
    ],
    "koso shoshone": [
        6035
    ],
    "kudala": [
        6049
    ],
    "kpasham": [
        6052
    ],
    "kpasam": [
        6052
    ],
    "kanjad": [
        6054
    ],
    "khipangwa": [
        6055
    ],
    "kipangwa": [
        6055
    ],
    "kandahari pashto": [
        6057
    ],
    "kandahari": [
        6057
    ],
    "ka-yun": [
        6087,
        6088
    ],
    "kayang": [
        6087,
        6088
    ],
    "kayăn": [
        6087,
        6088
    ],
    "kipende": [
        6100
    ],
    "kánchá": [
        6102
    ],
    "kénzä": [
        6102
    ],
    "kotofo": [
        6109
    ],
    "kotopo": [
        6109
    ],
    "kotpojo": [
        6109
    ],
    "khla": [
        6124
    ],
    "kuakua": [
        6145
    ],
    "kpilakpila": [
        6152
    ],
    "kuipaco": [
        6155
    ],
    "kipimbwe": [
        6162
    ],
    "kuruko": [
        6163
    ],
    "kipfokomo": [
        6168
    ],
    "kipokomo": [
        6168
    ],
    "kurumba, attapady": [
        6176
    ],
    "kenege": [
        6182
    ],
    "kohistani shina": [
        6190
    ],
    "kohistyo": [
        6190
    ],
    "kpalagha": [
        6196
    ],
    "kuriwongi": [
        6231
    ],
    "kiong nai": [
        6244
    ],
    "kjong nai": [
        6244
    ],
    "kjong": [
        6244
    ],
    "keneng": [
        6247
    ],
    "kenieng": [
        6247
    ],
    "khabenapo": [
        6259
    ],
    "kulanapan": [
        6259
    ],
    "kulanapo": [
        6259
    ],
    "kábinapek": [
        6259
    ],
    "kriyol": [
        6264
    ],
    "kiriol": [
        6264
    ],
    "kriulo": [
        6264
    ],
    "kaulong": [
        6322
    ],
    "kowlong": [
        6322
    ],
    "kaiowa": [
        6341
    ],
    "küne": [
        6358
    ],
    "kha puhoc": [
        6365
    ],
    "ksing mul": [
        6365
    ],
    "ksing": [
        6365
    ],
    "ksingmul": [
        6365
    ],
    "kuyubi": [
        6368
    ],
    "kale-whan": [
        6379
    ],
    "kapiangan": [
        6379
    ],
    "katausan": [
        6379
    ],
    "karen, pwo western": [
        6380
    ],
    "karen, pwo northern": [
        6382
    ],
    "krumen, pye": [
        6384
    ],
    "kroumen": [
        6384,
        7412
    ],
    "k’iche’": [
        6398,
        6411
    ],
    "k'iche'": [
        6398
    ],
    "kichwa": [
        6416,
        6399,
        6401,
        6419,
        6439,
        6444,
        6412,
        6424,
        6426
    ],
    "kichwa shimi": [
        6399,
        6401,
        6419,
        6444
    ],
    "kichwa de la sierra": [
        6401,
        6419
    ],
    "kwinaył": [
        6406
    ],
    "kichwa lingwa": [
        6416
    ],
    "ketchwa": [
        6422
    ],
    "kicho": [
        6424
    ],
    "kichua": [
        6424
    ],
    "kechwa de san martin": [
        6426
    ],
    "kechwa": [
        6426
    ],
    "kuman (russia)": [
        6433
    ],
    "kwalhioqua-tlatskanai": [
        6435
    ],
    "kashkay": [
        6443
    ],
    "kashkai": [
        6443
    ],
    "khesange": [
        6454
    ],
    "klei êđê": [
        6457
    ],
    "klei": [
        6457
    ],
    "kanela": [
        6467
    ],
    "kimaam": [
        6468
    ],
    "kuki airani": [
        6472
    ],
    "kuki": [
        6472,
        7378
    ],
    "kūki": [
        6472
    ],
    "khamchi": [
        6475
    ],
    "krangku": [
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "karraba": [
        6489
    ],
    "kréol rénioné": [
        6490
    ],
    "kréol": [
        6490
    ],
    "kayan, rejang": [
        6494
    ],
    "kara (tanzania)": [
        6495
    ],
    "kikara": [
        6495
    ],
    "kilegi": [
        6495
    ],
    "kiregi": [
        6495
    ],
    "kyonam": [
        6508
    ],
    "kau bru": [
        6517
    ],
    "kun": [
        6523
    ],
    "keremi": [
        6524
    ],
    "kilimi": [
        6524
    ],
    "kinyaturu": [
        6524
    ],
    "kiremi": [
        6524
    ],
    "kirimi": [
        6524
    ],
    "koche": [
        6531
    ],
    "kraol": [
        6532
    ],
    "kamta": [
        6537
    ],
    "kamtapuri": [
        6537
    ],
    "koch rajbanshi": [
        6537
    ],
    "kawhul": [
        6538
    ],
    "kogung": [
        6538
    ],
    "kaltuy": [
        6541
    ],
    "karpacki roma": [
        6542
    ],
    "karpacki": [
        6542
    ],
    "kalo": [
        6545
    ],
    "kaalengo tšibbaha": [
        6545
    ],
    "kaalengo": [
        6545
    ],
    "kaalo": [
        6545
    ],
    "kalo finnish romani": [
        6545
    ],
    "kalé": [
        6545
    ],
    "kurbat": [
        6560
    ],
    "kååle": [
        6563
    ],
    "kalá": [
        6563
    ],
    "kale": [
        6563
    ],
    "kirundi": [
        6566,
        6567
    ],
    "kilunda": [
        6568
    ],
    "kiluunda": [
        6568
    ],
    "kambove": [
        6568
    ],
    "kirungwa": [
        6574
    ],
    "kihorombo": [
        6585
    ],
    "kirombo": [
        6585
    ],
    "kohelia": [
        6609
    ],
    "krievu": [
        6610,
        6612
    ],
    "kiluguru": [
        6621
    ],
    "kiruguru": [
        6621
    ],
    "kiruihi": [
        6624
    ],
    "kuce": [
        6625
    ],
    "kuche": [
        6625
    ],
    "knovtsy": [
        6630,
        6631
    ],
    "keningau lobu": [
        6632
    ],
    "kinyarwanda": [
        6635,
        6636
    ],
    "kiruwa": [
        6638
    ],
    "kirwa": [
        6638
    ],
    "kirwo": [
        6638
    ],
    "kiruwila": [
        6639
    ],
    "kihumu": [
        6640
    ],
    "ku-amba": [
        6640
    ],
    "kuamba": [
        6640
    ],
    "kwamba": [
        6640
    ],
    "kolo": [
        6644
    ],
    "kukuruba": [
        6644
    ],
    "karuwali": [
        6645
    ],
    "karawalla": [
        6645
    ],
    "karorinje": [
        6645
    ],
    "kuriwalu": [
        6645
    ],
    "kurrawulla": [
        6645
    ],
    "kisandawe": [
        6661
    ],
    "kissandaui": [
        6661
    ],
    "kisampur": [
        6672
    ],
    "kêt": [
        6685
    ],
    "kele (papua new guinea)": [
        6693
    ],
    "kisafwa": [
        6701
    ],
    "kisagala": [
        6703,
        7446
    ],
    "kisagara": [
        6703
    ],
    "kisangu": [
        6706
    ],
    "kuhane": [
        6709
    ],
    "kuahane": [
        6709
    ],
    "kwahane": [
        6709
    ],
    "kimki": [
        6710
    ],
    "kimgi": [
        6710
    ],
    "khelma": [
        6724
    ],
    "kisan": [
        8487,
        6726,
        6727
    ],
    "khatoya": [
        6726,
        6727
    ],
    "khamen padong": [
        6733
    ],
    "khamen": [
        6733
    ],
    "katang, southern": [
        6736
    ],
    "kataang rueal": [
        6736
    ],
    "katang rueal": [
        6736
    ],
    "kurdish, southern": [
        6753
    ],
    "kurdî xwarîn": [
        6753
    ],
    "kissoundi": [
        6754
    ],
    "kisuundi": [
        6754
    ],
    "kifouma": [
        6754
    ],
    "kimongo": [
        6754
    ],
    "kundi": [
        6755
    ],
    "kmrang": [
        6777
    ],
    "komkak": [
        6782
    ],
    "konkaak": [
        6782
    ],
    "kunkaahac": [
        6782
    ],
    "kunkaak": [
        6782
    ],
    "könkáak": [
        6782
    ],
    "khumyt": [
        6786
    ],
    "koyraboro": [
        6792
    ],
    "koyraboro senni": [
        6792
    ],
    "koyra senni": [
        6792
    ],
    "koyra senni songhay": [
        6792
    ],
    "koyraboro senni songhai": [
        6792
    ],
    "kokua": [
        6797
    ],
    "kipsigis": [
        6808
    ],
    "kipsiikis": [
        6808
    ],
    "kipsikiis": [
        6808
    ],
    "kipsikis": [
        6808
    ],
    "khughnani": [
        6812,
        6813,
        6814
    ],
    "khughni": [
        6812,
        6813,
        6814
    ],
    "khughnoni": [
        6812,
        6813,
        6814
    ],
    "khugnone": [
        6812,
        6813,
        6814
    ],
    "kilua": [
        6832
    ],
    "kisonde": [
        6832
    ],
    "kisoonde": [
        6832
    ],
    "kundal shahi": [
        6833
    ],
    "kundal": [
        6833
    ],
    "khieng": [
        6843
    ],
    "khyen": [
        6843
    ],
    "koluri": [
        6844
    ],
    "kishi": [
        6852
    ],
    "kildin": [
        6891
    ],
    "kildin sami": [
        6891
    ],
    "kildin sámi": [
        6891
    ],
    "kola sámi": [
        6891
    ],
    "kemi sami": [
        6894
    ],
    "kemi": [
        6894
    ],
    "kagayan": [
        6896
    ],
    "krowe": [
        6920
    ],
    "kutong": [
        6922
    ],
    "kutong gin": [
        6922
    ],
    "kolibugan": [
        6923
    ],
    "kalibugan": [
        6923
    ],
    "kolibugan subanon": [
        6923
    ],
    "kisakata": [
        6932
    ],
    "klep": [
        6933
    ],
    "kadu sholigar": [
        6943
    ],
    "kissama": [
        6966
    ],
    "kabinga’an": [
        6972
    ],
    "kolta": [
        6980,
        6981
    ],
    "koltta": [
        6980,
        6981
    ],
    "kisanga": [
        6995,
        6996
    ],
    "kwara": [
        7000,
        7001
    ],
    "kanú": [
        7004
    ],
    "kokakañú": [
        7004
    ],
    "kou": [
        7016
    ],
    "kow": [
        7016
    ],
    "kesongola": [
        7027
    ],
    "kisongo": [
        7038
    ],
    "kalebwe": [
        7039
    ],
    "kisonge": [
        7039
    ],
    "kisongi": [
        7039
    ],
    "kisongye": [
        7039
    ],
    "kanasi": [
        7040,
        8568
    ],
    "kayobe": [
        7047
    ],
    "kuyobe": [
        7047
    ],
    "kyobe": [
        7047
    ],
    "kisonjo": [
        7048
    ],
    "kitemi": [
        7048
    ],
    "kaliána": [
        7050
    ],
    "kariana": [
        7050
    ],
    "kasnapan": [
        7058
    ],
    "kelya’mok": [
        7058
    ],
    "koshal": [
        7066
    ],
    "koshali": [
        7066
    ],
    "kosli": [
        7066
    ],
    "kufr qassem sign language": [
        7087
    ],
    "kufr": [
        7087
    ],
    "kqsl": [
        7087
    ],
    "kafr qassem sign language": [
        7087
    ],
    "kafr": [
        7087
    ],
    "kafr qassim sign language": [
        7087
    ],
    "kfar qassem sign language": [
        7087
    ],
    "kfar": [
        7087
    ],
    "kfar qassim sign language": [
        7087
    ],
    "kufr qassem sign language (kqsl)": [
        7087
    ],
    "kisimbiti": [
        7130
    ],
    "kisuba": [
        7130
    ],
    "kisetla": [
        7158
    ],
    "kisettla": [
        7158
    ],
    "kaclakin": [
        7161
    ],
    "kahlakim": [
        7161
    ],
    "kajiang": [
        7165,
        7166
    ],
    "kisuku": [
        7188
    ],
    "kishubi": [
        7193
    ],
    "kisubi": [
        7193
    ],
    "kesukuma": [
        7194
    ],
    "kisukuma": [
        7194
    ],
    "kisumbwa": [
        7205
    ],
    "kisêdjê": [
        7207
    ],
    "kiranti-kõits lo": [
        7208
    ],
    "kiranti-kõits": [
        7208
    ],
    "kirati-koits": [
        7208
    ],
    "koits lo": [
        7208
    ],
    "koits": [
        7208
    ],
    "kiswahili": [
        7223,
        7224,
        7225,
        7226,
        7227,
        7230,
        7231,
        7234,
        7235
    ],
    "kisuaheli": [
        7223,
        7234,
        7235
    ],
    "kisuahili": [
        7223,
        7234,
        7235
    ],
    "kiswaheli": [
        7223,
        7234,
        7235
    ],
    "komoro": [
        7228,
        7229
    ],
    "katukina shanenawá": [
        7242
    ],
    "kaldaya": [
        7277
    ],
    "kildani": [
        7277
    ],
    "kagate": [
        7279
    ],
    "kesengele": [
        7287
    ],
    "kizaya": [
        7295
    ],
    "kenaga": [
        7301
    ],
    "kitabwa": [
        7315
    ],
    "kidal": [
        7316,
        7317
    ],
    "kasupá": [
        7328
    ],
    "kolumbiara": [
        7328
    ],
    "kaki ae": [
        7331
    ],
    "kaki": [
        7331
    ],
    "kamanidi": [
        7336
    ],
    "kor é gəəmg": [
        7336
    ],
    "kalamian tagbanwa": [
        7338,
        7339
    ],
    "kalamian": [
        7338,
        7339
    ],
    "kalamianon": [
        7338,
        7339
    ],
    "kitembo": [
        7347
    ],
    "kapin": [
        7352
    ],
    "katumene": [
        7352
    ],
    "kamindjo": [
        7363
    ],
    "kaiy": [
        7370
    ],
    "kuki-thado": [
        7378
    ],
    "kaseng": [
        7389
    ],
    "kasseng": [
        7389
    ],
    "khon dak chueng": [
        7389
    ],
    "koseng": [
        7389
    ],
    "kraseng": [
        7389
    ],
    "kasimbar": [
        7394
    ],
    "kusur-myet": [
        7396
    ],
    "kodra": [
        7401
    ],
    "krumen, tepo": [
        7412
    ],
    "krou tepo": [
        7412
    ],
    "krou": [
        7412
    ],
    "kroumen tépo": [
        7412
    ],
    "katege": [
        7415
    ],
    "keteghe": [
        7415
    ],
    "ketego": [
        7415
    ],
    "kiteso": [
        7421,
        7422
    ],
    "kadama": [
        7428
    ],
    "kuntulishi": [
        7434
    ],
    "kinayskiy": [
        7438
    ],
    "kisagalla": [
        7446
    ],
    "kisaghala": [
        7446
    ],
    "karapató": [
        7463
    ],
    "k’e": [
        7465
    ],
    "klang": [
        7468,
        7469
    ],
    "kuuk thayorre": [
        7470
    ],
    "kuuk": [
        7470,
        7943
    ],
    "kuktayor": [
        7470
    ],
    "kukudayore": [
        7470
    ],
    "kuuk thaayoore": [
        7470
    ],
    "kuuk thaayorre": [
        7470
    ],
    "ksetriya": [
        7471
    ],
    "kitharaka": [
        7475
    ],
    "kîîtharaka": [
        7475
    ],
    "kha tong luang": [
        7477
    ],
    "kochila tharu": [
        7481
    ],
    "kochila": [
        7481
    ],
    "kapawa": [
        7490
    ],
    "kitiene": [
        7503
    ],
    "kitiini": [
        7503
    ],
    "kiefo": [
        7511
    ],
    "kalee": [
        7524
    ],
    "kolorer": [
        7531
    ],
    "kooloor": [
        7531
    ],
    "kathariya": [
        7550
    ],
    "kathoriya tharu": [
        7550
    ],
    "kathoriya": [
        7550
    ],
    "khatima tharu": [
        7550
    ],
    "khatima": [
        7550
    ],
    "klingon": [
        7566,
        7567
    ],
    "kolosch": [
        7568,
        7569
    ],
    "kolosh": [
        7568,
        7569
    ],
    "kitalinga": [
        7570
    ],
    "kondo": [
        7574
    ],
    "khabe": [
        7577
    ],
    "kon doi": [
        7577
    ],
    "kon loi": [
        7577
    ],
    "khehek": [
        7583
    ],
    "katbol": [
        7588
    ],
    "karfasia": [
        7598
    ],
    "kath-bhotiya": [
        7599
    ],
    "kwamera": [
        7622
    ],
    "kitongwe": [
        7636
    ],
    "kitonga": [
        7643
    ],
    "keo": [
        7654
    ],
    "kok borok": [
        7714,
        7715,
        7662,
        7663
    ],
    "kinnauri, chhoyul": [
        7674
    ],
    "katar gambir": [
        7711
    ],
    "katar": [
        7711
    ],
    "kakbarak": [
        7714,
        7715
    ],
    "kohkborohk": [
        7714,
        7715
    ],
    "kokbarak": [
        7714,
        7715
    ],
    "kokborok": [
        7714,
        7715
    ],
    "kitshwa": [
        7731
    ],
    "kiini": [
        7746
    ],
    "k’onti’l": [
        7757
    ],
    "kantua": [
        7762
    ],
    "kenyah": [
        8226,
        8502,
        7778,
        8514
    ],
    "kitulɛ": [
        7793
    ],
    "kotule": [
        7793
    ],
    "kutule": [
        7793
    ],
    "kamberi": [
        7805
    ],
    "kitaveta": [
        7812
    ],
    "kitubeta": [
        7812
    ],
    "kitubheta": [
        7812
    ],
    "kaunak": [
        7856
    ],
    "kayapó": [
        7857
    ],
    "kokraimoro": [
        7857
    ],
    "karot": [
        7857
    ],
    "kadazan tatana": [
        7858
    ],
    "kyanga": [
        7862
    ],
    "kyangawa": [
        7862
    ],
    "kyanggana": [
        7862
    ],
    "kyangganya": [
        7862
    ],
    "kyenga": [
        7862
    ],
    "kã": [
        7862
    ],
    "kombai": [
        7868
    ],
    "komboy": [
        7868
    ],
    "koko laia": [
        7869
    ],
    "kokowara": [
        7869
    ],
    "kuku-thaypan": [
        7869
    ],
    "kua": [
        7874
    ],
    "kizhi": [
        7875
    ],
    "kök mungak": [
        7875
    ],
    "kök": [
        7875
    ],
    "kaye": [
        7877
    ],
    "k’op": [
        7880,
        7888,
        7889,
        7890,
        7891
    ],
    "kop": [
        7888
    ],
    "karawari": [
        7892
    ],
    "kuan": [
        7894
    ],
    "khouan": [
        7894
    ],
    "kouane": [
        7894
    ],
    "kubiri": [
        7899
    ],
    "kakoli": [
        7900,
        7901,
        7902
    ],
    "kaugel": [
        7900,
        7901,
        7902
    ],
    "kauil": [
        7900,
        7901,
        7902
    ],
    "kiakala": [
        7906
    ],
    "kebeirka": [
        7913
    ],
    "korara": [
        7913
    ],
    "kumus": [
        7913
    ],
    "kwanim pa": [
        7913
    ],
    "kwanim": [
        7913
    ],
    "kuku-ugbanh": [
        7921
    ],
    "kugu-ugbanh": [
        7921
    ],
    "kal": [
        7927
    ],
    "koro funtu of kafin koro": [
        7930
    ],
    "kafin": [
        7930
    ],
    "koro funtu of minna": [
        7930
    ],
    "koro funtu of shakoyi": [
        7930
    ],
    "kaburi": [
        7932
    ],
    "kandh": [
        7935
    ],
    "khond": [
        7935
    ],
    "khondo": [
        7935
    ],
    "kodu": [
        7935
    ],
    "kodulu": [
        7935
    ],
    "kuinga": [
        7935
    ],
    "kaapor sign language": [
        7940
    ],
    "kaapor": [
        7940,
        7993
    ],
    "ka’apor sign language": [
        7940
    ],
    "ka’apor": [
        7940,
        7993
    ],
    "koko yak": [
        7943
    ],
    "kuku yak": [
        7943
    ],
    "kuku": [
        7943
    ],
    "kuuk yak": [
        7943
    ],
    "katan": [
        7951
    ],
    "kattalan": [
        7951
    ],
    "kochuvelan": [
        7951
    ],
    "kimbari": [
        7957
    ],
    "koko ompindamo": [
        7959
    ],
    "kuuku-umpinthamu": [
        7959
    ],
    "kuuku-yani": [
        7960
    ],
    "kodut, north": [
        7968
    ],
    "kurnai": [
        7975
    ],
    "kanai": [
        7975
    ],
    "kunnai": [
        7975
    ],
    "kolh": [
        7976,
        7977,
        7978,
        7979
    ],
    "killi": [
        7981,
        7982,
        7983
    ],
    "kaili, unde": [
        7984
    ],
    "kacha edze": [
        7992
    ],
    "kacha ere": [
        7992
    ],
    "kaaporté": [
        7993
    ],
    "kobuka": [
        7997
    ],
    "kopuka": [
        7997
    ],
    "kurom": [
        7999
    ],
    "kwrom": [
        7999
    ],
    "kawahíb": [
        8013
    ],
    "kaobrung": [
        8016,
        8017
    ],
    "kau brung": [
        8016,
        8017
    ],
    "kulon-pazeh": [
        8030
    ],
    "kulon": [
        8030
    ],
    "kulon-pazih": [
        8030
    ],
    "kulun": [
        8030
    ],
    "kuku-uwanh": [
        8036
    ],
    "kugu-uwanh": [
        8036
    ],
    "karikkorava": [
        8045
    ],
    "kuruvikkaran": [
        8045
    ],
    "konosarola": [
        8048
    ],
    "kumbhari": [
        8049
    ],
    "koroko": [
        8055
    ],
    "koruon": [
        8055
    ],
    "keski bhil": [
        8059,
        8060
    ],
    "keski": [
        8059,
        8060
    ],
    "keli": [
        8074
    ],
    "kelʹ": [
        8074
    ],
    "kinh": [
        8078,
        8079,
        8080
    ],
    "kividunda": [
        8082
    ],
    "kivinza": [
        8086
    ],
    "kariyarra": [
        8090
    ],
    "kariara": [
        8090
    ],
    "kariera": [
        8090
    ],
    "kariyara": [
        8090
    ],
    "karriara": [
        8090
    ],
    "kujarge": [
        8091
    ],
    "kaur": [
        8092
    ],
    "ka’ur": [
        8092
    ],
    "kulisusu": [
        8093
    ],
    "kalisusu": [
        8093
    ],
    "kolensusu": [
        8093
    ],
    "kolinsusu": [
        8093
    ],
    "kamakan": [
        8094
    ],
    "kamakán": [
        8094
    ],
    "koro nulu": [
        8095
    ],
    "koro afiki": [
        8095
    ],
    "koro ija": [
        8095
    ],
    "kodeoha": [
        8096
    ],
    "kondea": [
        8096
    ],
    "kondeha": [
        8096
    ],
    "korlai portuguese creole": [
        8097,
        8098
    ],
    "korlai": [
        8097,
        8098
    ],
    "korlai creole portuguese": [
        8097,
        8098
    ],
    "kurrama": [
        8100
    ],
    "karama": [
        8100
    ],
    "korama": [
        8100
    ],
    "koro zuba": [
        8101
    ],
    "koro ganagana": [
        8101
    ],
    "koraga, mudu": [
        8107
    ],
    "kokomoloroij": [
        8121
    ],
    "kokomoloroitji": [
        8121
    ],
    "kookanoona": [
        8121
    ],
    "kiil": [
        8136
    ],
    "kyivunjo": [
        8144
    ],
    "kivunjo": [
        8144
    ],
    "kivunjo-chaga": [
        8144
    ],
    "kiwunjo": [
        8144
    ],
    "kasiui": [
        8155
    ],
    "kasui": [
        8155
    ],
    "kesui": [
        8155
    ],
    "kaninuwa": [
        8168
    ],
    "kaokao": [
        8168
    ],
    "katuena": [
        8171
    ],
    "kiwanda": [
        8179
    ],
    "kɨvwanji": [
        8180
    ],
    "kivwanji": [
        8180
    ],
    "kiwanji": [
        8180
    ],
    "kialagwa": [
        8181
    ],
    "kichase": [
        8181
    ],
    "kalasha ala": [
        8182
    ],
    "khik": [
        8183,
        8184,
        8185
    ],
    "khikwar": [
        8183,
        8184,
        8185
    ],
    "k’awa": [
        8186
    ],
    "kolkata sign language": [
        8190
    ],
    "kolkata": [
        8190
    ],
    "kariimari": [
        8201
    ],
    "kun-gait": [
        8201
    ],
    "kungait": [
        8201
    ],
    "kɨ́wí": [
        8206
    ],
    "kiunum": [
        8207
    ],
    "kamtok": [
        8212
    ],
    "kilikilana": [
        8218
    ],
    "kenyah, wahau": [
        8226
    ],
    "kulit": [
        8226
    ],
    "kayan, wahau": [
        8227
    ],
    "kowilth": [
        8243
    ],
    "kw’adza": [
        8246
    ],
    "kw'adza": [
        8246
    ],
    "kwadza": [
        8246
    ],
    "kumbaran": [
        8247
    ],
    "kusavan": [
        8247
    ],
    "kalanadi": [
        8249
    ],
    "keerray-woorroong": [
        8250
    ],
    "kunduvadi": [
        8251
    ],
    "kunbarlang": [
        8257
    ],
    "kimwani": [
        8284,
        8285
    ],
    "kayik": [
        8298
    ],
    "kuwema": [
        8304
    ],
    "kamang": [
        8313
    ],
    "kamana-kamang": [
        8313
    ],
    "kiwongo": [
        8316
    ],
    "kwasengen": [
        8319
    ],
    "kapula": [
        8323
    ],
    "karrwa": [
        8328
    ],
    "karawa": [
        8626,
        8328
    ],
    "kariwa": [
        8328
    ],
    "karrawar": [
        8328
    ],
    "korrawa": [
        8328
    ],
    "kurrawar": [
        8328
    ],
    "koko wara": [
        8338
    ],
    "kokolaia": [
        8338
    ],
    "kokowarra": [
        8338
    ],
    "kuku-wara": [
        8338
    ],
    "koyang": [
        8343,
        8344,
        8345,
        8346
    ],
    "kugu nganhcara": [
        8360
    ],
    "kugu": [
        8360,
        8538
    ],
    "kibungu": [
        8366
    ],
    "kardagur": [
        8381
    ],
    "koronubu-ba": [
        8387
    ],
    "kaimbé": [
        8395
    ],
    "kariri de massacará": [
        8395
    ],
    "kalmyk-oirat": [
        8398,
        8399
    ],
    "kalmack": [
        8398,
        8399
    ],
    "kalmuck": [
        8398,
        8399
    ],
    "kalmuk": [
        8398,
        8399
    ],
    "kalmyk": [
        8398
    ],
    "kalmytskii jazyk": [
        8398,
        8399
    ],
    "kalmytskii": [
        8398,
        8399
    ],
    "khalli": [
        8398,
        8399
    ],
    "kama-ka": [
        8400
    ],
    "karami": [
        8405
    ],
    "kamassian": [
        8406
    ],
    "katawixi": [
        8407
    ],
    "kauwera": [
        8408
    ],
    "kabera": [
        8408
    ],
    "kaowerawedj": [
        8408
    ],
    "kauwerawec": [
        8408
    ],
    "kauwerawetj": [
        8408
    ],
    "kawera": [
        8408
    ],
    "kawaiisu": [
        8410
    ],
    "kayan mahakam": [
        8411
    ],
    "kombio": [
        8418
    ],
    "kenaboi": [
        8421
    ],
    "kamberaas": [
        8424
    ],
    "kambiwá": [
        8425
    ],
    "koolaburra": [
        8426
    ],
    "kwandu": [
        8448
    ],
    "kwando": [
        8448
    ],
    "kiǁkxigwi": [
        8452
    ],
    "kloukle": [
        8452
    ],
    "kelo": [
        8453
    ],
    "kelo-beni sheko": [
        8453
    ],
    "kelo-beni": [
        8453
    ],
    "kembayan": [
        8454
    ],
    "karambai": [
        8454
    ],
    "koromu": [
        8457
    ],
    "kesawai": [
        8457
    ],
    "kesawi": [
        8457
    ],
    "keoru-ahia": [
        8459
    ],
    "keuro": [
        8459
    ],
    "keuru": [
        8459
    ],
    "ke’oru": [
        8459
    ],
    "kouri": [
        8459
    ],
    "kekoseno": [
        8463
    ],
    "kaialiwongi": [
        8465
    ],
    "kokar": [
        8465
    ],
    "koorengi": [
        8465
    ],
    "kuriny": [
        8465
    ],
    "kaingbul": [
        8466
    ],
    "kanoloo": [
        8466
    ],
    "karingbal": [
        8466
    ],
    "karingbool": [
        8466
    ],
    "karranbal": [
        8466
    ],
    "koinbal": [
        8468
    ],
    "koinjmal": [
        8468
    ],
    "kungalburra": [
        8468
    ],
    "kungmal": [
        8468
    ],
    "koosa": [
        8472,
        8473
    ],
    "khetrani": [
        8477
    ],
    "kuda": [
        8487
    ],
    "kunha": [
        8487
    ],
    "kunhar": [
        8487
    ],
    "kunhu": [
        8487
    ],
    "kunna": [
        8487
    ],
    "kunrukh": [
        8487
    ],
    "kunuk": [
        8487
    ],
    "kalkoti": [
        8492
    ],
    "kambolé": [
        8493
    ],
    "kho’ini": [
        8494
    ],
    "kho'ini": [
        8494
    ],
    "kayan, mendalam": [
        8495
    ],
    "kereho": [
        8496
    ],
    "keriau punan": [
        8496
    ],
    "keriau": [
        8496
    ],
    "khengkha": [
        8497
    ],
    "ken": [
        8497,
        9188
    ],
    "keng": [
        8497
    ],
    "kenkha": [
        8497
    ],
    "khen": [
        8497
    ],
    "khenkha": [
        8497
    ],
    "kyengkha": [
        8497
    ],
    "kagoro": [
        8498
    ],
    "kakolo": [
        8498
    ],
    "kenyan sign language": [
        8499
    ],
    "kenyan": [
        8499
    ],
    "kajali": [
        8500
    ],
    "kaco’": [
        8501
    ],
    "kachah’": [
        8501
    ],
    "kachok": [
        8501
    ],
    "kaco'": [
        8501
    ],
    "kenyah, mainstream": [
        8502
    ],
    "kayan, kayan river": [
        8503
    ],
    "kayan river kajan": [
        8503
    ],
    "kayan river kayan": [
        8503
    ],
    "kiorr": [
        8504
    ],
    "kabatei": [
        8505
    ],
    "koroni": [
        8506
    ],
    "kumbewaha": [
        8508
    ],
    "kumberaha": [
        8508
    ],
    "kantosi": [
        8509
    ],
    "kantonsi": [
        8509
    ],
    "kaamba": [
        8510
    ],
    "kikaamba": [
        8510
    ],
    "kgalagadi": [
        8511
    ],
    "kgalagarhi": [
        8511
    ],
    "kgalagari": [
        8511
    ],
    "khalagari": [
        8511
    ],
    "khalakadi": [
        8511
    ],
    "kxhalaxadi": [
        8511
    ],
    "kembra": [
        8512
    ],
    "karore": [
        8513
    ],
    "kanyay": [
        8514
    ],
    "kenja": [
        8514
    ],
    "kindjin": [
        8514
    ],
    "kinjin": [
        8514
    ],
    "kurtokha": [
        8515,
        8516
    ],
    "kurteopkha": [
        8515,
        8516
    ],
    "kurthopkha": [
        8515,
        8516
    ],
    "kurtobikha": [
        8515,
        8516
    ],
    "kurtopakha": [
        8515,
        8516
    ],
    "kurtotpikha": [
        8515,
        8516
    ],
    "kurtöp": [
        8515,
        8516
    ],
    "kürthöpka": [
        8515,
        8516
    ],
    "kamula": [
        8517
    ],
    "kimushungulu": [
        8530
    ],
    "kugu-muminh": [
        8538
    ],
    "kuku-muminh": [
        8538
    ],
    "kuku-mu’inh": [
        8545
    ],
    "kugu-mu’inh": [
        8545
    ],
    "kuku-mu'inh": [
        8545
    ],
    "kuku-mangk": [
        8546
    ],
    "kugu-mangk": [
        8546
    ],
    "kanakanabu": [
        8557
    ],
    "kanabu": [
        8557
    ],
    "kanakana fu": [
        8557
    ],
    "kanakana": [
        8557
    ],
    "kanakanavu": [
        8557
    ],
    "kuanhua": [
        8559
    ],
    "kingoni": [
        8561,
        9172,
        9173
    ],
    "kisutu": [
        8561
    ],
    "kankanay, northern": [
        8564
    ],
    "kataugnan": [
        8564
    ],
    "kangra-dogri": [
        8567
    ],
    "kanashi": [
        8568
    ],
    "kenuz": [
        8572,
        8573,
        8574
    ],
    "kenuzi": [
        8572,
        8573,
        8574
    ],
    "kenzi": [
        8572,
        8573,
        8574
    ],
    "kunuz": [
        8572,
        8573,
        8574
    ],
    "kunuz nubian": [
        8572,
        8573,
        8574
    ],
    "kunuzi": [
        8572,
        8573,
        8574
    ],
    "kokoda": [
        8576
    ],
    "kasuweri": [
        8576
    ],
    "komudago": [
        8576
    ],
    "kominimung": [
        8578
    ],
    "konminimung": [
        8578
    ],
    "kuminimu": [
        8578
    ],
    "kaingang de santa catarina": [
        8579
    ],
    "koma of daga": [
        8580
    ],
    "komo (sudan)": [
        8580,
        8581
    ],
    "konkomba": [
        8582,
        8583
    ],
    "kpankpamba": [
        8582,
        8583
    ],
    "kirirí": [
        8584
    ],
    "kirirí-xokó": [
        8584
    ],
    "kopar": [
        8585
    ],
    "korubo": [
        8586
    ],
    "kowaki": [
        8587
    ],
    "kulina pano": [
        8597
    ],
    "kulina do acre": [
        8597
    ],
    "kapinawá": [
        8600
    ],
    "karakhanid": [
        8613
    ],
    "krahô": [
        8615
    ],
    "kraô": [
        8615
    ],
    "karaboro, eastern": [
        8616
    ],
    "kai yor": [
        8616
    ],
    "kar": [
        8616
    ],
    "ker": [
        8616
    ],
    "kler": [
        8616
    ],
    "kɛ yur": [
        8616
    ],
    "kɛ": [
        8616
    ],
    "kreye": [
        8618
    ],
    "krem-ye": [
        8618
    ],
    "kren-yê": [
        8618
    ],
    "krikati-timbira": [
        8620
    ],
    "krikati-gaviao": [
        8620
    ],
    "krinkati-gaviao": [
        8620
    ],
    "krinkati-timbira": [
        8620
    ],
    "kasem": [
        8634
    ],
    "kasena": [
        8634
    ],
    "kasim": [
        8634
    ],
    "kassem": [
        8634
    ],
    "kassena": [
        8634
    ],
    "kassene": [
        8634
    ],
    "katcha-kadugli-miri": [
        8647
    ],
    "ketengban": [
        8649
    ],
    "kufel-wenga": [
        8649
    ],
    "kupel": [
        8649
    ],
    "katungal": [
        8665
    ],
    "kurumba, alu": [
        8669
    ],
    "kurumba, betta": [
        8670,
        8671,
        8672
    ],
    "kadu bhasha": [
        8670,
        8671,
        8672
    ],
    "kadu kurumba": [
        8670,
        8671,
        8672
    ],
    "kurubara bhashe": [
        8670,
        8671,
        8672
    ],
    "kurubara": [
        8670,
        8671,
        8672
    ],
    "kunigami": [
        8674
    ],
    "kurumba, jennu": [
        8675
    ],
    "kattu nayaka": [
        8675
    ],
    "kattu": [
        8675
    ],
    "kúo": [
        8680
    ],
    "koh": [
        8680
    ],
    "kuthant": [
        8683
    ],
    "khwedam": [
        8684
    ],
    "khwe": [
        8684
    ],
    "khwe-||ani": [
        8684
    ],
    "kxoe": [
        8684
    ],
    "kxoedam": [
        8684
    ],
    "kwengo": [
        8684
    ],
    "kamviri": [
        8686
    ],
    "kamdeshi": [
        8686
    ],
    "kamik": [
        8686
    ],
    "kwaza": [
        8690
    ],
    "koaya": [
        8690
    ],
    "kwegu": [
        8694
    ],
    "karakata": [
        8695
    ],
    "karrakatta": [
        8695
    ],
    "kwerba mamberamo": [
        8699
    ],
    "ke’o": [
        8703
    ],
    "ke'o": [
        8703
    ],
    "koropó": [
        8705
    ],
    "kuungkari": [
        8708
    ],
    "kwart kwart": [
        8713
    ],
    "kwart": [
        8713
    ],
    "kiyaka": [
        8722
    ],
    "kúta": [
        8723
    ],
    "kjalonke": [
        8729,
        8730
    ],
    "kakayamba": [
        8731
    ],
    "kihiau": [
        8733,
        8734
    ],
    "kihyao": [
        8733,
        8734
    ],
    "kiyao": [
        8733,
        8734
    ],
    "korchi": [
        8778
    ],
    "kurru bhasha": [
        8778
    ],
    "kurru": [
        8778
    ],
    "kurutha": [
        8778
    ],
    "karikari": [
        8781
    ],
    "kopu": [
        8785
    ],
    "köpu": [
        8785
    ],
    "kokwaiyakwa": [
        8789
    ],
    "kakarakala": [
        8795
    ],
    "kitba": [
        8799
    ],
    "kya": [
        8804
    ],
    "khlula": [
        8819
    ],
    "kap": [
        8820
    ],
    "kua-nsi": [
        8821
    ],
    "kua’ensi": [
        8821
    ],
    "kua’eshi": [
        8821
    ],
    "kathu": [
        8824
    ],
    "kuamasi": [
        8825
    ],
    "kaunga": [
        8830
    ],
    "khlaka": [
        8840
    ],
    "kimakwe": [
        8846,
        8847
    ],
    "kuseki": [
        8866
    ],
    "korok": [
        8866
    ],
    "kiyanzi": [
        8867
    ],
    "kiombi": [
        8878
    ],
    "kiyombe": [
        8878
    ],
    "kiyoombi": [
        8878
    ],
    "khapho": [
        8883
    ],
    "kok-cel": [
        8897
    ],
    "kok-wap": [
        8897
    ],
    "khyung buyang": [
        8898
    ],
    "khyung": [
        8898
    ],
    "kién": [
        8923,
        8924,
        8925,
        8926
    ],
    "konghu": [
        8923,
        8924,
        8925,
        8926
    ],
    "karkar-yuri": [
        8930
    ],
    "karkar": [
        8930
    ],
    "kechan": [
        8933
    ],
    "kwtsan": [
        8933
    ],
    "kolym": [
        8940
    ],
    "kolyma": [
        8940
    ],
    "kolyma yukaghir": [
        8940
    ],
    "kalou": [
        8945
    ],
    "koka-mungin": [
        8961
    ],
    "koko-majoen": [
        8961
    ],
    "kokomandjoen": [
        8961
    ],
    "kokomindjin": [
        8961
    ],
    "kokominjen": [
        8961
    ],
    "kokomindjan": [
        8961
    ],
    "kokomindjen": [
        8961
    ],
    "kokominjan": [
        8961
    ],
    "kebadi": [
        8975,
        8976,
        8977
    ],
    "kuyuk": [
        8975,
        8976,
        8977
    ],
    "kizaramo": [
        8979
    ],
    "kizanaki": [
        8980
    ],
    "kinga": [
        9012
    ],
    "kɨkɨnga": [
        9012
    ],
    "kikinga": [
        9012
    ],
    "kon min": [
        9015
    ],
    "kang yei": [
        9016
    ],
    "khoton": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "kau ndae": [
        9044,
        9045
    ],
    "khaau daai": [
        9044,
        9045
    ],
    "khaau": [
        9044,
        9045
    ],
    "kanyi": [
        9046
    ],
    "kau nong": [
        9047,
        9048
    ],
    "khau nong": [
        9047,
        9048
    ],
    "khau": [
        9047,
        9048
    ],
    "kauq daez": [
        9047,
        9048
    ],
    "kauq": [
        9047,
        9048
    ],
    "kauq noangz": [
        9047,
        9048
    ],
    "kélo": [
        9055
    ],
    "kizinza": [
        9056
    ],
    "kizigua": [
        9057
    ],
    "kizigula": [
        9057
    ],
    "kaimbulawa": [
        9059
    ],
    "koibal": [
        9060
    ],
    "kadu-ganaan": [
        9061
    ],
    "kantu’": [
        9061
    ],
    "kudo": [
        9061
    ],
    "koguryo": [
        9062
    ],
    "khorezmian": [
        9063
    ],
    "karankawa": [
        9064
    ],
    "kanan": [
        9065
    ],
    "kott": [
        9066
    ],
    "kaingáng, são paulo": [
        9067
    ],
    "kaingáng": [
        9067
    ],
    "kitan": [
        9069,
        9070
    ],
    "kaurna": [
        9071
    ],
    "karnuwarra": [
        9071
    ],
    "kaura": [
        9071
    ],
    "koornawarra": [
        9071
    ],
    "kurumidlanta": [
        9071
    ],
    "krevinian": [
        9072
    ],
    "khazar": [
        9073
    ],
    "kishuula": [
        9074
    ],
    "kogai": [
        9091
    ],
    "kinya-mituku": [
        9097
    ],
    "kimbo": [
        9103
    ],
    "kizande": [
        9108,
        9109
    ],
    "kara (korea)": [
        9148
    ],
    "kayapi": [
        9152
    ],
    "kayapwe": [
        9152
    ],
    "kaniran": [
        9154
    ],
    "kaskean": [
        9156
    ],
    "kumzari": [
        9176
    ],
    "komzari": [
        9176
    ],
    "komzāri": [
        9176
    ],
    "kumzai": [
        9176
    ],
    "káang thó": [
        9181
    ],
    "káang": [
        9181
    ],
    "kirdki": [
        9186,
        9187
    ],
    "kirmanjki (macrolanguage)": [
        9186,
        9187
    ],
    "ken tho": [
        9188
    ]
};
